import React, { Component } from 'react';
import Included from '../Included';
import DarkThemeNav from '../common/dark-theme-nav';
import AgGridThemeNav from '../common/ag-grid-theme-nav';

class Tables extends Component {

	  constructor(props) {
		  super(props);
	}

  componentDidMount() {
    setTimeout(() => {
      $('.theme-select').on('change', function () {
        let theme = $(this).val();
        $('.js-data-table')
          .removeClass('table--light table--dark table--blue')
          .addClass(theme);
      });
    }, 0);
  }

	  render() {
		  return (
		<section className="is-styleguide"><a className="anchor"id="tables"></a>

		<h2>Tables</h2>
		<p>We have a lot at our disposal for making very complex table construct</p>
		<DarkThemeNav anchor="tables" />

    <h3>AG Grid</h3>
    <p>CUI has now created new brand compliant <a href="/themes#AgGrid">themes</a> for AG-Grid. This will help bridge the gap if using AG-Grid within your project.</p>

    <h3>What is AG-Grid?</h3>

    <p>AG-Grid is feature rich datagrid designed for the major JavaScript Frameworks. <a href="https://www.ag-grid.com/" target="new">Find out more</a></p>

    <AgGridThemeNav anchor="AgGrid" />

    <hr />

		<h3>Formatting</h3>
		<ul>
			<li>.table--fixed - equal width columns</li>
		</ul>

		<h3>Styling</h3>
		<ul>
			<li>.table--cells - bordered cells</li>
			<li>.table--rows - bordered rows</li>
			<li>.table--columns - bordered columns</li>
			<li>.table--hover - adds hover styling on rows</li>
			<li>.table--striped - adds zebra striping to rows</li>
		</ul>

		<h3>Spacing</h3>

		<ul>
			<li><code className="inline">.table--compact</code> &mdash; smallest padding</li>
			<li><code className="inline">.table--cosy</code> &mdash; middle padding</li>
			<li><code className="inline">.table--comfy</code> &mdash; wide padding</li>
			<li><code className="inline">.table--colossal</code> &mdash; most padding</li>
		</ul>

    <div className="push-half--ends">
      <p><strong>Compact</strong> table styling has the least padding. Use <code className="inline">.table--compact</code></p>
      <table className="table table--cells table--compact">
        <thead><tr><th>Lorem</th><th>Ipsum</th><th>Dolor</th><th>Sit</th></tr></thead>
        <tbody><tr><td>Lorem</td><td>Ipsum</td><td>Dolor</td><td>Sit</td></tr></tbody>
      </table>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<table class="table table--cells table--compact">
  <thead><tr><th>Lorem</th><th>Ipsum</th><th>Dolor</th><th>Sit</th></tr></thead>
  <tbody><tr><td>Lorem</td><td>Ipsum</td><td>Dolor</td><td>Sit</td></tr></tbody>
</table>`}</code></pre>
    </div>

    <div className="push-half--ends">
      <p><strong>Cosy</strong> table styling is still quite compact, but with slightly more padding. Use <code className="inline">.table--cosy</code></p>
      <table className="table table--cells table--cosy">
        <thead><tr><th>Lorem</th><th>Ipsum</th><th>Dolor</th><th>Sit</th></tr></thead>
        <tbody><tr><td>Lorem</td><td>Ipsum</td><td>Dolor</td><td>Sit</td></tr></tbody>
      </table>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<table class="table table--cells table--cosy">
  <thead><tr><th>Lorem</th><th>Ipsum</th><th>Dolor</th><th>Sit</th></tr></thead>
  <tbody><tr><td>Lorem</td><td>Ipsum</td><td>Dolor</td><td>Sit</td></tr></tbody>
</table>`}</code></pre>
    </div>

    <div className="push-half--ends">
      <p><strong>Comfy</strong> table styling uses wide padding. Use <code className="inline">.table--comfy</code></p>
      <table className="table table--cells table--comfy">
        <thead><tr><th>Lorem</th><th>Ipsum</th><th>Dolor</th><th>Sit</th></tr></thead>
        <tbody><tr><td>Lorem</td><td>Ipsum</td><td>Dolor</td><td>Sit</td></tr></tbody>
      </table>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<table class="table table--cells table--comfy">
  <thead><tr><th>Lorem</th><th>Ipsum</th><th>Dolor</th><th>Sit</th></tr></thead>
  <tbody><tr><td>Lorem</td><td>Ipsum</td><td>Dolor</td><td>Sit</td></tr></tbody>
</table>`}</code></pre>
    </div>

    <div className="push-half--ends">
      <p><strong>Colossal</strong> table styling has the most padding. Use <code className="inline">.table--colossal</code></p>
      <table className="table table--cells table--colossal">
        <thead><tr><th>Lorem</th><th>Ipsum</th><th>Dolor</th><th>Sit</th></tr></thead>
        <tbody><tr><td>Lorem</td><td>Ipsum</td><td>Dolor</td><td>Sit</td></tr></tbody>
      </table>
      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<table class="table table--cells table--colossal">
  <thead><tr><th>Lorem</th><th>Ipsum</th><th>Dolor</th><th>Sit</th></tr></thead>
  <tbody><tr><td>Lorem</td><td>Ipsum</td><td>Dolor</td><td>Sit</td></tr></tbody>
</table>`}</code></pre>
    </div>

		<h3>Head Alignment</h3>
		<ul>
			<li>.table-head--top-align - top align</li>
			<li>.table-head--middle-align - middle align</li>
			<li>.table-head--bottom-align - bottom align</li>
		</ul>

		<h3>Cell Alignment</h3>
		<p>By default they will align in the middle.</p>
		<table className="table table--cells table--compact">
			<thead>
				<tr>
					<th>Lorem</th>
					<th>Ipsum</th>
					<th>Dolor</th>
					<th>Sit</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Sit</td>
					<td>Dolor <br/>Dolor <br/>Dolor</td>
					<td className="text--center">03.788</td>
					<td>Lorem</td>
				</tr>
			</tbody>
		</table>

		<p>.table--top-align - Align at the top of the cell</p>
		<table className="table table--cells table--compact table--top-align">
			<thead>
				<tr>
					<th>Lorem</th>
					<th>Ipsum</th>
					<th>Dolor</th>
					<th>Sit</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Sit</td>
					<td>Dolor <br/>Dolor <br/>Dolor</td>
					<td className="text--center">03.788</td>
					<td>Lorem</td>
				</tr>
			</tbody>
		</table>
		<p>.table--bottom-align - Align at the bottom of the cell</p>
		<table className="table table--cells table--compact table--bottom-align">
			<thead>
				<tr>
					<th>Lorem</th>
					<th>Ipsum</th>
					<th>Dolor</th>
					<th>Sit</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Sit</td>
					<td>Dolor <br/>Dolor <br/>Dolor</td>
					<td className="text--center">03.788</td>
					<td>Lorem</td>
				</tr>
			</tbody>
		</table>

		<br/>
		<h3>Theming</h3>
		<h4>Light themed table</h4>
		<p>
			To apply the light theme to a table, simply add the class <code>.table--light</code> in addition to the <code>.table</code> class (as shown in the example below).
		</p>

		<table className="table table--light table--comfy table--hover table--striped table--responsive js-table--responsive">
			<thead>
				<tr>
					<th>Lorem</th>
					<th>Ipsum</th>
					<th>Dolor</th>
					<th>Sit</th>
					<th>Amet</th>
					<th>Consectetur</th>
					<th>Afdipisicing</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<th scope="row">
						<a href="">Sit</a>
					</th>
					<td>Dolor</td>
					<td className="text--center">03.788</td>
					<td>Lorem</td>
					<td>Amet</td>
					<td>Consectetur</td>
					<td>Afdipisicing</td>
					<td className="text--right">
						<i className="fa fa-trash delete-row"></i>
					</td>
				</tr>
				<tr>
					<th scope="row">
						<a href="">Sit</a>
					</th>
					<td>Dolor</td>
					<td className="text--center">32.210</td>
					<td>Lorem</td>
					<td>Amet</td>
					<td>Consectetur</td>
					<td>Afdipisicing</td>
					<td className="text--right"><i className="fa fa-trash delete-row"></i></td>
				</tr>
				<tr>
					<th scope="row">
						<a href="">Sit</a>
					</th>
					<td>Dolor</td>
					<td className="text--center">47.797</td>
					<td>Lorem</td>
					<td>Amet</td>
					<td>Consectetur</td>
					<td>Afdipisicing</td>
					<td className="text--right"><i className="fa fa-trash delete-row"></i></td>
				</tr>
				<tr>
					<th scope="row">
						<a href="">Sit</a>
					</th>
					<td>Dolor</td>
					<td className="text--center">09.640</td>
					<td>Lorem</td>
					<td>Amet</td>
					<td>Consectetur</td>
					<td>Afdipisicing</td>
					<td className="text--right"><i className="fa fa-trash delete-row"></i></td>
				</tr>
				<tr>
					<th scope="row">
						<a href="">Sit</a>
					</th>
					<td>Dolor</td>
					<td className="text--center">12.117</td>
					<td>Lorem</td>
					<td>Amet</td>
					<td>Consectetur</td>
					<td>Afdipisicing</td>
					<td className="text--right"><i className="fa fa-trash delete-row"></i></td>
				</tr>
			</tbody>
		</table>

		<div className="modal delete-row-modal modal--is-small">
			<div className="modal__inner">
				<header className="modal__header" aria-labelledby="modal__title">
				<h1 className="modal__title">Delete selected row</h1>
				<button className="modal__close btn btn--transparent js-modal-close" aria-label="close">
					<i className="icon-cme-card-close icon--medium"></i>
				</button>
				</header>
				<div className="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">
				<p className="modal__description">Are you sure you wish to delete this row?</p>
				</div>
				<footer className="modal__footer">
					<button type="button" className="modal__cancel btn btn--secondary js-modal-close delete-row-negative">No</button>
					<button type="button" className="modal__confirm btn js-modal-positive delete-row-positive">Yes</button>
				</footer>
			</div>
		</div>

		<button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
		<pre className="hide-code"><code className="language-html">{`
<table class="table table--light table--comfy table--hover table--striped table--responsive js-table--responsive">
<thead>
	<tr>
		<th>Lorem</th>
		<th>Ipsum</th>
		<th>Dolor</th>
		<th>Sit</th>
		<th>Amet</th>
		<th>Consectetur</th>
		<th>Afdipisicing</th>
		<th></th>
	</tr>
</thead>
<tbody>
	<tr>
		<th scope="row">
			<a href="">Sit</a>
		</th>
		<td>Dolor</td>
		<td class="text--center">03.788</td>
		<td>Lorem</td>
		<td>Amet</td>
		<td>Consectetur</td>
		<td>Afdipisicing</td>
		<td class="text--right"><i class="fa fa-trash delete-row"></i></td>
	</tr>
	<tr>
		<th scope="row">
			<a href="">Sit</a>
		</th>
		<td>Dolor</td>
		<td class="text--center">32.210</td>
		<td>Lorem</td>
		<td>Amet</td>
		<td>Consectetur</td>
		<td>Afdipisicing</td>
		<td class="text--right"><i class="fa fa-trash delete-row"></i></td>
	</tr>
	<tr>
		<th scope="row">
			<a href="">Sit</a>
		</th>
		<td>Dolor</td>
		<td class="text--center">47.797</td>
		<td>Lorem</td>
		<td>Amet</td>
		<td>Consectetur</td>
		<td>Afdipisicing</td>
		<td class="text--right"><i class="fa fa-trash delete-row"></i></td>
	</tr>
	<tr>
		<th scope="row">
			<a href="">Sit</a>
		</th>
		<td>Dolor</td>
		<td class="text--center">09.640</td>
		<td>Lorem</td>
		<td>Amet</td>
		<td>Consectetur</td>
		<td>Afdipisicing</td>
		<td class="text--right"><i class="fa fa-trash delete-row"></i></td>
	</tr>
	<tr>
		<th scope="row">
			<a href="">Sit</a>
		</th>
		<td>Dolor</td>
		<td class="text--center">12.117</td>
		<td>Lorem</td>
		<td>Amet</td>
		<td>Consectetur</td>
		<td>Afdipisicing</td>
		<td class="text--right"><i class="fa fa-trash delete-row"></i></td>
	</tr>
</tbody>
</table>`}</code></pre>
		<br/>
		<p>.table__cell--highlight - light themed table column</p>
		<table className="table table--comfy table--hover table--striped table--light table--responsive js-table--responsive">
			<thead>
				<tr>
					<th>Lorem</th>
					<th>Ipsum</th>
					<th>Dolor</th>
					<th>Sit</th>
					<th>Amet</th>
					<th>Consectetur</th>
					<th>Afdipisicing</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<th scope="row" className="table__cell--highlight"><a href="">Sit</a></th>
					<td>Dolor</td>
					<td className="text--center">03.788</td>
					<td>Lorem</td>
					<td>Amet</td>
					<td>Consectetur</td>
					<td>Afdipisicing</td>
				</tr>
				<tr>
					<th scope="row" className="table__cell--highlight"><a href="">Sit</a></th>
					<td>Dolor</td>
					<td className="text--center">32.210</td>
					<td>Lorem</td>
					<td>Amet</td>
					<td>Consectetur</td>
					<td>Afdipisicing</td>
				</tr>
			</tbody>
		</table>

		<button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
		<pre className="hide-code"><code className="language-html">{`<table class="table table--comfy table--hover table--striped table--light table--responsive js-table--responsive">
		<thead>
			<tr>
				<th>Lorem</th>
				<th>Ipsum</th>
				<th>Dolor</th>
				<th>Sit</th>
				<th>Amet</th>
				<th>Consectetur</th>
				<th>Afdipisicing</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<th scope="row" class="table__cell--highlight"><a href="">Sit</a></th>
				<td>Dolor</td>
				<td class="text--center">03.788</td>
				<td>Lorem</td>
				<td>Amet</td>
				<td>Consectetur</td>
				<td>Afdipisicing</td>
			</tr>
			<tr>
				<th scope="row" class="table__cell--highlight"><a href="">Sit</a></th>
				<td>Dolor</td>
				<td class="text--center">32.210</td>
				<td>Lorem</td>
				<td>Amet</td>
				<td>Consectetur</td>
				<td>Afdipisicing</td>
			</tr>
		</tbody>
		</table>`}</code></pre>

		<br/>
		<h4>Blue themed table</h4>
		<p>
			To apply the blue theme to a table, simply add the class <code>.table--blue</code> in addition to the <code>.table</code> class (as shown in the example below).
		</p>
		<div className="callout">
			Previously, the <code>.table--blue</code> class shipped with column and row dividers by
			default. Following the new additive approach for table styling you can achieve
			the same style by applying the <code>.table--cells</code> class to the table.
		</div>
		<br/>

		<table className="table table--blue table--comfy table--rows table--hover table--striped text-scale-xs flush--bottom table--responsive js-table--responsive">
			<thead>
				<tr>
          <th>Product</th>
          <th>Code</th>
          <th>Last</th>
          <th>Change</th>
          <th>Chart</th>
          <th>Open</th>
          <th>High</th>
          <th>Low</th>
          <th>Globex Vol</th>
				</tr>
			</thead>
			<tbody>
				<tr>
          <td><a className="weight--bold" href="#">Corn Futures</a></td>
          <td className="text--center">ZCH7</td>
          <td className="text--right">369'0</td>
          <td className="text--right">+1'0</td>
          <td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
          <td className="text--right">367'4</td>
          <td className="text--right">367'4</td>
          <td className="text--right">367'4</td>
          <td className="text--right">68,284</td>
				</tr>
				<tr>
          <td><a className="weight--bold" href="#">Soybean Futures</a></td>
          <td className="text--center">ZCH7</td>
          <td className="text--right">1036'4</td>
          <td className="text--right">+1'0</td>
          <td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
          <td className="text--right">1037'2</td>
          <td className="text--right">1037'2</td>
          <td className="text--right">1037'2</td>
          <td className="text--right">48,346</td>
				</tr>
				<tr>
          <td><a className="weight--bold" href="#">Soybean Oil Futures</a></td>
          <td className="text--center">ZCH7</td>
          <td className="text--right">34.29</td>
          <td className="text--right">+0.02</td>
          <td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
          <td className="text--right">34.31</td>
          <td className="text--right">34.31</td>
          <td className="text--right">34.31</td>
          <td className="text--right">23,054</td>
				</tr>
			</tbody>
		</table>
		<ul className="link-list">
			<li className="link-list__item"><a href="">Link One</a></li>
			<li className="link-list__item"><a href="">Link Two</a></li>
			<li className="link-list__item"><a href="">Link Three</a></li>
		</ul>


		<button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
		<pre className="hide-code"><code className="language-html">{`
<table class="table table--blue table--comfy table--cells table--hover table--striped text-scale-xs flush--bottom table--responsive js-table--responsive">
	<thead>
		<tr>
			<th>Product</th>
			<th>Code</th>
			<th>Last</th>
			<th>Change</th>
			<th>Chart</th>
			<th>Open</th>
			<th>High</th>
			<th>Low</th>
			<th>Globex Vol</th>
		</tr>
	</thead>
	<tbody>
	  <tr>
	    <td><a class="weight--bold" href="#">Corn Futures</a></td>
	    <td class="text--center">ZCH7</td>
	    <td class="text--right">369'0</td>
	    <td class="text--right">+1'0</td>
	    <td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>
	    <td class="text--right">367'4</td>
	    <td class="text--right">367'4</td>
	    <td class="text--right">367'4</td>
	    <td class="text--right">68,284</td>
	  </tr>
	  <tr>
	    <td><a class="weight--bold" href="#">Soybean Futures</a></td>
	    <td class="text--center">ZCH7</td>
	    <td class="text--right">1036'4</td>
	    <td class="text--right">+1'0</td>
	    <td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>
	    <td class="text--right">1037'2</td>
	    <td class="text--right">1037'2</td>
	    <td class="text--right">1037'2</td>
	    <td class="text--right">48,346</td>
	  </tr>
	  <tr>
	    <td><a class="weight--bold" href="#">Soybean Oil Futures</a></td>
	    <td class="text--center">ZCH7</td>
	    <td class="text--right">34.29</td>
	    <td class="text--right">+0.02</td>
	    <td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>
	    <td class="text--right">34.31</td>
	    <td class="text--right">34.31</td>
	    <td class="text--right">34.31</td>
	    <td class="text--right">23,054</td>
	  </tr>
	</tbody>
</table>
<ul class="link-list">
	<li class="link-list__item"><a href="">Link One</a></li>
	<li class="link-list__item"><a href="">Link Two</a></li>
	<li class="link-list__item"><a href="">Link Three</a></li>
</ul>
`}</code></pre>
    <br/>
		<h3>Grouped columns</h3>
		<p>
			Grouped columns are a clear way to visually gather relevant columns into
			one overall category. They can be 2 or 3 levels deep, but no larger than 3.
			The very top row (overall grouped category) will always be a lighter
			colour than the other row(s). Individual columns are separated by divider
			line to clearly identify them. Currently the grouped columns are only
			available for use with blue themed tables.
		</p>
		<p>
			Grouped columns are not responsive. When viewed on a small screen, the whole table should scroll.
		</p>
		<p>
			To apply grouped column styling to your blue themed table, simply add
			the <code>.table--grouped-columns</code> class to your existing table class list.
		</p>

		<div className="scroll-container-x">
			<table className="table table--comfy table--blue table--rows table--grouped-columns">
				<thead>
					<tr>
						<th colSpan="4">First column grouping</th>
						<th rowSpan="2">&nbsp;</th>
						<th colSpan="6">First column grouping</th>
					</tr>
					<tr>
						<th colSpan="2">Second column grouping</th>
						<th colSpan="2">Second column grouping</th>
						<th colSpan="2">Second column grouping</th>
						<th colSpan="2">Second column grouping</th>
						<th colSpan="2">Second column grouping</th>
					</tr>
					<tr>
						<th>Column</th>
						<th>Column</th>
						<th>Column</th>
						<th>Column</th>
						<th>Column</th>
						<th>Column</th>
						<th>Column</th>
						<th>Column</th>
						<th>Column</th>
						<th>Column</th>
						<th>Column</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>Content</td>
						<td>Content</td>
						<td>Content</td>
						<td>Content</td>
						<td>Content</td>
						<td>Content</td>
						<td>Content</td>
						<td>Content</td>
						<td>Content</td>
						<td>Content</td>
						<td>Content</td>
					</tr>
					<tr>
						<td>Content</td>
						<td>Content</td>
						<td>Content</td>
						<td>Content</td>
						<td>Content</td>
						<td>Content</td>
						<td>Content</td>
						<td>Content</td>
						<td>Content</td>
						<td>Content</td>
						<td>Content</td>
					</tr>
				</tbody>
			</table>
		</div>

		<button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
		<pre className="hide-code">
			<code className="language-html">
				{`
	<div class="scroll-container-x">
		<table class="table table--comfy table--blue table--cells table--grouped-columns">
			<thead>
				<tr>
					<th colspan="4">First column grouping</th>
					<th rowspan="2">&nbsp;</th>
					<th colspan="6">First column grouping</th>
				</tr>
				<tr>
					<th colspan="2">Second column grouping</th>
					<th colspan="2">Second column grouping</th>
					<th colspan="2">Second column grouping</th>
					<th colspan="2">Second column grouping</th>
					<th colspan="2">Second column grouping</th>
				</tr>
				<tr>
					<th>Column</th>
					<th>Column</th>
					<th>Column</th>
					<th>Column</th>
					<th>Column</th>
					<th>Column</th>
					<th>Column</th>
					<th>Column</th>
					<th>Column</th>
					<th>Column</th>
					<th>Column</th>
				</tr>
			</thead>
			<tbody>
				<td>Content</td>
				<td>Content</td>
				<td>Content</td>
				<td>Content</td>
				<td>Content</td>
				<td>Content</td>
				<td>Content</td>
				<td>Content</td>
				<td>Content</td>
				<td>Content</td>
				<td>Content</td>
			</tbody>
		</table>
	</div>
				`}
			</code>
		</pre>

		<br/>
		<h3>Grouped rows</h3>

		<p className="callout">
			<strong>Note:</strong> Only the styles for grouped rows are being provided at this time. Functionality will come in a future release.
		</p>

		<p>
			Grouped rows should be used in cases where one or several rows of data are aggregated to a single identifier row. There are 2 use cases for grouped rows at present: Row hierarchy and Row history
		</p>
		<h4>Row hierarchy</h4>
		<p>Row hierarchy displays the grouped rows in an indented visual order which can be navigated using plus/minus icons. The hierarchy can be up to 3 levels deep. A solid plus/minus icon should be used in the identifier row (level 1). A lite plus/minus icon should be used for the indented row (level 2). For level 3 data rows are displayed under a dark grey line.</p>

		<div className="scroll-container-x">
		<table className="table table--rows table--border table--blue table--comfy text--left">
			<thead>
				<tr>
					<th>&nbsp;</th>
					<th>One</th>
					<th>Two</th>
					<th>Three</th>
					<th>Four</th>
					<th>Five</th>
					<th>Six</th>
					<th>Seven</th>
				</tr>
			</thead>
			<tbody className="row-group row-group--open">
				<tr className="row-group__key-row">
					<td className="row-expand">
						<button className="row-expand__trigger row-expand__trigger--open"></button>
					</td>
					<th scope="row">
						<a href="">MAINLINK</a>
					</th>
					<td>Two</td>
					<td>Three</td>
					<td>Four</td>
					<td>Five</td>
					<td>Six</td>
					<td>Seven</td>
				</tr>
				<tr className="row-group__parent-row row-group__parent-row--active" data-row-id="123">
					<td rowSpan="5">&nbsp;</td>
					<td className="row-expand row-expand--secondary">
						<button className="row-expand__trigger row-expand__trigger--open"></button>
					</td>
					<td>Two</td>
					<td>Three</td>
					<td>Four</td>
					<td>Five</td>
					<td>Six</td>
					<td>Seven</td>
				</tr>
				<tr className="row-group__child-row row-group__child-row--show" data-row-parent="123">
					<td rowSpan="2">&nbsp;</td>
					<td>Two</td>
					<td>Three</td>
					<td>Four</td>
					<td>Five</td>
					<td>Six</td>
					<td>Seven</td>
				</tr>
				<tr className="row-group__child-row row-group__child-row--show" data-row-parent="123">
					<td>Two</td>
					<td>Three</td>
					<td>Four</td>
					<td>Five</td>
					<td>Six</td>
					<td>Seven</td>
				</tr>
				<tr className="row-group__parent-row" data-row-id="456">
					<td className="row-expand row-expand--secondary">
						<button className="js-rowExpand row-expand__trigger"></button>
					</td>
					<td>Two</td>
					<td>Three</td>
					<td>Four</td>
					<td>Five</td>
					<td>Six</td>
					<td>Seven</td>
				</tr>
				<tr className="row-group__child-row" data-row-parent="456">
					<td>&nbsp;</td>
					<td>Two</td>
					<td>Three</td>
					<td>Four</td>
					<td>Five</td>
					<td>Six</td>
					<td>Seven</td>
				</tr>
			</tbody>
			<tbody className="row-group">
				<tr className="row-group__key-row">
					<td className="row-expand">
						<button className="row-expand__trigger row-expand__trigger--open"></button>
					</td>
					<th scope="row">
						<a href="">MAINLINK</a>
					</th>
					<td>Two</td>
					<td>Three</td>
					<td>Four</td>
					<td>Five</td>
					<td>Six</td>
					<td>Seven</td>
				</tr>
			</tbody>
		</table>
	</div>

		<button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
		<pre className="hide-code"><code className="language-html">{`<div class="scroll-container-x"><table class="table table--rows table--border table--blue table--comfy text--left">
		  <thead>
		    <tr>
		      <th>&nbsp;</th>
		      <th>One</th>
		      <th>Two</th>
		      <th>Three</th>
		      <th>Four</th>
		      <th>Five</th>
		      <th>Six</th>
		      <th>Seven</th>
		    </tr>
		  </thead>
		  <tbody class="row-group row-group--open">
		    <tr class="row-group__key-row">
		      <td class="row-expand">
		        <button class="row-expand__trigger row-expand__trigger--open"></button>
		      </td>
		      <th scope="row">
		        <a href="">MAINLINK</a>
		      </th>
		      <td>Two</td>
		      <td>Three</td>
		      <td>Four</td>
		      <td>Five</td>
		      <td>Six</td>
		      <td>Seven</td>
		    </tr>
		    <tr class="row-group__parent-row row-group__parent-row--active" data-row-id="123">
		      <td rowspan="5">&nbsp;</td>
		      <td class="row-expand row-expand--secondary">
		        <button class="row-expand__trigger row-expand__trigger--open"></button>
		      </td>
		      <td>Two</td>
		      <td>Three</td>
		      <td>Four</td>
		      <td>Five</td>
		      <td>Six</td>
		      <td>Seven</td>
		    </tr>
		    <tr class="row-group__child-row row-group__child-row--show" data-row-parent="123">
		      <td rowspan="2">&nbsp;</td>
		      <td>Two</td>
		      <td>Three</td>
		      <td>Four</td>
		      <td>Five</td>
		      <td>Six</td>
		      <td>Seven</td>
		    </tr>
		    <tr class="row-group__child-row row-group__child-row--show" data-row-parent="123">
		      <td>Two</td>
		      <td>Three</td>
		      <td>Four</td>
		      <td>Five</td>
		      <td>Six</td>
		      <td>Seven</td>
		    </tr>
		    <tr class="row-group__parent-row" data-row-id="456">
		      <td class="row-expand row-expand--secondary">
		        <button class="js-rowExpand row-expand__trigger"></button>
		      </td>
		      <td>Two</td>
		      <td>Three</td>
		      <td>Four</td>
		      <td>Five</td>
		      <td>Six</td>
		      <td>Seven</td>
		    </tr>
		    <tr class="row-group__child-row" data-row-parent="456">
		      <td>&nbsp;</td>
		      <td>Two</td>
		      <td>Three</td>
		      <td>Four</td>
		      <td>Five</td>
		      <td>Six</td>
		      <td>Seven</td>
		    </tr>
		  </tbody>
		  <tbody class="row-group">
		    <tr class="row-group__key-row">
		      <td class="row-expand">
		        <button class="row-expand__trigger row-expand__trigger--open"></button>
		      </td>
		      <th scope="row">
		        <a href="">MAINLINK</a>
		      </th>
		      <td>Two</td>
		      <td>Three</td>
		      <td>Four</td>
		      <td>Five</td>
		      <td>Six</td>
		      <td>Seven</td>
		    </tr>
		  </tbody>
		</table></div>`}</code></pre>

		<br/>
		<h4>Row history</h4>
		<p>Row history should be used when showing the previous states of a single row. This is different to the hierarchy format as there is no indentation or visual order of the data rows. This format might be used when showing the depth of the book for example. A single solid plus/minus icon per row is used to open/close the row history. This icon can be placed beside the data relevant to trigger a display of the rows history e.g. ID</p>

		<div className="scroll-container-x">
		<table className="table table--rows table--border table--blue table--comfy text--left">
			<thead>
				<tr>
					<th>One</th>
					<th>Two</th>
					<th>&nbsp;</th>
					<th>Three</th>
					<th>Four</th>
					<th>Five</th>
					<th>Six</th>
					<th>Seven</th>
				</tr>
			</thead>
			<tbody className="row-group row-group--history row-group--open">
				<tr className="row-group__key-row">
					<th scope="row">
						<a href="">One</a>
					</th>
					<td>Two</td>
					<td className="row-expand">
						<button className="row-expand__trigger row-expand__trigger--open"></button>
					</td>
					<td>Three</td>
					<td>Four</td>
					<td>Five</td>
					<td>Six</td>
					<td>Seven</td>
				</tr>
				<tr className="row-group__child-row">
					<td colSpan="3" rowSpan="2">&nbsp;</td>
					<td>Three</td>
					<td>Four</td>
					<td>Five</td>
					<td>Six</td>
					<td>Seven</td>
				</tr>
				<tr className="row-group__child-row">
					<td>Three</td>
					<td>Four</td>
					<td>Five</td>
					<td>Six</td>
					<td>Seven</td>
				</tr>
			</tbody>
			<tbody className="row-group row-group--history">
				<tr className="row-group__key-row">
					<th scope="row">
						<a href="">One</a>
					</th>
					<td>Two</td>
					<td className="row-expand">
						<button className="js-rowExpand row-expand__trigger"></button>
					</td>
					<td>Three</td>
					<td>Four</td>
					<td>Five</td>
					<td>Six</td>
					<td>Seven</td>
				</tr>
				<tr className="row-group__child-row">
					<td colSpan="3">&nbsp;</td>
					<td>Three</td>
					<td>Four</td>
					<td>Five</td>
					<td>Six</td>
					<td>Seven</td>
				</tr>
			</tbody>
		</table>
	</div>

		<button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
		<pre className="hide-code"><code className="language-html">{`<div class="scroll-container-x"><table class="table table--rows table--border table--blue table--comfy text--left">
		  <thead>
		    <tr>
		      <th>One</th>
		      <th>Two</th>
		      <th>&nbsp;</th>
		      <th>Three</th>
		      <th>Four</th>
		      <th>Five</th>
		      <th>Six</th>
		      <th>Seven</th>
		    </tr>
		  </thead>
		  <tbody class="row-group row-group--history row-group--open">
		    <tr class="row-group__key-row">
		      <th scope="row">
		        <a href="">One</a>
		      </th>
		      <td>Two</td>
		      <td class="row-expand">
		        <button class="row-expand__trigger row-expand__trigger--open"></button>
		      </td>
		      <td>Three</td>
		      <td>Four</td>
		      <td>Five</td>
		      <td>Six</td>
		      <td>Seven</td>
		    </tr>
		    <tr class="row-group__child-row">
		      <td colspan="3" rowspan="2">&nbsp;</td>
		      <td>Three</td>
		      <td>Four</td>
		      <td>Five</td>
		      <td>Six</td>
		      <td>Seven</td>
		    </tr>
		    <tr class="row-group__child-row">
		      <td>Three</td>
		      <td>Four</td>
		      <td>Five</td>
		      <td>Six</td>
		      <td>Seven</td>
		    </tr>
		  </tbody>
		  <tbody class="row-group row-group--history">
		    <tr class="row-group__key-row">
		      <th scope="row">
		        <a href="">One</a>
		      </th>
		      <td>Two</td>
		      <td class="row-expand">
		        <button class="js-rowExpand row-expand__trigger"></button>
		      </td>
		      <td>Three</td>
		      <td>Four</td>
		      <td>Five</td>
		      <td>Six</td>
		      <td>Seven</td>
		    </tr>
		    <tr class="row-group__child-row">
		      <td colspan="3">&nbsp;</td>
		      <td>Three</td>
		      <td>Four</td>
		      <td>Five</td>
		      <td>Six</td>
		      <td>Seven</td>
		    </tr>
		  </tbody>
		</table></div>`}</code></pre>

		<br/>
		<h3>Sorting</h3>
    <p>
			Giving users the ability to sort data based on a column is a common
			feature when using tables to display data. The <code>.table-sort</code> class
			and modifiers provide styling (no functionality) to indicate that a column can be
			sorted and, if it is being sorted, which direction it is being sorted in.
		</p>

		<table className="table table--comfy text--left">
			<thead>
				<tr>
					<th>Class</th>
					<th>Type</th>
					<th>Description</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td><code>.table-sort</code></td>
					<td>Block</td>
					<td>Applies styling to indicate that a column can be sorted</td>
				</tr>
				<tr>
					<td><code>.table-sort--asc</code></td>
					<td>Modifier</td>
					<td>Applies styling to indicate that a column is being sorted in an ascending direction</td>
				</tr>
				<tr>
					<td><code>.table-sort--desc</code></td>
					<td>Modifier</td>
					<td>Applies styling to indicate that a column is being sorted in a descending direction</td>
				</tr>
			</tbody>
		</table>

		<div className="scroll-container-x">
		<table className="table table--comfy table--hover table--striped table--blue js-data-table">
			<thead>
				<tr>
          <th>
						<button type="button" className="table-sort">Product</button>
					</th>
          <th>
						<button type="button" className="table-sort">Code</button>
					</th>
          <th>Last</th>
          <th>
						<button type="button" className="table-sort table-sort--asc">Change</button>
					</th>
          <th>Chart</th>
          <th>Open</th>
          <th>
						<button type="button" className="table-sort table-sort--desc">High</button>
					</th>
          <th>Low</th>
          <th>Globex Vol</th>
				</tr>
			</thead>
			<tbody>
				<tr>
          <td><a className="weight--bold" href="#">Corn Futures</a></td>
          <td className="text--center">ZCH7</td>
          <td className="text--right">369'0</td>
          <td className="text--right">+1'0</td>
          <td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
          <td className="text--right">367'4</td>
          <td className="text--right">367'4</td>
          <td className="text--right">367'4</td>
          <td className="text--right">68,284</td>
				</tr>
				<tr>
          <td><a className="weight--bold" href="#">Soybean Futures</a></td>
          <td className="text--center">ZCH7</td>
          <td className="text--right">1036'4</td>
          <td className="text--right">+1'0</td>
          <td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
          <td className="text--right">1037'2</td>
          <td className="text--right">1037'2</td>
          <td className="text--right">1037'2</td>
          <td className="text--right">48,346</td>
				</tr>
				<tr>
          <td><a className="weight--bold" href="#">Soybean Oil Futures</a></td>
          <td className="text--center">ZCH7</td>
          <td className="text--right">34.29</td>
          <td className="text--right">+0.02</td>
          <td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
          <td className="text--right">34.31</td>
          <td className="text--right">34.31</td>
          <td className="text--right">34.31</td>
          <td className="text--right">23,054</td>
				</tr>
			</tbody>
		</table>
		</div>

    <select className="theme-select float--left">
      <option value="">Default Theme</option>
      <option value="table--light">Light Theme</option>
      <option value="table--blue" selected>Blue Theme</option>
    </select>

    <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
<pre className="hide-code"><code className="language-html">{`<div class="scroll-container-x"><table class="table table--comfy table--hover table--striped table--blue">
	<thead>
		<tr>
			<th>
				<button type="button" class="table-sort">Product</button>
			</th>
			<th>
				<button type="button" class="table-sort">Code</button>
			</th>
			<th>Last</th>
			<th>
				<button type="button" class="table-sort table-sort--asc">Change</button>
			</th>
			<th>Chart</th>
			<th>Open</th>
			<th>
				<button type="button" class="table-sort table-sort--desc">High</button>
			</th>
			<th>Low</th>
			<th>Globex Vol</th>
		</tr>
	</thead>
  <tbody>
      ...
  </tbody>
</table></div>`}</code></pre>

		<br/>

		<h3>Categories</h3>
		<p>
			Categories can be added to tables when groups of rows need to be broken up. Several categories can exist within a single table.
		</p>

		<div className="scroll-container-x">
		<table className="table table--blue table--comfy table--striped table--rows table--hover">
			<thead>
				<tr>
          <th>Product</th>
          <th>Code</th>
          <th>Last</th>
          <th>Change</th>
          <th>Chart</th>
          <th>Open</th>
          <th>High</th>
          <th>Low</th>
          <th>Globex Vol</th>
				</tr>
			</thead>
			<tbody className="table-category">
				<tr className="table-category__head">
					<td colSpan="9">
						<div className="display--flex">
							<div className="table-category__title">
								Category heading
							</div>
						</div>
					</td>
				</tr>
				<tr>
          <td><a className="weight--bold" href="#">Corn Futures</a></td>
          <td className="text--center">ZCH7</td>
          <td className="text--right">369'0</td>
          <td className="text--right">+1'0</td>
          <td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
          <td className="text--right">367'4</td>
          <td className="text--right">367'4</td>
          <td className="text--right">367'4</td>
          <td className="text--right">68,284</td>
				</tr>
				<tr>
          <td><a className="weight--bold" href="#">Soybean Futures</a></td>
          <td className="text--center">ZCH7</td>
          <td className="text--right">1036'4</td>
          <td className="text--right">+1'0</td>
          <td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
          <td className="text--right">1037'2</td>
          <td className="text--right">1037'2</td>
          <td className="text--right">1037'2</td>
          <td className="text--right">48,346</td>
				</tr>
			</tbody>
			<tbody className="table-category">
				<tr className="table-category__head">
					<td colSpan="9">
						<div className="display--flex">
							<div className="table-category__title">
								Category heading
							</div>
						</div>
					</td>
				</tr>
				<tr>
          <td><a className="weight--bold" href="#">Soybean Oil Futures</a></td>
          <td className="text--center">ZCH7</td>
          <td className="text--right">34.29</td>
          <td className="text--right">+0.02</td>
          <td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
          <td className="text--right">34.31</td>
          <td className="text--right">34.31</td>
          <td className="text--right">34.31</td>
          <td className="text--right">23,054</td>
				</tr>
			</tbody>
		</table>
		</div>

		<button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
<pre className="hide-code"><code className="language-html">{`<div class="scroll-container-x"><table class="table table--blue table--comfy table--striped table--rows table--hover">
	<thead>
		<tr>
			<th>Product</th>
			<th>Code</th>
			<th>Last</th>
			<th>Change</th>
			<th>Chart</th>
			<th>Open</th>
			<th>High</th>
			<th>Low</th>
			<th>Globex Vol</th>
		</tr>
	</thead>
	<tbody class="table-category">
		<tr class="table-category__head">
			<td colspan="9">
				<div class="display--flex">
					<div class="table-category__title">
						Category heading
					</div>
				</div>
			</td>
		</tr>
		<tr>
			<td><a class="weight--bold" href="#">Corn Futures</a></td>
			<td class="text--center">ZCH7</td>
			<td class="text--right">369'0</td>
			<td class="text--right">+1'0</td>
			<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>
			<td class="text--right">367'4</td>
			<td class="text--right">367'4</td>
			<td class="text--right">367'4</td>
			<td class="text--right">68,284</td>
		</tr>
		<tr>
			<td><a class="weight--bold" href="#">Soybean Futures</a></td>
			<td class="text--center">ZCH7</td>
			<td class="text--right">1036'4</td>
			<td class="text--right">+1'0</td>
			<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>
			<td class="text--right">1037'2</td>
			<td class="text--right">1037'2</td>
			<td class="text--right">1037'2</td>
			<td class="text--right">48,346</td>
		</tr>
	</tbody>
	<tbody class="table-category">
		<tr class="table-category__head">
			<td colspan="9">
				<div class="display--flex">
					<div class="table-category__title">
						Category heading
					</div>
				</div>
			</td>
		</tr>
		<tr>
			<td><a class="weight--bold" href="#">Soybean Oil Futures</a></td>
			<td class="text--center">ZCH7</td>
			<td class="text--right">34.29</td>
			<td class="text--right">+0.02</td>
			<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>
			<td class="text--right">34.31</td>
			<td class="text--right">34.31</td>
			<td class="text--right">34.31</td>
			<td class="text--right">23,054</td>
		</tr>
	</tbody>
</table></div>`}</code></pre>

<br/>

		<h3>Selected Rows</h3>
		<p>
			Rows can be shown to be selected by applying a class of <code>.table--tr-selected</code> on the desired row.
		</p>

		<div className="scroll-container-x">
		<table className="table table--blue table--comfy table--striped table--rows table--hover">
			<thead>
				<tr>
          <th>Product</th>
          <th>Code</th>
          <th>Last</th>
          <th>Change</th>
          <th>Chart</th>
          <th>Open</th>
          <th>High</th>
          <th>Low</th>
          <th>Globex Vol</th>
				</tr>
			</thead>
			<tbody className="table-category">
				<tr className="table-category__head">
					<td colSpan="9">
						<div className="display--flex">
							<div className="table-category__title">
								Category heading
							</div>
						</div>
					</td>
				</tr>
				<tr>
          <td><a className="weight--bold" href="#">Corn Futures</a></td>
          <td className="text--center">ZCH7</td>
          <td className="text--right">369'0</td>
          <td className="text--right">+1'0</td>
          <td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
          <td className="text--right">367'4</td>
          <td className="text--right">367'4</td>
          <td className="text--right">367'4</td>
          <td className="text--right">68,284</td>
				</tr>
				<tr className="table--tr-selected">
          <td><a className="weight--bold" href="#">Soybean Futures</a></td>
          <td className="text--center">ZCH7</td>
          <td className="text--right">1036'4</td>
          <td className="text--right">+1'0</td>
          <td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
          <td className="text--right">1037'2</td>
          <td className="text--right">1037'2</td>
          <td className="text--right">1037'2</td>
          <td className="text--right">48,346</td>
				</tr>
			</tbody>
			<tbody className="table-category">
				<tr className="table-category__head">
					<td colSpan="9">
						<div className="display--flex">
							<div className="table-category__title">
								Category heading
							</div>
						</div>
					</td>
				</tr>
				<tr>
          <td><a className="weight--bold" href="#">Soybean Oil Futures</a></td>
          <td className="text--center">ZCH7</td>
          <td className="text--right">34.29</td>
          <td className="text--right">+0.02</td>
          <td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
          <td className="text--right">34.31</td>
          <td className="text--right">34.31</td>
          <td className="text--right">34.31</td>
          <td className="text--right">23,054</td>
				</tr>
			</tbody>
		</table>
		</div>

		<button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
<pre className="hide-code"><code className="language-html">{`<div class="scroll-container-x"><table class="table table--blue table--comfy table--striped table--rows table--hover">
	<thead>
		<tr>
			<th>Product</th>
			<th>Code</th>
			<th>Last</th>
			<th>Change</th>
			<th>Chart</th>
			<th>Open</th>
			<th>High</th>
			<th>Low</th>
			<th>Globex Vol</th>
		</tr>
	</thead>
	<tbody class="table-category">
		<tr class="table-category__head">
			<td colspan="9">
				<div class="display--flex">
					<div class="table-category__title">
						Category heading
					</div>
				</div>
			</td>
		</tr>
		<tr>
			<td><a class="weight--bold" href="#">Corn Futures</a></td>
			<td class="text--center">ZCH7</td>
			<td class="text--right">369'0</td>
			<td class="text--right">+1'0</td>
			<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>
			<td class="text--right">367'4</td>
			<td class="text--right">367'4</td>
			<td class="text--right">367'4</td>
			<td class="text--right">68,284</td>
		</tr>
		<tr class="table--tr-selected">
			<td><a class="weight--bold" href="#">Soybean Futures</a></td>
			<td class="text--center">ZCH7</td>
			<td class="text--right">1036'4</td>
			<td class="text--right">+1'0</td>
			<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>
			<td class="text--right">1037'2</td>
			<td class="text--right">1037'2</td>
			<td class="text--right">1037'2</td>
			<td class="text--right">48,346</td>
		</tr>
	</tbody>
	<tbody class="table-category">
		<tr class="table-category__head">
			<td colspan="9">
				<div class="display--flex">
					<div class="table-category__title">
						Category heading
					</div>
				</div>
			</td>
		</tr>
		<tr>
			<td><a class="weight--bold" href="#">Soybean Oil Futures</a></td>
			<td class="text--center">ZCH7</td>
			<td class="text--right">34.29</td>
			<td class="text--right">+0.02</td>
			<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>
			<td class="text--right">34.31</td>
			<td class="text--right">34.31</td>
			<td class="text--right">34.31</td>
			<td class="text--right">23,054</td>
		</tr>
	</tbody>
</table></div>`}</code></pre>

		<br/>

		<h3>Responsive</h3>

    <div className="callout"><b>Note</b>: For full table scrolling, you need to wrap the table in a div which has the <code>scroll-container-x</code> class.</div>
    <br/>
		<p>If you have too much data for mobile view to handle, there is a couple of options</p>
		<p>For content data that the user does not need to directly compare, the following non-javascript solution is preferred</p>
		<p>Resize your browser to see the functionality.</p>
		<p>.table--collapse - Pure css enabled responsiveness</p>

		<table className="table table--blue table--comfy table--hover table--striped table--rows table--collapse">
			<thead>
				<tr>
					<th>Movie Title</th>
					<th>Genre</th>
					<th>Year</th>
					<th>Gross</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td data-th="Movie Title">Star Wars</td>
					<td data-th="Genre">Adventure, Sci-fi</td>
					<td data-th="Year">1977</td>
					<td data-th="Gross">$460,935,665</td>
				</tr>
				<tr>
					<td data-th="Movie Title">Howard The Duck</td>
					<td data-th="Genre">"Comedy"</td>
					<td data-th="Year">1986</td>
					<td data-th="Gross">$16,295,774</td>
				</tr>
				<tr>
					<td data-th="Movie Title">American Graffiti</td>
					<td data-th="Genre">Comedy, Drama</td>
					<td data-th="Year">1973</td>
					<td data-th="Gross">$115,000,000</td>
				</tr>
			</tbody>
		</table>
			<button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
			<pre className="hide-code"><code className="language-html">{`<table class="table table--blue table--comfy table--hover table--striped table--rows table--collapse">
<thead>
	<tr>
		<th>Movie Title</th>
		<th>Genre</th>
		<th>Year</th>
		<th>Gross</th>
	</tr>
</thead>
<tbody>
	<tr>
		<td data-th="Movie Title">Star Wars</td>
		<td data-th="Genre">Adventure, Sci-fi</td>
		<td data-th="Year">1977</td>
		<td data-th="Gross">$460,935,665</td>
	</tr>
	<tr>
		<td data-th="Movie Title">Howard The Duck</td>
		<td data-th="Genre">"Comedy"</td>
		<td data-th="Year">1986</td>
		<td data-th="Gross">$16,295,774</td>
	</tr>
	<tr>
		<td data-th="Movie Title">American Graffiti</td>
		<td data-th="Genre">Comedy, Drama</td>
		<td data-th="Year">1973</td>
		<td data-th="Gross">$115,000,000</td>
	</tr>
</tbody>
</table>`}</code></pre>

		<br/>
		<p>For tabular data that the user needs to compare directly the following behaviour is preferred - the library will break the table to enable a fixed first column and horizontal scrolling to aid viewing context.</p>
		<p>Resize your browser to see the functionality.</p>
		<p>.table--responsive .js-table--responsive - Javascript enabled responsiveness</p>

		<select className="size-select">
			<option value="">Select a resolution</option>
			<option value="482">480px (xs)</option>
			<option value="770">768px (sm)</option>
			<option value="994">992px (md)</option>
			<option value="1202">1200px (lg)</option>
		</select>
		<br/><br/>
		<div className="iframe-container" style={{ 'height': '280px' }}>
			<iframe seamless srcDoc={`
				<html>
					<head>
						<link rel="stylesheet" type="text/css" href="css/commonUI.css">
					</head>
					<body>
						<div class="grid">
							<div class="grid__col-12">
								<table class="table table--blue table--comfy table--hover table--striped table--rows table--responsive js-table--responsive">
							<thead>
								<tr>
									<th>Lorem</th>
									<th>Ipsum</th>
									<th>Dolor</th>
									<th>Sit</th>
									<th>Lorem</th>
									<th>Ipsum</th>
									<th>Dolor</th>
									<th>Sit</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Sit</td>
									<td>Dolor</td>
									<td class="text--center">03.788</td>
									<td>Lorem</td>
									<td>Sit</td>
									<td>Dolor</td>
									<td class="text--center">03.788</td>
									<td>Lorem</td>
								</tr>
								<tr>
									<td>Sit</td>
									<td>Dolor</td>
									<td class="text--center">32.210</td>
									<td>Lorem</td>
									<td>Sit</td>
									<td>Dolor</td>
									<td class="text--center">32.210</td>
									<td>Lorem</td>
								</tr>
								<tr>
									<td>Sit</td>
									<td>Dolor</td>
									<td class="text--center">47.797</td>
									<td>Lorem</td>
									<td>Sit</td>
									<td>Dolor</td>
									<td class="text--center">47.797</td>
									<td>Lorem</td>
								</tr>
								<tr>
									<td>Sit</td>
									<td>Dolor</td>
									<td class="text--center">09.640</td>
									<td>Lorem</td>
									<td>Sit</td>
									<td>Dolor</td>
									<td class="text--center">09.640</td>
									<td>Lorem</td>
								</tr>
								<tr>
									<td>Sit</td>
									<td>Dolor</td>
									<td class="text--center">12.117</td>
									<td>Lorem</td>
									<td>Sit</td>
									<td>Dolor</td>
									<td class="text--center">12.117</td>
									<td>Lorem</td>
								</tr>

							</tbody>
						</table>
						</div>
						</div>
						<script type="text/javascript" src="js/commonUI.js"></script>
						<script>
							function init() {
								commonUI.initializeTable();
							}
							window.onload = init;
						</script>
					</body>
				</html>
			`}></iframe>
		</div>

		<button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
		<pre className="hide-code"><code className="language-html">{`<table class="table table--blue table--comfy table--hover table--striped table--rows table--responsive js-table--responsive text-body-xs">
	<thead>
		<tr>
			<th>Lorem</th>
			<th>Ipsum</th>
			<th>Dolor</th>
			<th>Sit</th>
			<th>Lorem</th>
			<th>Ipsum</th>
			<th>Dolor</th>
			<th>Sit</th>
		</tr>
	</thead>
	<tbody>
		<tr>
			<td>Sit</td>
			<td>Dolor</td>
			<td class="text--center">03.788</td>
			<td>Lorem</td>
			<td>Sit</td>
			<td>Dolor</td>
			<td class="text--center">03.788</td>
			<td>Lorem</td>
		</tr>
		<tr>
			<td>Sit</td>
			<td>Dolor</td>
			<td class="text--center">32.210</td>
			<td>Lorem</td>
			<td>Sit</td>
			<td>Dolor</td>
			<td class="text--center">32.210</td>
			<td>Lorem</td>
		</tr>
		<tr>
			<td>Sit</td>
			<td>Dolor</td>
			<td class="text--center">47.797</td>
			<td>Lorem</td>
			<td>Sit</td>
			<td>Dolor</td>
			<td class="text--center">47.797</td>
			<td>Lorem</td>
		</tr>
		<tr>
			<td>Sit</td>
			<td>Dolor</td>
			<td class="text--center">09.640</td>
			<td>Lorem</td>
			<td>Sit</td>
			<td>Dolor</td>
			<td class="text--center">09.640</td>
			<td>Lorem</td>
		</tr>
		<tr>
			<td>Sit</td>
			<td>Dolor</td>
			<td class="text--center">12.117</td>
			<td>Lorem</td>
			<td>Sit</td>
			<td>Dolor</td>
			<td class="text--center">12.117</td>
			<td>Lorem</td>
		</tr>

	</tbody>
</table>`}</code></pre>

<pre><code className="language-javascript">{`// Using default classes shown in snippet.
// The library looks for the class 'js-table--responsive' by default.
commonUI.initializeTable();

// You can have multiple tables on the page, they will all be initialised

// Using custom selectors
commonUI.initializeTable({
  selector: '.special-table'
});`}</code></pre>
		<br/><br/>
		<h3>Table Detail View</h3>
		<p>The table detail view will instantiate a secondary view when entering any breakpoint below the small Common UI breakpoint.
		Columns assigned as priority will appear on the primary view of table. Each row will have a chevron to the right of the row. Once this icon is selected the view will change to a detailed view where all data in the row (including the priority data) will be listed.</p>

		<p>To assign what column gets shown at which particular breakpoint, you can use the following pattern: <code>table--detail--show-['breakpoint']</code> where 'breakpoint' is the CommonUI breakpoint name.</p>
		<p>Find a list of available breakpoints <a href="#breakpoints">here</a>.</p>
		<p>Examples: <code>table--detail--show-xs-and-up table--detail--show-sm-and-up</code>.</p>

		<div style={{ 'height': '450px', 'overflowX': 'hidden' }}>
			<div className="table--detail--container js-table--detail">
				<div className="grid height--100">
					<div className="position--relative grid__col-12 height--100">
						<table className="table table--blue table--comfy table--hover table--striped table--rows table--detail">
							<thead>
								<tr>
									<th className="table--detail--show-xs-only table--detail--show-xs-and-up">Client Order ID</th>
									<th className="table--detail--show-md-and-up">Fill ID</th>
									<th className="table--detail--show-md-and-up">Status</th>
									<th className="table--detail--show-xs-and-up">Fill Time</th>
									<th className="table--detail--show-xs-and-up">Tag 50</th>
									<th className="table--detail--show-lg-and-up">Fill Qty</th>
									<th className="table--detail--show-xs-only table--detail--show-xs-and-up">Contract</th>
									<th className="table--detail--show-sm-and-up">Session ID</th>
									<th className="table--detail--show-sm-and-up">B/S</th>
									<th className="table--detail--show-lg-and-up">Amount</th>
									<th className="table--detail--show-lg-and-up">Fill Price</th>
									<th className="table--detail--show-lg-and-up">Order Price</th>
									<th className="table--detail--disclose hide--lg-and-up"></th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i className="fa fa-angle-double-right"></i></td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i className="fa fa-angle-double-right"></i></td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i className="fa fa-angle-double-right"></i></td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i className="fa fa-angle-double-right"></i></td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i className="fa fa-angle-double-right"></i></td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i className="fa fa-angle-double-right"></i></td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i className="fa fa-angle-double-right"></i></td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i className="fa fa-angle-double-right"></i></td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i className="fa fa-angle-double-right"></i></td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i className="fa fa-angle-double-right"></i></td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i className="fa fa-angle-double-right"></i></td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i className="fa fa-angle-double-right"></i></td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i className="fa fa-angle-double-right"></i></td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i className="fa fa-angle-double-right"></i></td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i className="fa fa-angle-double-right"></i></td>
								</tr>
							</tbody>
						</table>
						<div className="table--detail__secondary--view js-table-secondary-view hide--lg-and-up">
							<div className="table--detail__secondary--view__container">
								<header className="table--detail__secondary--view__header">
									<button className="btn btn--transparent table--detail__secondary--view__header__action js-table-secondary-view--dismiss soft-half"><i className="fa fa-angle-double-left"></i></button>
									<h3 className="table--detail__secondary--view__header__title flush">Detail View</h3>
								</header>
								<section className="table--detail__secondary--view__container__content">
									<table className="table table--detail__secondary--view-table push-half--top">
										<tbody>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Client Order ID</td>
												<td className="table--detail__secondary--view__table-value text--left">ACP1529</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Fill ID</td>
												<td className="table--detail__secondary--view__table-value text--left">88123:M:49753</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Status</td>
												<td className="table--detail__secondary--view__table-value text--left">Filled</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Fill Time</td>
												<td className="table--detail__secondary--view__table-value text--left">2018-06-22 07:53:47</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Tag 50</td>
												<td className="table--detail__secondary--view__table-value text--left">4027</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Fill Qty</td>
												<td className="table--detail__secondary--view__table-value text--left">9</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Contract</td>
												<td className="table--detail__secondary--view__table-value text--left">CAUM9 C0775</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Session ID</td>
												<td className="table--detail__secondary--view__table-value text--left">AZT</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">B/S</td>
												<td className="table--detail__secondary--view__table-value text--left">BUY</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Amount</td>
												<td className="table--detail__secondary--view__table-value text--left">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Fill Price</td>
												<td className="table--detail__secondary--view__table-value text--left">10028.0</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Order Price</td>
												<td className="table--detail__secondary--view__table-value text--left">10028.0</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Client Order ID</td>
												<td className="table--detail__secondary--view__table-value text--left">ACP1529</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Fill ID</td>
												<td className="table--detail__secondary--view__table-value text--left">88123:M:49753</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Status</td>
												<td className="table--detail__secondary--view__table-value text--left">Filled</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Fill Time</td>
												<td className="table--detail__secondary--view__table-value text--left">2018-06-22 07:53:47</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Tag 50</td>
												<td className="table--detail__secondary--view__table-value text--left">4027</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Fill Qty</td>
												<td className="table--detail__secondary--view__table-value text--left">9</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Contract</td>
												<td className="table--detail__secondary--view__table-value text--left">CAUM9 C0775</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Session ID</td>
												<td className="table--detail__secondary--view__table-value text--left">AZT</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">B/S</td>
												<td className="table--detail__secondary--view__table-value text--left">BUY</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Amount</td>
												<td className="table--detail__secondary--view__table-value text--left">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Fill Price</td>
												<td className="table--detail__secondary--view__table-value text--left">10028.0</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Order Price</td>
												<td className="table--detail__secondary--view__table-value text--left">10028.0</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Client Order ID</td>
												<td className="table--detail__secondary--view__table-value text--left">ACP1529</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Fill ID</td>
												<td className="table--detail__secondary--view__table-value text--left">88123:M:49753</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Status</td>
												<td className="table--detail__secondary--view__table-value text--left">Filled</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Fill Time</td>
												<td className="table--detail__secondary--view__table-value text--left">2018-06-22 07:53:47</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Tag 50</td>
												<td className="table--detail__secondary--view__table-value text--left">4027</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Fill Qty</td>
												<td className="table--detail__secondary--view__table-value text--left">9</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Contract</td>
												<td className="table--detail__secondary--view__table-value text--left">CAUM9 C0775</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Session ID</td>
												<td className="table--detail__secondary--view__table-value text--left">AZT</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">B/S</td>
												<td className="table--detail__secondary--view__table-value text--left">BUY</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Amount</td>
												<td className="table--detail__secondary--view__table-value text--left">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Fill Price</td>
												<td className="table--detail__secondary--view__table-value text--left">10028.0</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Order Price</td>
												<td className="table--detail__secondary--view__table-value text--left">10028.0</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Client Order ID</td>
												<td className="table--detail__secondary--view__table-value text--left">ACP1529</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Fill ID</td>
												<td className="table--detail__secondary--view__table-value text--left">88123:M:49753</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Status</td>
												<td className="table--detail__secondary--view__table-value text--left">Filled</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Fill Time</td>
												<td className="table--detail__secondary--view__table-value text--left">2018-06-22 07:53:47</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Tag 50</td>
												<td className="table--detail__secondary--view__table-value text--left">4027</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Fill Qty</td>
												<td className="table--detail__secondary--view__table-value text--left">9</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Contract</td>
												<td className="table--detail__secondary--view__table-value text--left">CAUM9 C0775</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Session ID</td>
												<td className="table--detail__secondary--view__table-value text--left">AZT</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">B/S</td>
												<td className="table--detail__secondary--view__table-value text--left">BUY</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Amount</td>
												<td className="table--detail__secondary--view__table-value text--left">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Fill Price</td>
												<td className="table--detail__secondary--view__table-value text--left">10028.0</td>
											</tr>
											<tr>
												<td className="table--detail__secondary--view__table-key text--right">Order Price</td>
												<td className="table--detail__secondary--view__table-value text--left">10028.0</td>
											</tr>
										</tbody>
									</table>
								</section>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<br/>
		<p>In the provided example, you can see certain columns dropping in and out, some remain throughout the breakpoints and some only appear at the upper breakpoints.
		These are all configurable using the aforementioned classes. When the disclosure chevron is viewable is also configurable.</p>

		<select className="size-select">
			<option value="">Select a resolution</option>
			<option value="482">480px (xs)</option>
			<option value="770">768px (sm)</option>
			<option value="994">992px (md)</option>
			<option value="1202">1200px (lg)</option>
		</select>
		<br/><br/>
		<div className="iframe-container" style={{ 'height': '685px' }}>
			<iframe seamless srcDoc={`
				<html class="height--100">
					<head>
						<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
						<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
						<link rel="stylesheet" type="text/css" href="css/commonUI.css">
					</head>
					<body class="height--100">
						<div class="table--detail--container js-table--detail">
							<div class="grid height--100">
								<div class="position--relative grid__col-12 height--100">
									<table class="table table--blue table--comfy table--hover table--striped table--rows table--detail">
										<thead>
											<tr>
												<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Client Order ID</th>
												<th class="table--detail--show-md-and-up">Fill ID</th>
												<th class="table--detail--show-md-and-up">Status</th>
												<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Fill Time</th>
												<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Tag 50</th>
												<th class="table--detail--show-lg-and-up">Fill Qty</th>
												<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Contract</th>
												<th class="table--detail--show-sm-and-up">Session ID</th>
												<th class="table--detail--show-sm-and-up">B/S</th>
												<th class="table--detail--show-lg-and-up">Amount</th>
												<th class="table--detail--show-lg-and-up">Fill Price</th>
												<th class="table--detail--show-lg-and-up">Order Price</th>
												<th class="table--detail--disclose hide--lg-and-up"></th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
											</tr>
										</tbody>
									</table>
									<div class="table--detail__secondary--view js-table-secondary-view hide--lg-and-up">
										<div class="table--detail__secondary--view__container">
											<header class="table--detail__secondary--view__header">
												<button class="btn btn--transparent table--detail__secondary--view__header__action js-table-secondary-view--dismiss soft-half"><i class="fa fa-angle-double-left"></i></button>
												<h3 class="table--detail__secondary--view__header__title flush">Detail View</h3>
											</header>
											<section class="table--detail__secondary--view__container__content">
												<table class="table table--detail__secondary--view-table push-half--top">
													<tbody>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Client Order ID</td>
															<td class="table--detail__secondary--view__table-value text--left">ACP1529</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Fill ID</td>
															<td class="table--detail__secondary--view__table-value text--left">88123:M:49753</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Status</td>
															<td class="table--detail__secondary--view__table-value text--left">Filled</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Fill Time</td>
															<td class="table--detail__secondary--view__table-value text--left">2018-06-22 07:53:47</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Tag 50</td>
															<td class="table--detail__secondary--view__table-value text--left">4027</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Fill Qty</td>
															<td class="table--detail__secondary--view__table-value text--left">9</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Contract</td>
															<td class="table--detail__secondary--view__table-value text--left">CAUM9 C0775</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Session ID</td>
															<td class="table--detail__secondary--view__table-value text--left">AZT</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">B/S</td>
															<td class="table--detail__secondary--view__table-value text--left">BUY</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Amount</td>
															<td class="table--detail__secondary--view__table-value text--left">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Fill Price</td>
															<td class="table--detail__secondary--view__table-value text--left">10028.0</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Order Price</td>
															<td class="table--detail__secondary--view__table-value text--left">10028.0</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Client Order ID</td>
															<td class="table--detail__secondary--view__table-value text--left">ACP1529</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Fill ID</td>
															<td class="table--detail__secondary--view__table-value text--left">88123:M:49753</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Status</td>
															<td class="table--detail__secondary--view__table-value text--left">Filled</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Fill Time</td>
															<td class="table--detail__secondary--view__table-value text--left">2018-06-22 07:53:47</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Tag 50</td>
															<td class="table--detail__secondary--view__table-value text--left">4027</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Fill Qty</td>
															<td class="table--detail__secondary--view__table-value text--left">9</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Contract</td>
															<td class="table--detail__secondary--view__table-value text--left">CAUM9 C0775</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Session ID</td>
															<td class="table--detail__secondary--view__table-value text--left">AZT</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">B/S</td>
															<td class="table--detail__secondary--view__table-value text--left">BUY</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Amount</td>
															<td class="table--detail__secondary--view__table-value text--left">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Fill Price</td>
															<td class="table--detail__secondary--view__table-value text--left">10028.0</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Order Price</td>
															<td class="table--detail__secondary--view__table-value text--left">10028.0</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Client Order ID</td>
															<td class="table--detail__secondary--view__table-value text--left">ACP1529</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Fill ID</td>
															<td class="table--detail__secondary--view__table-value text--left">88123:M:49753</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Status</td>
															<td class="table--detail__secondary--view__table-value text--left">Filled</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Fill Time</td>
															<td class="table--detail__secondary--view__table-value text--left">2018-06-22 07:53:47</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Tag 50</td>
															<td class="table--detail__secondary--view__table-value text--left">4027</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Fill Qty</td>
															<td class="table--detail__secondary--view__table-value text--left">9</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Contract</td>
															<td class="table--detail__secondary--view__table-value text--left">CAUM9 C0775</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Session ID</td>
															<td class="table--detail__secondary--view__table-value text--left">AZT</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">B/S</td>
															<td class="table--detail__secondary--view__table-value text--left">BUY</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Amount</td>
															<td class="table--detail__secondary--view__table-value text--left">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Fill Price</td>
															<td class="table--detail__secondary--view__table-value text--left">10028.0</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Order Price</td>
															<td class="table--detail__secondary--view__table-value text--left">10028.0</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Client Order ID</td>
															<td class="table--detail__secondary--view__table-value text--left">ACP1529</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Fill ID</td>
															<td class="table--detail__secondary--view__table-value text--left">88123:M:49753</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Status</td>
															<td class="table--detail__secondary--view__table-value text--left">Filled</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Fill Time</td>
															<td class="table--detail__secondary--view__table-value text--left">2018-06-22 07:53:47</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Tag 50</td>
															<td class="table--detail__secondary--view__table-value text--left">4027</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Fill Qty</td>
															<td class="table--detail__secondary--view__table-value text--left">9</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Contract</td>
															<td class="table--detail__secondary--view__table-value text--left">CAUM9 C0775</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Session ID</td>
															<td class="table--detail__secondary--view__table-value text--left">AZT</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">B/S</td>
															<td class="table--detail__secondary--view__table-value text--left">BUY</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Amount</td>
															<td class="table--detail__secondary--view__table-value text--left">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Fill Price</td>
															<td class="table--detail__secondary--view__table-value text--left">10028.0</td>
														</tr>
														<tr>
															<td class="table--detail__secondary--view__table-key text--right">Order Price</td>
															<td class="table--detail__secondary--view__table-value text--left">10028.0</td>
														</tr>
													</tbody>
												</table>
											</section>
										</div>
									</div>
								</div>
							</div>
						</div>
						<script type="text/javascript" src="js/commonUI.js"></script>
						<script>
							function init() {
								commonUI.initializeTable({
									selector: '.js-table--detail',
									detailViewType: 'detailedView',
									detailViewSelector: '.js-table-secondary-view',
									detailViewDismissSelector: '.js-table-secondary-view--dismiss'
								});
							}
							window.onload = init;
						</script>
					</body>
				</html>
			`}></iframe>
		</div>
		<br/>
		<p>To enable this functionality, you can instantiate the table like this:</p>
		<pre><code className="language-javascript">{`commonUI.initializeTable({
	selector: '.js-table--detail',
	detailViewType: 'detailedView',
	detailViewSelector: '.js-table-secondary-view',
	detailViewDismissSelector: '.js-table-secondary-view--dismiss'
});`}</code></pre>
		<br/>
		<button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
		<pre className="hide-code"><code className="language-html">{`<div class="table--detail--container js-table--detail">
	<div class="grid height--100">
		<div class="position--relative grid__col-12 height--100">
			<table class="table table--blue table--comfy table--hover table--striped table--rows table--detail">
				<thead>
					<tr>
						<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Client Order ID</th>
						<th class="table--detail--show-md-and-up">Fill ID</th>
						<th class="table--detail--show-md-and-up">Status</th>
						<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Fill Time</th>
						<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Tag 50</th>
						<th class="table--detail--show-lg-and-up">Fill Qty</th>
						<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Contract</th>
						<th class="table--detail--show-lg-and-up">Session ID</th>
						<th class="table--detail--show-sm-and-up">B/S</th>
						<th class="table--detail--show-sm-and-up">Amount</th>
						<th class="table--detail--show-lg-and-up">Fill Price</th>
						<th class="table--detail--show-lg-and-up">Order Price</th>
						<th class="table--detail--disclose hide--lg-and-up"></th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
						<td class="table--detail--show-md-and-up">88123:M:49753</td>
						<td class="table--detail--show-md-and-up">Filled</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
						<td class="table--detail--show-lg-and-up">9</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
						<td class="table--detail--show-lg-and-up">AZT</td>
						<td class="table--detail--show-sm-and-up">BUY</td>
						<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
					</tr>
					<tr>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
						<td class="table--detail--show-md-and-up">88123:M:49753</td>
						<td class="table--detail--show-md-and-up">Filled</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
						<td class="table--detail--show-lg-and-up">9</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
						<td class="table--detail--show-lg-and-up">AZT</td>
						<td class="table--detail--show-sm-and-up">BUY</td>
						<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
					</tr>
					<tr>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
						<td class="table--detail--show-md-and-up">88123:M:49753</td>
						<td class="table--detail--show-md-and-up">Filled</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
						<td class="table--detail--show-lg-and-up">9</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
						<td class="table--detail--show-lg-and-up">AZT</td>
						<td class="table--detail--show-sm-and-up">BUY</td>
						<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
					</tr>
					<tr>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
						<td class="table--detail--show-md-and-up">88123:M:49753</td>
						<td class="table--detail--show-md-and-up">Filled</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
						<td class="table--detail--show-lg-and-up">9</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
						<td class="table--detail--show-lg-and-up">AZT</td>
						<td class="table--detail--show-sm-and-up">BUY</td>
						<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
					</tr>
					<tr>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
						<td class="table--detail--show-md-and-up">88123:M:49753</td>
						<td class="table--detail--show-md-and-up">Filled</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
						<td class="table--detail--show-lg-and-up">9</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
						<td class="table--detail--show-lg-and-up">AZT</td>
						<td class="table--detail--show-sm-and-up">BUY</td>
						<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
					</tr>
					<tr>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
						<td class="table--detail--show-md-and-up">88123:M:49753</td>
						<td class="table--detail--show-md-and-up">Filled</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
						<td class="table--detail--show-lg-and-up">9</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
						<td class="table--detail--show-lg-and-up">AZT</td>
						<td class="table--detail--show-sm-and-up">BUY</td>
						<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
					</tr>
					<tr>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
						<td class="table--detail--show-md-and-up">88123:M:49753</td>
						<td class="table--detail--show-md-and-up">Filled</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
						<td class="table--detail--show-lg-and-up">9</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
						<td class="table--detail--show-lg-and-up">AZT</td>
						<td class="table--detail--show-sm-and-up">BUY</td>
						<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
					</tr>
					<tr>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
						<td class="table--detail--show-md-and-up">88123:M:49753</td>
						<td class="table--detail--show-md-and-up">Filled</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
						<td class="table--detail--show-lg-and-up">9</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
						<td class="table--detail--show-lg-and-up">AZT</td>
						<td class="table--detail--show-sm-and-up">BUY</td>
						<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
					</tr>
					<tr>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
						<td class="table--detail--show-md-and-up">88123:M:49753</td>
						<td class="table--detail--show-md-and-up">Filled</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
						<td class="table--detail--show-lg-and-up">9</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
						<td class="table--detail--show-lg-and-up">AZT</td>
						<td class="table--detail--show-sm-and-up">BUY</td>
						<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
					</tr>
					<tr>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
						<td class="table--detail--show-md-and-up">88123:M:49753</td>
						<td class="table--detail--show-md-and-up">Filled</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
						<td class="table--detail--show-lg-and-up">9</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
						<td class="table--detail--show-lg-and-up">AZT</td>
						<td class="table--detail--show-sm-and-up">BUY</td>
						<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
					</tr>
					<tr>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
						<td class="table--detail--show-md-and-up">88123:M:49753</td>
						<td class="table--detail--show-md-and-up">Filled</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
						<td class="table--detail--show-lg-and-up">9</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
						<td class="table--detail--show-lg-and-up">AZT</td>
						<td class="table--detail--show-sm-and-up">BUY</td>
						<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
					</tr>
					<tr>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
						<td class="table--detail--show-md-and-up">88123:M:49753</td>
						<td class="table--detail--show-md-and-up">Filled</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
						<td class="table--detail--show-lg-and-up">9</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
						<td class="table--detail--show-lg-and-up">AZT</td>
						<td class="table--detail--show-sm-and-up">BUY</td>
						<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
					</tr>
					<tr>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
						<td class="table--detail--show-md-and-up">88123:M:49753</td>
						<td class="table--detail--show-md-and-up">Filled</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
						<td class="table--detail--show-lg-and-up">9</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
						<td class="table--detail--show-lg-and-up">AZT</td>
						<td class="table--detail--show-sm-and-up">BUY</td>
						<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
					</tr>
					<tr>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
						<td class="table--detail--show-md-and-up">88123:M:49753</td>
						<td class="table--detail--show-md-and-up">Filled</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
						<td class="table--detail--show-lg-and-up">9</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
						<td class="table--detail--show-lg-and-up">AZT</td>
						<td class="table--detail--show-sm-and-up">BUY</td>
						<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
					</tr>
					<tr>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>
						<td class="table--detail--show-md-and-up">88123:M:49753</td>
						<td class="table--detail--show-md-and-up">Filled</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>
						<td class="table--detail--show-lg-and-up">9</td>
						<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
						<td class="table--detail--show-lg-and-up">AZT</td>
						<td class="table--detail--show-sm-and-up">BUY</td>
						<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--show-lg-and-up">10028.0</td>
						<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>
					</tr>
				</tbody>
			</table>
			<div class="table--detail__secondary--view js-table-secondary-view hide--lg-and-up">
				<div class="table--detail__secondary--view__container">
					<header class="table--detail__secondary--view__header">
						<button class="btn btn--transparent table--detail__secondary--view__header__action js-table-secondary-view--dismiss soft-half"><i class="fa fa-angle-double-left"></i></button>
						<h3 class="table--detail__secondary--view__header__title flush">Detail View</h3>
					</header>
					<section class="table--detail__secondary--view__container__content">
						<table class="table table--detail__secondary--view-table push-half--top">
							<tbody>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Client Order ID</td>
									<td class="table--detail__secondary--view__table-value text--left">ACP1529</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Fill ID</td>
									<td class="table--detail__secondary--view__table-value text--left">88123:M:49753</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Status</td>
									<td class="table--detail__secondary--view__table-value text--left">Filled</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Fill Time</td>
									<td class="table--detail__secondary--view__table-value text--left">2018-06-22 07:53:47</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Tag 50</td>
									<td class="table--detail__secondary--view__table-value text--left">4027</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Fill Qty</td>
									<td class="table--detail__secondary--view__table-value text--left">9</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Contract</td>
									<td class="table--detail__secondary--view__table-value text--left">CAUM9 C0775</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Session ID</td>
									<td class="table--detail__secondary--view__table-value text--left">AZT</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">B/S</td>
									<td class="table--detail__secondary--view__table-value text--left">BUY</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Amount</td>
									<td class="table--detail__secondary--view__table-value text--left">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Fill Price</td>
									<td class="table--detail__secondary--view__table-value text--left">10028.0</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Order Price</td>
									<td class="table--detail__secondary--view__table-value text--left">10028.0</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Client Order ID</td>
									<td class="table--detail__secondary--view__table-value text--left">ACP1529</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Fill ID</td>
									<td class="table--detail__secondary--view__table-value text--left">88123:M:49753</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Status</td>
									<td class="table--detail__secondary--view__table-value text--left">Filled</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Fill Time</td>
									<td class="table--detail__secondary--view__table-value text--left">2018-06-22 07:53:47</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Tag 50</td>
									<td class="table--detail__secondary--view__table-value text--left">4027</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Fill Qty</td>
									<td class="table--detail__secondary--view__table-value text--left">9</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Contract</td>
									<td class="table--detail__secondary--view__table-value text--left">CAUM9 C0775</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Session ID</td>
									<td class="table--detail__secondary--view__table-value text--left">AZT</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">B/S</td>
									<td class="table--detail__secondary--view__table-value text--left">BUY</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Amount</td>
									<td class="table--detail__secondary--view__table-value text--left">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Fill Price</td>
									<td class="table--detail__secondary--view__table-value text--left">10028.0</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Order Price</td>
									<td class="table--detail__secondary--view__table-value text--left">10028.0</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Client Order ID</td>
									<td class="table--detail__secondary--view__table-value text--left">ACP1529</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Fill ID</td>
									<td class="table--detail__secondary--view__table-value text--left">88123:M:49753</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Status</td>
									<td class="table--detail__secondary--view__table-value text--left">Filled</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Fill Time</td>
									<td class="table--detail__secondary--view__table-value text--left">2018-06-22 07:53:47</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Tag 50</td>
									<td class="table--detail__secondary--view__table-value text--left">4027</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Fill Qty</td>
									<td class="table--detail__secondary--view__table-value text--left">9</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Contract</td>
									<td class="table--detail__secondary--view__table-value text--left">CAUM9 C0775</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Session ID</td>
									<td class="table--detail__secondary--view__table-value text--left">AZT</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">B/S</td>
									<td class="table--detail__secondary--view__table-value text--left">BUY</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Amount</td>
									<td class="table--detail__secondary--view__table-value text--left">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Fill Price</td>
									<td class="table--detail__secondary--view__table-value text--left">10028.0</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Order Price</td>
									<td class="table--detail__secondary--view__table-value text--left">10028.0</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Client Order ID</td>
									<td class="table--detail__secondary--view__table-value text--left">ACP1529</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Fill ID</td>
									<td class="table--detail__secondary--view__table-value text--left">88123:M:49753</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Status</td>
									<td class="table--detail__secondary--view__table-value text--left">Filled</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Fill Time</td>
									<td class="table--detail__secondary--view__table-value text--left">2018-06-22 07:53:47</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Tag 50</td>
									<td class="table--detail__secondary--view__table-value text--left">4027</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Fill Qty</td>
									<td class="table--detail__secondary--view__table-value text--left">9</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Contract</td>
									<td class="table--detail__secondary--view__table-value text--left">CAUM9 C0775</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Session ID</td>
									<td class="table--detail__secondary--view__table-value text--left">AZT</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">B/S</td>
									<td class="table--detail__secondary--view__table-value text--left">BUY</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Amount</td>
									<td class="table--detail__secondary--view__table-value text--left">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Fill Price</td>
									<td class="table--detail__secondary--view__table-value text--left">10028.0</td>
								</tr>
								<tr>
									<td class="table--detail__secondary--view__table-key text--right">Order Price</td>
									<td class="table--detail__secondary--view__table-value text--left">10028.0</td>
								</tr>
							</tbody>
						</table>
					</section>
				</div>
			</div>
		</div>
	</div>
</div>`}</code></pre>
		<br/>
		<h3>Table Expanded Row</h3>
		<p>For data sets with large amounts of columns you can set priority and secondary columns. To avoid scrolling horizontally, the Common UI Expanded Row table allows you
		to view all information. The intention is that any data that will not fit in the defaulted view will be shown in an Expanded Row.</p>
		<div style={{ 'height': '400px', 'overflowX': 'hidden' }}>
			<div className="table--detail--container">
				<div className="grid height--100">
					<div className="position--relative grid__col-12 height--100">
						<table className="table table--blue table--comfy table--hover table--expanded--striped table--rows table--detail table--detail__expanded js-table-detail-expanded">
							<thead>
								<tr>
									<th className="table--detail--show-xs-only table--detail--show-xs-and-up">Client Order ID</th>
									<th className="table--detail--show-md-and-up">Fill ID</th>
									<th className="table--detail--show-md-and-up">Status</th>
									<th className="table--detail--show-xs-and-up">Fill Time</th>
									<th className="table--detail--show-xs-and-up">Tag 50</th>
									<th className="table--detail--show-lg-and-up">Fill Qty</th>
									<th className="table--detail--show-xs-only table--detail--show-xs-and-up">Contract</th>
									<th className="table--detail--show-sm-and-up">Session ID</th>
									<th className="table--detail--show-sm-and-up">B/S</th>
									<th className="table--detail--show-lg-and-up">Fill Price</th>
									<th className="table--detail--show-lg-and-up">Order Price</th>
									<th className="table--detail--show-lg-and-up">Stop Price</th>
									<th className="table--detail--disclose"></th>
									<th className="table--detail--disclose"></th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-expand-trigger"><i className="fa fa-angle-double-down"></i></td>
									<td className="table--detail--disclose"><i className="fa fa-trash delete-row"></i></td>
								</tr>
								<tr className="table--detail__row--expanded js-table-detail-expanded-row">
									<td colSpan="14">
										<div>
											<ul className="table--detail__row--expanded--list">
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill ID</p>
													<p className="table--detail__row--expanded--list-item-value">88123:M:49753</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Status</p>
													<p className="table--detail__row--expanded--list-item-value">Filled</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Time</p>
													<p className="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Tag 50</p>
													<p className="table--detail__row--expanded--list-item-value">4027</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Qty</p>
													<p className="table--detail__row--expanded--list-item-value">9</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">Session ID</p>
													<p className="table--detail__row--expanded--list-item-value">AZT</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">B/S</p>
													<p className="table--detail__row--expanded--list-item-value">BUY</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Order Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Stop Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Exchange</p>
													<p className="table--detail__row--expanded--list-item-value">NYMEX</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
													<p className="table--detail__row--expanded--list-item-value">Day</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Firm ID</p>
													<p className="table--detail__row--expanded--list-item-value">100</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Comments</p>
													<p className="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
												</li>
											</ul>
										</div>
									</td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-expand-trigger"><i className="fa fa-angle-double-down"></i></td>
									<td className="table--detail--disclose"><i className="fa fa-trash delete-row"></i></td>
								</tr>
								<tr className="table--detail__row--expanded js-table-detail-expanded-row">
									<td colSpan="14">
										<div>
											<ul className="table--detail__row--expanded--list">
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill ID</p>
													<p className="table--detail__row--expanded--list-item-value">88123:M:49753</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Status</p>
													<p className="table--detail__row--expanded--list-item-value">Filled</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Time</p>
													<p className="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Tag 50</p>
													<p className="table--detail__row--expanded--list-item-value">4027</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Qty</p>
													<p className="table--detail__row--expanded--list-item-value">9</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">Session ID</p>
													<p className="table--detail__row--expanded--list-item-value">AZT</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">B/S</p>
													<p className="table--detail__row--expanded--list-item-value">BUY</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Order Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Stop Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Exchange</p>
													<p className="table--detail__row--expanded--list-item-value">NYMEX</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
													<p className="table--detail__row--expanded--list-item-value">Day</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Firm ID</p>
													<p className="table--detail__row--expanded--list-item-value">100</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Comments</p>
													<p className="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
												</li>
											</ul>
										</div>
									</td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-expand-trigger"><i className="fa fa-angle-double-down"></i></td>
									<td className="table--detail--disclose"><i className="fa fa-trash delete-row"></i></td>
								</tr>
								<tr className="table--detail__row--expanded js-table-detail-expanded-row">
									<td colSpan="14">
										<div>
											<ul className="table--detail__row--expanded--list">
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill ID</p>
													<p className="table--detail__row--expanded--list-item-value">88123:M:49753</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Status</p>
													<p className="table--detail__row--expanded--list-item-value">Filled</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Time</p>
													<p className="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Tag 50</p>
													<p className="table--detail__row--expanded--list-item-value">4027</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Qty</p>
													<p className="table--detail__row--expanded--list-item-value">9</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">Session ID</p>
													<p className="table--detail__row--expanded--list-item-value">AZT</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">B/S</p>
													<p className="table--detail__row--expanded--list-item-value">BUY</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Order Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Stop Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Exchange</p>
													<p className="table--detail__row--expanded--list-item-value">NYMEX</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
													<p className="table--detail__row--expanded--list-item-value">Day</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Firm ID</p>
													<p className="table--detail__row--expanded--list-item-value">100</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Comments</p>
													<p className="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
												</li>
											</ul>
										</div>
									</td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-expand-trigger"><i className="fa fa-angle-double-down"></i></td>
									<td className="table--detail--disclose"><i className="fa fa-trash delete-row"></i></td>
								</tr>
								<tr className="table--detail__row--expanded js-table-detail-expanded-row">
									<td colSpan="14">
										<div>
											<ul className="table--detail__row--expanded--list">
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill ID</p>
													<p className="table--detail__row--expanded--list-item-value">88123:M:49753</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Status</p>
													<p className="table--detail__row--expanded--list-item-value">Filled</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Time</p>
													<p className="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Tag 50</p>
													<p className="table--detail__row--expanded--list-item-value">4027</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Qty</p>
													<p className="table--detail__row--expanded--list-item-value">9</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">Session ID</p>
													<p className="table--detail__row--expanded--list-item-value">AZT</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">B/S</p>
													<p className="table--detail__row--expanded--list-item-value">BUY</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Order Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Stop Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Exchange</p>
													<p className="table--detail__row--expanded--list-item-value">NYMEX</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
													<p className="table--detail__row--expanded--list-item-value">Day</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Firm ID</p>
													<p className="table--detail__row--expanded--list-item-value">100</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Comments</p>
													<p className="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
												</li>
											</ul>
										</div>
									</td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-expand-trigger"><i className="fa fa-angle-double-down"></i></td>
									<td className="table--detail--disclose"><i className="fa fa-trash delete-row"></i></td>
								</tr>
								<tr className="table--detail__row--expanded js-table-detail-expanded-row">
									<td colSpan="14">
										<div>
											<ul className="table--detail__row--expanded--list">
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill ID</p>
													<p className="table--detail__row--expanded--list-item-value">88123:M:49753</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Status</p>
													<p className="table--detail__row--expanded--list-item-value">Filled</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Time</p>
													<p className="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Tag 50</p>
													<p className="table--detail__row--expanded--list-item-value">4027</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Qty</p>
													<p className="table--detail__row--expanded--list-item-value">9</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">Session ID</p>
													<p className="table--detail__row--expanded--list-item-value">AZT</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">B/S</p>
													<p className="table--detail__row--expanded--list-item-value">BUY</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Order Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Stop Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Exchange</p>
													<p className="table--detail__row--expanded--list-item-value">NYMEX</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
													<p className="table--detail__row--expanded--list-item-value">Day</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Firm ID</p>
													<p className="table--detail__row--expanded--list-item-value">100</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Comments</p>
													<p className="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
												</li>
											</ul>
										</div>
									</td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-expand-trigger"><i className="fa fa-angle-double-down"></i></td>
									<td className="table--detail--disclose"><i className="fa fa-trash delete-row"></i></td>
								</tr>
								<tr className="table--detail__row--expanded js-table-detail-expanded-row">
									<td colSpan="14">
										<div>
											<ul className="table--detail__row--expanded--list">
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill ID</p>
													<p className="table--detail__row--expanded--list-item-value">88123:M:49753</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Status</p>
													<p className="table--detail__row--expanded--list-item-value">Filled</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Time</p>
													<p className="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Tag 50</p>
													<p className="table--detail__row--expanded--list-item-value">4027</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Qty</p>
													<p className="table--detail__row--expanded--list-item-value">9</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">Session ID</p>
													<p className="table--detail__row--expanded--list-item-value">AZT</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">B/S</p>
													<p className="table--detail__row--expanded--list-item-value">BUY</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Order Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Stop Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Exchange</p>
													<p className="table--detail__row--expanded--list-item-value">NYMEX</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
													<p className="table--detail__row--expanded--list-item-value">Day</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Firm ID</p>
													<p className="table--detail__row--expanded--list-item-value">100</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Comments</p>
													<p className="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
												</li>
											</ul>
										</div>
									</td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-expand-trigger"><i className="fa fa-angle-double-down"></i></td>
									<td className="table--detail--disclose"><i className="fa fa-trash delete-row"></i></td>
								</tr>
								<tr className="table--detail__row--expanded js-table-detail-expanded-row">
									<td colSpan="14">
										<div>
											<ul className="table--detail__row--expanded--list">
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill ID</p>
													<p className="table--detail__row--expanded--list-item-value">88123:M:49753</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Status</p>
													<p className="table--detail__row--expanded--list-item-value">Filled</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Time</p>
													<p className="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Tag 50</p>
													<p className="table--detail__row--expanded--list-item-value">4027</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Qty</p>
													<p className="table--detail__row--expanded--list-item-value">9</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">Session ID</p>
													<p className="table--detail__row--expanded--list-item-value">AZT</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">B/S</p>
													<p className="table--detail__row--expanded--list-item-value">BUY</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Order Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Stop Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Exchange</p>
													<p className="table--detail__row--expanded--list-item-value">NYMEX</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
													<p className="table--detail__row--expanded--list-item-value">Day</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Firm ID</p>
													<p className="table--detail__row--expanded--list-item-value">100</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Comments</p>
													<p className="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
												</li>
											</ul>
										</div>
									</td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-expand-trigger"><i className="fa fa-angle-double-down"></i></td>
									<td className="table--detail--disclose"><i className="fa fa-trash delete-row"></i></td>
								</tr>
								<tr className="table--detail__row--expanded js-table-detail-expanded-row">
									<td colSpan="14">
										<div>
											<ul className="table--detail__row--expanded--list">
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill ID</p>
													<p className="table--detail__row--expanded--list-item-value">88123:M:49753</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Status</p>
													<p className="table--detail__row--expanded--list-item-value">Filled</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Time</p>
													<p className="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Tag 50</p>
													<p className="table--detail__row--expanded--list-item-value">4027</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Qty</p>
													<p className="table--detail__row--expanded--list-item-value">9</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">Session ID</p>
													<p className="table--detail__row--expanded--list-item-value">AZT</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">B/S</p>
													<p className="table--detail__row--expanded--list-item-value">BUY</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Order Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Stop Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Exchange</p>
													<p className="table--detail__row--expanded--list-item-value">NYMEX</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
													<p className="table--detail__row--expanded--list-item-value">Day</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Firm ID</p>
													<p className="table--detail__row--expanded--list-item-value">100</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Comments</p>
													<p className="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
												</li>
											</ul>
										</div>
									</td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-expand-trigger"><i className="fa fa-angle-double-down"></i></td>
									<td className="table--detail--disclose"><i className="fa fa-trash delete-row"></i></td>
								</tr>
								<tr className="table--detail__row--expanded js-table-detail-expanded-row">
									<td colSpan="14">
										<div>
											<ul className="table--detail__row--expanded--list">
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill ID</p>
													<p className="table--detail__row--expanded--list-item-value">88123:M:49753</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Status</p>
													<p className="table--detail__row--expanded--list-item-value">Filled</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Time</p>
													<p className="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Tag 50</p>
													<p className="table--detail__row--expanded--list-item-value">4027</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Qty</p>
													<p className="table--detail__row--expanded--list-item-value">9</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">Session ID</p>
													<p className="table--detail__row--expanded--list-item-value">AZT</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">B/S</p>
													<p className="table--detail__row--expanded--list-item-value">BUY</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Order Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Stop Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Exchange</p>
													<p className="table--detail__row--expanded--list-item-value">NYMEX</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
													<p className="table--detail__row--expanded--list-item-value">Day</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Firm ID</p>
													<p className="table--detail__row--expanded--list-item-value">100</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Comments</p>
													<p className="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
												</li>
											</ul>
										</div>
									</td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-expand-trigger"><i className="fa fa-angle-double-down"></i></td>
									<td className="table--detail--disclose"><i className="fa fa-trash delete-row"></i></td>
								</tr>
								<tr className="table--detail__row--expanded js-table-detail-expanded-row">
									<td colSpan="14">
										<div>
											<ul className="table--detail__row--expanded--list">
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill ID</p>
													<p className="table--detail__row--expanded--list-item-value">88123:M:49753</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Status</p>
													<p className="table--detail__row--expanded--list-item-value">Filled</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Time</p>
													<p className="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Tag 50</p>
													<p className="table--detail__row--expanded--list-item-value">4027</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Qty</p>
													<p className="table--detail__row--expanded--list-item-value">9</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">Session ID</p>
													<p className="table--detail__row--expanded--list-item-value">AZT</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">B/S</p>
													<p className="table--detail__row--expanded--list-item-value">BUY</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Order Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Stop Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Exchange</p>
													<p className="table--detail__row--expanded--list-item-value">NYMEX</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
													<p className="table--detail__row--expanded--list-item-value">Day</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Firm ID</p>
													<p className="table--detail__row--expanded--list-item-value">100</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Comments</p>
													<p className="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
												</li>
											</ul>
										</div>
									</td>
								</tr>
								<tr>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
									<td className="table--detail--show-md-and-up">88123:M:49753</td>
									<td className="table--detail--show-md-and-up">Filled</td>
									<td className="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--show-lg-and-up">10028.0</td>
									<td className="table--detail--disclose js-table-detail-expand-trigger"><i className="fa fa-angle-double-down"></i></td>
									<td className="table--detail--disclose"><i className="fa fa-trash delete-row"></i></td>
								</tr>
								<tr className="table--detail__row--expanded js-table-detail-expanded-row">
									<td colSpan="14">
										<div>
											<ul className="table--detail__row--expanded--list">
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill ID</p>
													<p className="table--detail__row--expanded--list-item-value">88123:M:49753</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--md-and-up">
													<p className="table--detail__row--expanded--list-item-title">Status</p>
													<p className="table--detail__row--expanded--list-item-value">Filled</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Time</p>
													<p className="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--xs-and-up">
													<p className="table--detail__row--expanded--list-item-title">Tag 50</p>
													<p className="table--detail__row--expanded--list-item-value">4027</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Qty</p>
													<p className="table--detail__row--expanded--list-item-value">9</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">Session ID</p>
													<p className="table--detail__row--expanded--list-item-value">AZT</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--sm-and-up">
													<p className="table--detail__row--expanded--list-item-title">B/S</p>
													<p className="table--detail__row--expanded--list-item-value">BUY</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Fill Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Order Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item hide--lg-and-up">
													<p className="table--detail__row--expanded--list-item-title">Stop Price</p>
													<p className="table--detail__row--expanded--list-item-value">10028.0</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Exchange</p>
													<p className="table--detail__row--expanded--list-item-value">NYMEX</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
													<p className="table--detail__row--expanded--list-item-value">Day</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Firm ID</p>
													<p className="table--detail__row--expanded--list-item-value">100</p>
												</li>
												<li className="table--detail__row--expanded--list-item">
													<p className="table--detail__row--expanded--list-item-title">Comments</p>
													<p className="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
												</li>
											</ul>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<br/>
		<p>As seen in the source, for each main row there should be another row immediately following with a <code>table--detail__row--expanded</code> class. This means two <code>tr</code> tags in succession in the DOM. The first one being the
		main table row that follows the usual format and the second being a row that has free-form flex elements within. The Common UI JS library expects the detailed row to immediately follow its 'parent' row.</p>
		<pre><code className="language-html">{`<!-- Start of 'full' row couplet -->
<tr ...>
	<td>ACP1529</td>
	<td>88123:M:49753</td>
	...
</tr>
<tr class="table--detail__row--expanded js-table-detail-expanded-row">
	<td colspan=""><ul>...</ul></td>
</tr>
<!-- End of 'full' row couplet -->`}</code></pre>
		<br/>
		<p className="callout">
			<strong>Note:</strong> In order for the detail row to appear correctly and span the full width of the table, the td tag within the expanded row must have a 'colspan' attribute, with a value that matches the amount of table headings.
		</p>
		<p>The responsive implementation is similiar to the detail table view above, using CSS classes we can show and hide certain content at certain breakpoints.</p>
		<select className="size-select">
			<option value="">Select a resolution</option>
			<option value="482">480px (xs)</option>
			<option value="770">768px (sm)</option>
			<option value="994">992px (md)</option>
			<option value="1202">1200px (lg)</option>
		</select>
		<br/><br/>
		<div className="iframe-container" style={{ 'height': '500px' }}>
			<iframe seamless srcDoc={`
				<html class="height--100">
					<head>
						<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
						<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
						<link rel="stylesheet" type="text/css" href="css/commonUI.css">
					</head>
					<body class="height--100">
						<div class="table--detail--container">
							<div class="grid height--100">
								<div class="position--relative grid__col-12 height--100">
									<table class="table table--blue table--comfy table--hover table--expanded--striped table--rows table--detail table--detail__expanded js-table-detail-expanded">
										<thead>
											<tr>
												<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Client Order ID</th>
												<th class="table--detail--show-md-and-up">Fill ID</th>
												<th class="table--detail--show-md-and-up">Status</th>
												<th class="table--detail--show-xs-and-up">Fill Time</th>
												<th class="table--detail--show-xs-and-up">Tag 50</th>
												<th class="table--detail--show-lg-and-up">Fill Qty</th>
												<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Contract</th>
												<th class="table--detail--show-sm-and-up">Session ID</th>
												<th class="table--detail--show-sm-and-up">B/S</th>
												<th class="table--detail--show-lg-and-up">Fill Price</th>
												<th class="table--detail--show-lg-and-up">Order Price</th>
												<th class="table--detail--show-lg-and-up">Stop Price</th>
												<th class="table--detail--disclose"></th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>
											</tr>
											<tr class="table--detail__row--expanded js-table-detail-expanded-row">
												<td colspan="13">
													<div>
														<ul class="table--detail__row--expanded--list">
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill ID</p>
																<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Status</p>
																<p class="table--detail__row--expanded--list-item-value">Filled</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Time</p>
																<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Tag 50</p>
																<p class="table--detail__row--expanded--list-item-value">4027</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>
																<p class="table--detail__row--expanded--list-item-value">9</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">Session ID</p>
																<p class="table--detail__row--expanded--list-item-value">AZT</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">B/S</p>
																<p class="table--detail__row--expanded--list-item-value">BUY</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Order Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Stop Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Exchange</p>
																<p class="table--detail__row--expanded--list-item-value">NYMEX</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
																<p class="table--detail__row--expanded--list-item-value">Day</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Firm ID</p>
																<p class="table--detail__row--expanded--list-item-value">100</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Comments</p>
																<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
															</li>
														</ul>
													</div>
												</td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>
											</tr>
											<tr class="table--detail__row--expanded js-table-detail-expanded-row">
												<td colSpan="13">
													<div>
														<ul class="table--detail__row--expanded--list">
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill ID</p>
																<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Status</p>
																<p class="table--detail__row--expanded--list-item-value">Filled</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Time</p>
																<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Tag 50</p>
																<p class="table--detail__row--expanded--list-item-value">4027</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>
																<p class="table--detail__row--expanded--list-item-value">9</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">Session ID</p>
																<p class="table--detail__row--expanded--list-item-value">AZT</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">B/S</p>
																<p class="table--detail__row--expanded--list-item-value">BUY</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Order Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Stop Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Exchange</p>
																<p class="table--detail__row--expanded--list-item-value">NYMEX</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
																<p class="table--detail__row--expanded--list-item-value">Day</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Firm ID</p>
																<p class="table--detail__row--expanded--list-item-value">100</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Comments</p>
																<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
															</li>
														</ul>
													</div>
												</td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>
											</tr>
											<tr class="table--detail__row--expanded js-table-detail-expanded-row">
												<td colSpan="13">
													<div>
														<ul class="table--detail__row--expanded--list">
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill ID</p>
																<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Status</p>
																<p class="table--detail__row--expanded--list-item-value">Filled</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Time</p>
																<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Tag 50</p>
																<p class="table--detail__row--expanded--list-item-value">4027</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>
																<p class="table--detail__row--expanded--list-item-value">9</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">Session ID</p>
																<p class="table--detail__row--expanded--list-item-value">AZT</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">B/S</p>
																<p class="table--detail__row--expanded--list-item-value">BUY</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Order Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Stop Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Exchange</p>
																<p class="table--detail__row--expanded--list-item-value">NYMEX</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
																<p class="table--detail__row--expanded--list-item-value">Day</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Firm ID</p>
																<p class="table--detail__row--expanded--list-item-value">100</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Comments</p>
																<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
															</li>
														</ul>
													</div>
												</td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>
											</tr>
											<tr class="table--detail__row--expanded js-table-detail-expanded-row">
												<td colSpan="13">
													<div>
														<ul class="table--detail__row--expanded--list">
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill ID</p>
																<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Status</p>
																<p class="table--detail__row--expanded--list-item-value">Filled</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Time</p>
																<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Tag 50</p>
																<p class="table--detail__row--expanded--list-item-value">4027</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>
																<p class="table--detail__row--expanded--list-item-value">9</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">Session ID</p>
																<p class="table--detail__row--expanded--list-item-value">AZT</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">B/S</p>
																<p class="table--detail__row--expanded--list-item-value">BUY</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Order Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Stop Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Exchange</p>
																<p class="table--detail__row--expanded--list-item-value">NYMEX</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
																<p class="table--detail__row--expanded--list-item-value">Day</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Firm ID</p>
																<p class="table--detail__row--expanded--list-item-value">100</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Comments</p>
																<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
															</li>
														</ul>
													</div>
												</td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>
											</tr>
											<tr class="table--detail__row--expanded js-table-detail-expanded-row">
												<td colSpan="13">
													<div>
														<ul class="table--detail__row--expanded--list">
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill ID</p>
																<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Status</p>
																<p class="table--detail__row--expanded--list-item-value">Filled</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Time</p>
																<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Tag 50</p>
																<p class="table--detail__row--expanded--list-item-value">4027</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>
																<p class="table--detail__row--expanded--list-item-value">9</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">Session ID</p>
																<p class="table--detail__row--expanded--list-item-value">AZT</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">B/S</p>
																<p class="table--detail__row--expanded--list-item-value">BUY</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Order Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Stop Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Exchange</p>
																<p class="table--detail__row--expanded--list-item-value">NYMEX</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
																<p class="table--detail__row--expanded--list-item-value">Day</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Firm ID</p>
																<p class="table--detail__row--expanded--list-item-value">100</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Comments</p>
																<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
															</li>
														</ul>
													</div>
												</td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>
											</tr>
											<tr class="table--detail__row--expanded js-table-detail-expanded-row">
												<td colSpan="13">
													<div>
														<ul class="table--detail__row--expanded--list">
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill ID</p>
																<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Status</p>
																<p class="table--detail__row--expanded--list-item-value">Filled</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Time</p>
																<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Tag 50</p>
																<p class="table--detail__row--expanded--list-item-value">4027</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>
																<p class="table--detail__row--expanded--list-item-value">9</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">Session ID</p>
																<p class="table--detail__row--expanded--list-item-value">AZT</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">B/S</p>
																<p class="table--detail__row--expanded--list-item-value">BUY</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Order Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Stop Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Exchange</p>
																<p class="table--detail__row--expanded--list-item-value">NYMEX</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
																<p class="table--detail__row--expanded--list-item-value">Day</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Firm ID</p>
																<p class="table--detail__row--expanded--list-item-value">100</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Comments</p>
																<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
															</li>
														</ul>
													</div>
												</td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>
											</tr>
											<tr class="table--detail__row--expanded js-table-detail-expanded-row">
												<td colSpan="13">
													<div>
														<ul class="table--detail__row--expanded--list">
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill ID</p>
																<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Status</p>
																<p class="table--detail__row--expanded--list-item-value">Filled</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Time</p>
																<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Tag 50</p>
																<p class="table--detail__row--expanded--list-item-value">4027</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>
																<p class="table--detail__row--expanded--list-item-value">9</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">Session ID</p>
																<p class="table--detail__row--expanded--list-item-value">AZT</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">B/S</p>
																<p class="table--detail__row--expanded--list-item-value">BUY</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Order Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Stop Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Exchange</p>
																<p class="table--detail__row--expanded--list-item-value">NYMEX</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
																<p class="table--detail__row--expanded--list-item-value">Day</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Firm ID</p>
																<p class="table--detail__row--expanded--list-item-value">100</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Comments</p>
																<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
															</li>
														</ul>
													</div>
												</td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>
											</tr>
											<tr class="table--detail__row--expanded js-table-detail-expanded-row">
												<td colSpan="13">
													<div>
														<ul class="table--detail__row--expanded--list">
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill ID</p>
																<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Status</p>
																<p class="table--detail__row--expanded--list-item-value">Filled</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Time</p>
																<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Tag 50</p>
																<p class="table--detail__row--expanded--list-item-value">4027</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>
																<p class="table--detail__row--expanded--list-item-value">9</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">Session ID</p>
																<p class="table--detail__row--expanded--list-item-value">AZT</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">B/S</p>
																<p class="table--detail__row--expanded--list-item-value">BUY</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Order Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Stop Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Exchange</p>
																<p class="table--detail__row--expanded--list-item-value">NYMEX</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
																<p class="table--detail__row--expanded--list-item-value">Day</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Firm ID</p>
																<p class="table--detail__row--expanded--list-item-value">100</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Comments</p>
																<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
															</li>
														</ul>
													</div>
												</td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>
											</tr>
											<tr class="table--detail__row--expanded js-table-detail-expanded-row">
												<td colSpan="13">
													<div>
														<ul class="table--detail__row--expanded--list">
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill ID</p>
																<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Status</p>
																<p class="table--detail__row--expanded--list-item-value">Filled</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Time</p>
																<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Tag 50</p>
																<p class="table--detail__row--expanded--list-item-value">4027</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>
																<p class="table--detail__row--expanded--list-item-value">9</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">Session ID</p>
																<p class="table--detail__row--expanded--list-item-value">AZT</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">B/S</p>
																<p class="table--detail__row--expanded--list-item-value">BUY</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Order Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Stop Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Exchange</p>
																<p class="table--detail__row--expanded--list-item-value">NYMEX</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
																<p class="table--detail__row--expanded--list-item-value">Day</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Firm ID</p>
																<p class="table--detail__row--expanded--list-item-value">100</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Comments</p>
																<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
															</li>
														</ul>
													</div>
												</td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>
											</tr>
											<tr class="table--detail__row--expanded js-table-detail-expanded-row">
												<td colSpan="13">
													<div>
														<ul class="table--detail__row--expanded--list">
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill ID</p>
																<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Status</p>
																<p class="table--detail__row--expanded--list-item-value">Filled</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Time</p>
																<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Tag 50</p>
																<p class="table--detail__row--expanded--list-item-value">4027</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>
																<p class="table--detail__row--expanded--list-item-value">9</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">Session ID</p>
																<p class="table--detail__row--expanded--list-item-value">AZT</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">B/S</p>
																<p class="table--detail__row--expanded--list-item-value">BUY</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Order Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Stop Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Exchange</p>
																<p class="table--detail__row--expanded--list-item-value">NYMEX</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
																<p class="table--detail__row--expanded--list-item-value">Day</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Firm ID</p>
																<p class="table--detail__row--expanded--list-item-value">100</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Comments</p>
																<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
															</li>
														</ul>
													</div>
												</td>
											</tr>
											<tr>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
												<td class="table--detail--show-md-and-up">88123:M:49753</td>
												<td class="table--detail--show-md-and-up">Filled</td>
												<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
												<td class="table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--show-lg-and-up">10028.0</td>
												<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>
											</tr>
											<tr class="table--detail__row--expanded js-table-detail-expanded-row">
												<td colSpan="13">
													<div>
														<ul class="table--detail__row--expanded--list">
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill ID</p>
																<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--md-and-up">
																<p class="table--detail__row--expanded--list-item-title">Status</p>
																<p class="table--detail__row--expanded--list-item-value">Filled</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Time</p>
																<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																<p class="table--detail__row--expanded--list-item-title">Tag 50</p>
																<p class="table--detail__row--expanded--list-item-value">4027</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>
																<p class="table--detail__row--expanded--list-item-value">9</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">Session ID</p>
																<p class="table--detail__row--expanded--list-item-value">AZT</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																<p class="table--detail__row--expanded--list-item-title">B/S</p>
																<p class="table--detail__row--expanded--list-item-value">BUY</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Fill Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Order Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																<p class="table--detail__row--expanded--list-item-title">Stop Price</p>
																<p class="table--detail__row--expanded--list-item-value">10028.0</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Exchange</p>
																<p class="table--detail__row--expanded--list-item-value">NYMEX</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
																<p class="table--detail__row--expanded--list-item-value">Day</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Firm ID</p>
																<p class="table--detail__row--expanded--list-item-value">100</p>
															</li>
															<li class="table--detail__row--expanded--list-item">
																<p class="table--detail__row--expanded--list-item-title">Comments</p>
																<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
															</li>
														</ul>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
						<script type="text/javascript" src="js/commonUI.js"></script>
						<script>
							function init() {
								commonUI.initializeTable({
									selector: '.js-table-detail-expanded',
									detailViewType: 'expandedRow',
									detailViewSelector: '.js-table-detail-expand-trigger'
								});
							}
							window.onload = init;
						</script>
					</body>
				</html>
			`}></iframe>
		</div><br/>
		<p>To enable this functionality, you can instantiate the table like this:</p>
		<pre><code className="language-javascript">{`commonUI.initializeTable({
	selector: '.js-table-detail-expanded',
	detailViewType: 'expandedRow',
	detailViewSelector: '.js-table-detail-expand-trigger'
});`}</code></pre>
		<br/>
		<button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
		<pre className="hide-code"><code className="language-html">{`<table class="table table--blue table--comfy table--hover table--expanded--striped table--rows table--detail table--detail__expanded js-table-detail-expanded">
	<thead>
		<tr>
			<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Client Order ID</th>
			<th class="table--detail--show-md-and-up">Fill ID</th>
			<th class="table--detail--show-md-and-up">Status</th>
			<th class="table--detail--show-xs-and-up">Fill Time</th>
			<th class="table--detail--show-xs-and-up">Tag 50</th>
			<th class="table--detail--show-lg-and-up">Fill Qty</th>
			<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Contract</th>
			<th class="table--detail--show-sm-and-up">Session ID</th>
			<th class="table--detail--show-sm-and-up">B/S</th>
			<th class="table--detail--show-lg-and-up">Fill Price</th>
			<th class="table--detail--show-lg-and-up">Order Price</th>
			<th class="table--detail--show-lg-and-up">Stop Price</th>
			<th class="table--detail--disclose"></th>
		</tr>
	</thead>
	<tbody>
		<tr>
			<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
			<td class="table--detail--show-md-and-up">88123:M:49753</td>
			<td class="table--detail--show-md-and-up">Filled</td>
			<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>
			<td class="table--detail--show-xs-and-up">4027</td>
			<td class="table--detail--show-lg-and-up">9</td>
			<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
			<td class="table--detail--show-sm-and-up">AZT</td>
			<td class="table--detail--show-sm-and-up">BUY</td>
			<td class="table--detail--show-lg-and-up">10028.0</td>
			<td class="table--detail--show-lg-and-up">10028.0</td>
			<td class="table--detail--show-lg-and-up">10028.0</td>
			<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>
		</tr>
		<tr class="table--detail__row--expanded js-table-detail-expanded-row">
			<td colspan="13">
				<div>
					<ul class="table--detail__row--expanded--list">
						<li class="table--detail__row--expanded--list-item hide--md-and-up">
							<p class="table--detail__row--expanded--list-item-title">Fill ID</p>
							<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>
						</li>
						<li class="table--detail__row--expanded--list-item hide--md-and-up">
							<p class="table--detail__row--expanded--list-item-title">Status</p>
							<p class="table--detail__row--expanded--list-item-value">Filled</p>
						</li>
						<li class="table--detail__row--expanded--list-item hide--xs-and-up">
							<p class="table--detail__row--expanded--list-item-title">Fill Time</p>
							<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>
						</li>
						<li class="table--detail__row--expanded--list-item hide--xs-and-up">
							<p class="table--detail__row--expanded--list-item-title">Tag 50</p>
							<p class="table--detail__row--expanded--list-item-value">4027</p>
						</li>
						<li class="table--detail__row--expanded--list-item hide--lg-and-up">
							<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>
							<p class="table--detail__row--expanded--list-item-value">9</p>
						</li>
						<li class="table--detail__row--expanded--list-item hide--sm-and-up">
							<p class="table--detail__row--expanded--list-item-title">Session ID</p>
							<p class="table--detail__row--expanded--list-item-value">AZT</p>
						</li>
						<li class="table--detail__row--expanded--list-item hide--sm-and-up">
							<p class="table--detail__row--expanded--list-item-title">B/S</p>
							<p class="table--detail__row--expanded--list-item-value">BUY</p>
						</li>
						<li class="table--detail__row--expanded--list-item hide--lg-and-up">
							<p class="table--detail__row--expanded--list-item-title">Fill Price</p>
							<p class="table--detail__row--expanded--list-item-value">10028.0</p>
						</li>
						<li class="table--detail__row--expanded--list-item hide--lg-and-up">
							<p class="table--detail__row--expanded--list-item-title">Order Price</p>
							<p class="table--detail__row--expanded--list-item-value">10028.0</p>
						</li>
						<li class="table--detail__row--expanded--list-item hide--lg-and-up">
							<p class="table--detail__row--expanded--list-item-title">Stop Price</p>
							<p class="table--detail__row--expanded--list-item-value">10028.0</p>
						</li>
						<li class="table--detail__row--expanded--list-item">
							<p class="table--detail__row--expanded--list-item-title">Exchange</p>
							<p class="table--detail__row--expanded--list-item-value">NYMEX</p>
						</li>
						<li class="table--detail__row--expanded--list-item">
							<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>
							<p class="table--detail__row--expanded--list-item-value">Day</p>
						</li>
						<li class="table--detail__row--expanded--list-item">
							<p class="table--detail__row--expanded--list-item-title">Firm ID</p>
							<p class="table--detail__row--expanded--list-item-value">100</p>
						</li>
						<li class="table--detail__row--expanded--list-item">
							<p class="table--detail__row--expanded--list-item-title">Comments</p>
							<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
						</li>
					</ul>
				</div>
			</td>
		</tr>
	</tbody>
</table>`}</code></pre>
		<br/>

		<h3>Table Stacked Row</h3>
		<p>In addition to the detailed view and expanded row there is also a stacked row. The use case for the stacked row is large sets of table data per row.</p>

		<p>These can be split into 3 sections; Primary Information, Secondary Information & All other supporting information. The padding of the secondary and supporting
		information row is relative to the <a href="#tables">table class</a> applied. For example, a secondary view with a table class of <code>.table--cosy</code>, will inherit the styling of the next size up, in this example <code>.table--comfy</code>.</p>
		<div style={{ 'height': '550px', 'overflowX': 'hidden' }}>
			<div className="table--detail--container">
				<div className="grid height--100">
					<div className="position--relative grid__col-12 hard height--100">
						<table className="table table--blue table--comfy table--hover table--expanded--striped table--rows table--detail table--detail__expanded--stacked js-table-detail-stacked">
							<thead>
								<tr>
									<th className="table--detail--show-xs-only table--detail--show-xs-and-up">Client Order ID</th>
									<th className="table--detail--show-md-and-up">Status</th>
									<th className="table--detail--show-md-and-up">Transaction Time</th>
									<th className="table--detail--show-xs-and-up">Tag 50</th>
									<th className="table--detail--show-xs-and-up">Qty</th>
									<th className="table--detail--show-lg-and-up">Open Qty</th>
									<th className="table--detail--show-xs-only table--detail--show-xs-and-up">Contract</th>
									<th className="table--detail--show-sm-and-up">Session ID</th>
									<th className="table--detail--show-sm-and-up">B/S</th>
									<th className="table--detail--show-lg-and-up">Account</th>
									<th className="table--detail--show-lg-and-up">TIF</th>
									<th className="table--detail--show-lg-and-up">Decimal Price</th>
									<th className="table--detail--disclose"></th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
									<td className="table--detail--show-md-and-up">Working</td>
									<td className="table--detail--show-md-and-up">08:09:38.890</td>
									<td className="table--detail--show-xs-and-up">45</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">BRIO</td>
									<td className="table--detail--show-lg-and-up">Day</td>
									<td className="table--detail--show-lg-and-up">5330.123456</td>
									<td className="table--detail--disclose"><i className="fa fa-ellipsis-v"></i></td>
								</tr>
								<tr className="table--detail__row--stacked">
									<td colSpan="13">
										<div className="table--detail__row--stacked--container">
											<div className="table--detail__row--stacked--content js-stacked-content">
												<ul className="table--detail__row--expanded--list">
													<li className="table--detail__row--expanded--list-item hide--md-and-up">
														<p className="table--detail__row--expanded--list-item-title">Status</p>
														<p className="table--detail__row--expanded--list-item-value">Working</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--md-and-up">
														<p className="table--detail__row--expanded--list-item-title">Transaction Time</p>
														<p className="table--detail__row--expanded--list-item-value">08:09:38.890</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--xs-and-up">
														<p className="table--detail__row--expanded--list-item-title">Tag 50</p>
														<p className="table--detail__row--expanded--list-item-value">45</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--xs-and-up">
														<p className="table--detail__row--expanded--list-item-title">Qty</p>
														<p className="table--detail__row--expanded--list-item-value">4027</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--lg-and-up">
														<p className="table--detail__row--expanded--list-item-title">Open Qty</p>
														<p className="table--detail__row--expanded--list-item-value">9</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--sm-and-up">
														<p className="table--detail__row--expanded--list-item-title">Contract</p>
														<p className="table--detail__row--expanded--list-item-value">CAUM9 C0775</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--sm-and-up">
														<p className="table--detail__row--expanded--list-item-title">Session ID</p>
														<p className="table--detail__row--expanded--list-item-value">AZT</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--lg-and-up">
														<p className="table--detail__row--expanded--list-item-title">B/S</p>
														<p className="table--detail__row--expanded--list-item-value">BUY</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--lg-and-up">
														<p className="table--detail__row--expanded--list-item-title">Account</p>
														<p className="table--detail__row--expanded--list-item-value">BRIO</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--lg-and-up">
														<p className="table--detail__row--expanded--list-item-title">TIF</p>
														<p className="table--detail__row--expanded--list-item-value">Day</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--lg-and-up">
														<p className="table--detail__row--expanded--list-item-title">Decimal Price</p>
														<p className="table--detail__row--expanded--list-item-value">5330.123456</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Fractional Price</p>
														<p className="table--detail__row--expanded--list-item-value">12345</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Stop Price</p>
														<p className="table--detail__row--expanded--list-item-value">12345</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Exchange</p>
														<p className="table--detail__row--expanded--list-item-value">CME</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Sender</p>
														<p className="table--detail__row--expanded--list-item-value">BRIO</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Cancel Reason</p>
														<p className="table--detail__row--expanded--list-item-value">Expired</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Segment ID</p>
														<p className="table--detail__row--expanded--list-item-value">56</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Firm ID</p>
														<p className="table--detail__row--expanded--list-item-value">004</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Expiry Date</p>
														<p className="table--detail__row--expanded--list-item-value">2018-10-11</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Reject Reason</p>
														<p className="table--detail__row--expanded--list-item-value">None</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Data Source</p>
														<p className="table--detail__row--expanded--list-item-value">Globex</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Order key</p>
														<p className="table--detail__row--expanded--list-item-value">561945654</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Exec Qty</p>
														<p className="table--detail__row--expanded--list-item-value">3</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">CTI Code</p>
														<p className="table--detail__row--expanded--list-item-value">1</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">CTI Origin</p>
														<p className="table--detail__row--expanded--list-item-value">3</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Comments</p>
														<p className="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
													</li>
												</ul>
											</div>
											<div className="table--detail__row--stacked--actions">
												<button className="btn btn--transparent  js-table-detail-stacked-trigger">
													<i className="fa fa-angle-double-down"></i>
												</button>
											</div>
										</div>
									</td>
								</tr>
								<tr>
									<td className="table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
									<td className="table--detail--show-md-and-up">Working</td>
									<td className="table--detail--show-md-and-up">08:09:38.890</td>
									<td className="table--detail--show-xs-and-up">45</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">BRIO</td>
									<td className="table--detail--show-lg-and-up">Day</td>
									<td className="table--detail--show-lg-and-up">5330.123456</td>
									<td className="table--detail--disclose"><i className="fa fa-ellipsis-v"></i></td>
								</tr>
								<tr className="table--detail__row--stacked">
									<td colSpan="13">
										<div className="table--detail__row--stacked--container">
											<div className="table--detail__row--stacked--content js-stacked-content">
												<ul className="table--detail__row--expanded--list">
													<li className="table--detail__row--expanded--list-item hide--md-and-up">
														<p className="table--detail__row--expanded--list-item-title">Status</p>
														<p className="table--detail__row--expanded--list-item-value">Working</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--md-and-up">
														<p className="table--detail__row--expanded--list-item-title">Transaction Time</p>
														<p className="table--detail__row--expanded--list-item-value">08:09:38.890</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--xs-and-up">
														<p className="table--detail__row--expanded--list-item-title">Tag 50</p>
														<p className="table--detail__row--expanded--list-item-value">45</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--xs-and-up">
														<p className="table--detail__row--expanded--list-item-title">Qty</p>
														<p className="table--detail__row--expanded--list-item-value">4027</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--lg-and-up">
														<p className="table--detail__row--expanded--list-item-title">Open Qty</p>
														<p className="table--detail__row--expanded--list-item-value">9</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--sm-and-up">
														<p className="table--detail__row--expanded--list-item-title">Contract</p>
														<p className="table--detail__row--expanded--list-item-value">CAUM9 C0775</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--sm-and-up">
														<p className="table--detail__row--expanded--list-item-title">Session ID</p>
														<p className="table--detail__row--expanded--list-item-value">AZT</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--lg-and-up">
														<p className="table--detail__row--expanded--list-item-title">B/S</p>
														<p className="table--detail__row--expanded--list-item-value">BUY</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--lg-and-up">
														<p className="table--detail__row--expanded--list-item-title">Account</p>
														<p className="table--detail__row--expanded--list-item-value">BRIO</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--lg-and-up">
														<p className="table--detail__row--expanded--list-item-title">TIF</p>
														<p className="table--detail__row--expanded--list-item-value">Day</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--lg-and-up">
														<p className="table--detail__row--expanded--list-item-title">Decimal Price</p>
														<p className="table--detail__row--expanded--list-item-value">5330.123456</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Fractional Price</p>
														<p className="table--detail__row--expanded--list-item-value">12345</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Stop Price</p>
														<p className="table--detail__row--expanded--list-item-value">12345</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Exchange</p>
														<p className="table--detail__row--expanded--list-item-value">CME</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Sender</p>
														<p className="table--detail__row--expanded--list-item-value">BRIO</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Cancel Reason</p>
														<p className="table--detail__row--expanded--list-item-value">Expired</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Segment ID</p>
														<p className="table--detail__row--expanded--list-item-value">56</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Firm ID</p>
														<p className="table--detail__row--expanded--list-item-value">004</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Expiry Date</p>
														<p className="table--detail__row--expanded--list-item-value">2018-10-11</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Reject Reason</p>
														<p className="table--detail__row--expanded--list-item-value">None</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Data Source</p>
														<p className="table--detail__row--expanded--list-item-value">Globex</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Order key</p>
														<p className="table--detail__row--expanded--list-item-value">561945654</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Exec Qty</p>
														<p className="table--detail__row--expanded--list-item-value">3</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">CTI Code</p>
														<p className="table--detail__row--expanded--list-item-value">1</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">CTI Origin</p>
														<p className="table--detail__row--expanded--list-item-value">3</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Comments</p>
														<p className="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
													</li>
												</ul>
											</div>
											<div className="table--detail__row--stacked--actions">
												<button className="btn btn--transparent  js-table-detail-stacked-trigger">
													<i className="fa fa-angle-double-down"></i>
												</button>
											</div>
										</div>
									</td>
								</tr>
								<tr>
									<td className="table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
									<td className="table--detail--show-md-and-up">Working</td>
									<td className="table--detail--show-md-and-up">08:09:38.890</td>
									<td className="table--detail--show-xs-and-up">45</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">BRIO</td>
									<td className="table--detail--show-lg-and-up">Day</td>
									<td className="table--detail--show-lg-and-up">5330.123456</td>
									<td className="table--detail--disclose"><i className="fa fa-ellipsis-v"></i></td>
								</tr>
								<tr className="table--detail__row--stacked">
									<td colSpan="13">
										<div className="table--detail__row--stacked--container">
											<div className="table--detail__row--stacked--content js-stacked-content">
												<ul className="table--detail__row--expanded--list">
													<li className="table--detail__row--expanded--list-item hide--md-and-up">
														<p className="table--detail__row--expanded--list-item-title">Status</p>
														<p className="table--detail__row--expanded--list-item-value">Working</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--md-and-up">
														<p className="table--detail__row--expanded--list-item-title">Transaction Time</p>
														<p className="table--detail__row--expanded--list-item-value">08:09:38.890</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--xs-and-up">
														<p className="table--detail__row--expanded--list-item-title">Tag 50</p>
														<p className="table--detail__row--expanded--list-item-value">45</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--xs-and-up">
														<p className="table--detail__row--expanded--list-item-title">Qty</p>
														<p className="table--detail__row--expanded--list-item-value">4027</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--lg-and-up">
														<p className="table--detail__row--expanded--list-item-title">Open Qty</p>
														<p className="table--detail__row--expanded--list-item-value">9</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--sm-and-up">
														<p className="table--detail__row--expanded--list-item-title">Contract</p>
														<p className="table--detail__row--expanded--list-item-value">CAUM9 C0775</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--sm-and-up">
														<p className="table--detail__row--expanded--list-item-title">Session ID</p>
														<p className="table--detail__row--expanded--list-item-value">AZT</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--lg-and-up">
														<p className="table--detail__row--expanded--list-item-title">B/S</p>
														<p className="table--detail__row--expanded--list-item-value">BUY</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--lg-and-up">
														<p className="table--detail__row--expanded--list-item-title">Account</p>
														<p className="table--detail__row--expanded--list-item-value">BRIO</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--lg-and-up">
														<p className="table--detail__row--expanded--list-item-title">TIF</p>
														<p className="table--detail__row--expanded--list-item-value">Day</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--lg-and-up">
														<p className="table--detail__row--expanded--list-item-title">Decimal Price</p>
														<p className="table--detail__row--expanded--list-item-value">5330.123456</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Fractional Price</p>
														<p className="table--detail__row--expanded--list-item-value">12345</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Stop Price</p>
														<p className="table--detail__row--expanded--list-item-value">12345</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Exchange</p>
														<p className="table--detail__row--expanded--list-item-value">CME</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Sender</p>
														<p className="table--detail__row--expanded--list-item-value">BRIO</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Cancel Reason</p>
														<p className="table--detail__row--expanded--list-item-value">Expired</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Segment ID</p>
														<p className="table--detail__row--expanded--list-item-value">56</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Firm ID</p>
														<p className="table--detail__row--expanded--list-item-value">004</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Expiry Date</p>
														<p className="table--detail__row--expanded--list-item-value">2018-10-11</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Reject Reason</p>
														<p className="table--detail__row--expanded--list-item-value">None</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Data Source</p>
														<p className="table--detail__row--expanded--list-item-value">Globex</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Order key</p>
														<p className="table--detail__row--expanded--list-item-value">561945654</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Exec Qty</p>
														<p className="table--detail__row--expanded--list-item-value">3</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">CTI Code</p>
														<p className="table--detail__row--expanded--list-item-value">1</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">CTI Origin</p>
														<p className="table--detail__row--expanded--list-item-value">3</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Comments</p>
														<p className="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
													</li>
												</ul>
											</div>
											<div className="table--detail__row--stacked--actions">
												<button className="btn btn--transparent  js-table-detail-stacked-trigger">
													<i className="fa fa-angle-double-down"></i>
												</button>
											</div>
										</div>
									</td>
								</tr>
								<tr>
									<td className="table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
									<td className="table--detail--show-md-and-up">Working</td>
									<td className="table--detail--show-md-and-up">08:09:38.890</td>
									<td className="table--detail--show-xs-and-up">45</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">BRIO</td>
									<td className="table--detail--show-lg-and-up">Day</td>
									<td className="table--detail--show-lg-and-up">5330.123456</td>
									<td className="table--detail--disclose"><i className="fa fa-ellipsis-v"></i></td>
								</tr>
								<tr className="table--detail__row--stacked">
									<td colSpan="13">
										<div className="table--detail__row--stacked--container">
											<div className="table--detail__row--stacked--content js-stacked-content">
												<ul className="table--detail__row--expanded--list">
													<li className="table--detail__row--expanded--list-item hide--md-and-up">
														<p className="table--detail__row--expanded--list-item-title">Status</p>
														<p className="table--detail__row--expanded--list-item-value">Working</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--md-and-up">
														<p className="table--detail__row--expanded--list-item-title">Transaction Time</p>
														<p className="table--detail__row--expanded--list-item-value">08:09:38.890</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--xs-and-up">
														<p className="table--detail__row--expanded--list-item-title">Tag 50</p>
														<p className="table--detail__row--expanded--list-item-value">45</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--xs-and-up">
														<p className="table--detail__row--expanded--list-item-title">Qty</p>
														<p className="table--detail__row--expanded--list-item-value">4027</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--lg-and-up">
														<p className="table--detail__row--expanded--list-item-title">Open Qty</p>
														<p className="table--detail__row--expanded--list-item-value">9</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--sm-and-up">
														<p className="table--detail__row--expanded--list-item-title">Contract</p>
														<p className="table--detail__row--expanded--list-item-value">CAUM9 C0775</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--sm-and-up">
														<p className="table--detail__row--expanded--list-item-title">Session ID</p>
														<p className="table--detail__row--expanded--list-item-value">AZT</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--lg-and-up">
														<p className="table--detail__row--expanded--list-item-title">B/S</p>
														<p className="table--detail__row--expanded--list-item-value">BUY</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--lg-and-up">
														<p className="table--detail__row--expanded--list-item-title">Account</p>
														<p className="table--detail__row--expanded--list-item-value">BRIO</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--lg-and-up">
														<p className="table--detail__row--expanded--list-item-title">TIF</p>
														<p className="table--detail__row--expanded--list-item-value">Day</p>
													</li>
													<li className="table--detail__row--expanded--list-item hide--lg-and-up">
														<p className="table--detail__row--expanded--list-item-title">Decimal Price</p>
														<p className="table--detail__row--expanded--list-item-value">5330.123456</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Fractional Price</p>
														<p className="table--detail__row--expanded--list-item-value">12345</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Stop Price</p>
														<p className="table--detail__row--expanded--list-item-value">12345</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Exchange</p>
														<p className="table--detail__row--expanded--list-item-value">CME</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Sender</p>
														<p className="table--detail__row--expanded--list-item-value">BRIO</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Cancel Reason</p>
														<p className="table--detail__row--expanded--list-item-value">Expired</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Segment ID</p>
														<p className="table--detail__row--expanded--list-item-value">56</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Firm ID</p>
														<p className="table--detail__row--expanded--list-item-value">004</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Expiry Date</p>
														<p className="table--detail__row--expanded--list-item-value">2018-10-11</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Reject Reason</p>
														<p className="table--detail__row--expanded--list-item-value">None</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Data Source</p>
														<p className="table--detail__row--expanded--list-item-value">Globex</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Order key</p>
														<p className="table--detail__row--expanded--list-item-value">561945654</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Exec Qty</p>
														<p className="table--detail__row--expanded--list-item-value">3</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">CTI Code</p>
														<p className="table--detail__row--expanded--list-item-value">1</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">CTI Origin</p>
														<p className="table--detail__row--expanded--list-item-value">3</p>
													</li>
													<li className="table--detail__row--expanded--list-item">
														<p className="table--detail__row--expanded--list-item-title">Comments</p>
														<p className="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
													</li>
												</ul>
											</div>
											<div className="table--detail__row--stacked--actions">
												<button className="btn btn--transparent  js-table-detail-stacked-trigger">
													<i className="fa fa-angle-double-down"></i>
												</button>
											</div>
										</div>
									</td>
								</tr>
								<tr>
									<td className="table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
									<td className="table--detail--show-md-and-up">Normal Row</td>
									<td className="table--detail--show-md-and-up">08:09:38.890</td>
									<td className="table--detail--show-xs-and-up">45</td>
									<td className="table--detail--show-xs-and-up">4027</td>
									<td className="table--detail--show-lg-and-up">9</td>
									<td className="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
									<td className="table--detail--show-sm-and-up">AZT</td>
									<td className="table--detail--show-sm-and-up">BUY</td>
									<td className="table--detail--show-lg-and-up">BRIO</td>
									<td className="table--detail--show-lg-and-up">Day</td>
									<td className="table--detail--show-lg-and-up">5330.123456</td>
									<td className="table--detail--disclose"></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<br/><br/>
		<p>In the demo shown here, you can see primary and secondary information is always visible but in a similiar fashion to the other types of detail view, you
		can specify what columns are visible at certain <a href="#breakpoints">breakpoints</a> using the <code>table--detail--show-['breakpoint']</code> CSS class.</p>
		<br/>
		<select className="size-select">
			<option value="">Select a resolution</option>
			<option value="482">480px (xs)</option>
			<option value="770">768px (sm)</option>
			<option value="994">992px (md)</option>
			<option value="1202">1200px (lg)</option>
		</select>
		<br/><br/>
		<div className="iframe-container" style={{ 'height': '500px' }}>
			<iframe seamless srcDoc={`
				<html class="height--100">
					<head>
						<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
						<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
						<link rel="stylesheet" type="text/css" href="css/commonUI.css">
					</head>
					<body class="height--100">
						<div class="table--detail--container">
							<div class="grid height--100">
								<div class="position--relative grid__col-12 height--100">
									<table class="table table--blue table--comfy table--hover table--expanded--striped table--rows table--detail table--detail__expanded--stacked js-table-detail-stacked">
										<thead>
											<tr>
												<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Client Order ID</th>
												<th class="table--detail--show-md-and-up">Status</th>
												<th class="table--detail--show-md-and-up">Transaction Time</th>
												<th class="table--detail--show-xs-and-up">Tag 50</th>
												<th class="table--detail--show-xs-and-up">Qty</th>
												<th class="table--detail--show-lg-and-up">Open Qty</th>
												<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Contract</th>
												<th class="table--detail--show-sm-and-up">Session ID</th>
												<th class="table--detail--show-sm-and-up">B/S</th>
												<th class="table--detail--show-lg-and-up">Account</th>
												<th class="table--detail--show-lg-and-up">TIF</th>
												<th class="table--detail--show-lg-and-up">Decimal Price</th>
												<th class="table--detail--disclose"></th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td class="table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
												<td class="table--detail--show-md-and-up">Working</td>
												<td class="table--detail--show-md-and-up">08:09:38.890</td>
												<td class="table--detail--show-xs-and-up">45</td>
												<td class="table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">BRIO</td>
												<td class="table--detail--show-lg-and-up">Day</td>
												<td class="table--detail--show-lg-and-up">5330.123456</td>
												<td class="table--detail--disclose"><i class="fa fa-ellipsis-v"></i></td>
											</tr>
											<tr class="table--detail__row--stacked">
												<td colSpan="13">
													<div class="table--detail__row--stacked--container">
														<div class="table--detail__row--stacked--content js-stacked-content">
															<ul class="table--detail__row--expanded--list">
																<li class="table--detail__row--expanded--list-item hide--md-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Status</p>
																	<p class="table--detail__row--expanded--list-item-value">Working</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--md-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Transaction Time</p>
																	<p class="table--detail__row--expanded--list-item-value">08:09:38.890</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Tag 50</p>
																	<p class="table--detail__row--expanded--list-item-value">45</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Qty</p>
																	<p class="table--detail__row--expanded--list-item-value">4027</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Open Qty</p>
																	<p class="table--detail__row--expanded--list-item-value">9</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Contract</p>
																	<p class="table--detail__row--expanded--list-item-value">CAUM9 C0775</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Session ID</p>
																	<p class="table--detail__row--expanded--list-item-value">AZT</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																	<p class="table--detail__row--expanded--list-item-title">B/S</p>
																	<p class="table--detail__row--expanded--list-item-value">BUY</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Account</p>
																	<p class="table--detail__row--expanded--list-item-value">BRIO</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																	<p class="table--detail__row--expanded--list-item-title">TIF</p>
																	<p class="table--detail__row--expanded--list-item-value">Day</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Decimal Price</p>
																	<p class="table--detail__row--expanded--list-item-value">5330.123456</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Fractional Price</p>
																	<p class="table--detail__row--expanded--list-item-value">12345</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Stop Price</p>
																	<p class="table--detail__row--expanded--list-item-value">12345</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Exchange</p>
																	<p class="table--detail__row--expanded--list-item-value">CME</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Sender</p>
																	<p class="table--detail__row--expanded--list-item-value">BRIO</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Cancel Reason</p>
																	<p class="table--detail__row--expanded--list-item-value">Expired</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Segment ID</p>
																	<p class="table--detail__row--expanded--list-item-value">56</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Firm ID</p>
																	<p class="table--detail__row--expanded--list-item-value">004</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Expiry Date</p>
																	<p class="table--detail__row--expanded--list-item-value">2018-10-11</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Reject Reason</p>
																	<p class="table--detail__row--expanded--list-item-value">None</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Data Source</p>
																	<p class="table--detail__row--expanded--list-item-value">Globex</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Order key</p>
																	<p class="table--detail__row--expanded--list-item-value">561945654</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Exec Qty</p>
																	<p class="table--detail__row--expanded--list-item-value">3</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">CTI Code</p>
																	<p class="table--detail__row--expanded--list-item-value">1</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">CTI Origin</p>
																	<p class="table--detail__row--expanded--list-item-value">3</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Comments</p>
																	<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
																</li>
															</ul>
														</div>
														<div class="table--detail__row--stacked--actions">
															<button class="btn btn--transparent  js-table-detail-stacked-trigger">
																<i class="fa fa-angle-double-down"></i>
															</button>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td class="table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
												<td class="table--detail--show-md-and-up">Working</td>
												<td class="table--detail--show-md-and-up">08:09:38.890</td>
												<td class="table--detail--show-xs-and-up">45</td>
												<td class="table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">BRIO</td>
												<td class="table--detail--show-lg-and-up">Day</td>
												<td class="table--detail--show-lg-and-up">5330.123456</td>
												<td class="table--detail--disclose"><i class="fa fa-trash-o"></i></td>
											</tr>
											<tr class="table--detail__row--stacked">
												<td colSpan="13">
													<div class="table--detail__row--stacked--container">
														<div class="table--detail__row--stacked--content js-stacked-content">
															<ul class="table--detail__row--expanded--list">
																<li class="table--detail__row--expanded--list-item hide--md-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Status</p>
																	<p class="table--detail__row--expanded--list-item-value">Working</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--md-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Transaction Time</p>
																	<p class="table--detail__row--expanded--list-item-value">08:09:38.890</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Tag 50</p>
																	<p class="table--detail__row--expanded--list-item-value">45</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Qty</p>
																	<p class="table--detail__row--expanded--list-item-value">4027</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Open Qty</p>
																	<p class="table--detail__row--expanded--list-item-value">9</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Contract</p>
																	<p class="table--detail__row--expanded--list-item-value">CAUM9 C0775</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Session ID</p>
																	<p class="table--detail__row--expanded--list-item-value">AZT</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																	<p class="table--detail__row--expanded--list-item-title">B/S</p>
																	<p class="table--detail__row--expanded--list-item-value">BUY</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Account</p>
																	<p class="table--detail__row--expanded--list-item-value">BRIO</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																	<p class="table--detail__row--expanded--list-item-title">TIF</p>
																	<p class="table--detail__row--expanded--list-item-value">Day</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Decimal Price</p>
																	<p class="table--detail__row--expanded--list-item-value">5330.123456</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Fractional Price</p>
																	<p class="table--detail__row--expanded--list-item-value">12345</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Stop Price</p>
																	<p class="table--detail__row--expanded--list-item-value">12345</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Exchange</p>
																	<p class="table--detail__row--expanded--list-item-value">CME</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Sender</p>
																	<p class="table--detail__row--expanded--list-item-value">BRIO</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Cancel Reason</p>
																	<p class="table--detail__row--expanded--list-item-value">Expired</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Segment ID</p>
																	<p class="table--detail__row--expanded--list-item-value">56</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Firm ID</p>
																	<p class="table--detail__row--expanded--list-item-value">004</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Expiry Date</p>
																	<p class="table--detail__row--expanded--list-item-value">2018-10-11</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Reject Reason</p>
																	<p class="table--detail__row--expanded--list-item-value">None</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Data Source</p>
																	<p class="table--detail__row--expanded--list-item-value">Globex</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Order key</p>
																	<p class="table--detail__row--expanded--list-item-value">561945654</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Exec Qty</p>
																	<p class="table--detail__row--expanded--list-item-value">3</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">CTI Code</p>
																	<p class="table--detail__row--expanded--list-item-value">1</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">CTI Origin</p>
																	<p class="table--detail__row--expanded--list-item-value">3</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Comments</p>
																	<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
																</li>
															</ul>
														</div>
														<div class="table--detail__row--stacked--actions">
															<button class="btn btn--transparent  js-table-detail-stacked-trigger">
																<i class="fa fa-angle-double-down"></i>
															</button>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td class="table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
												<td class="table--detail--show-md-and-up">Working</td>
												<td class="table--detail--show-md-and-up">08:09:38.890</td>
												<td class="table--detail--show-xs-and-up">45</td>
												<td class="table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">BRIO</td>
												<td class="table--detail--show-lg-and-up">Day</td>
												<td class="table--detail--show-lg-and-up">5330.123456</td>
												<td class="table--detail--disclose"><i class="fa fa-ellipsis-v"></i></td>
											</tr>
											<tr class="table--detail__row--stacked">
												<td colSpan="13">
													<div class="table--detail__row--stacked--container">
														<div class="table--detail__row--stacked--content js-stacked-content">
															<ul class="table--detail__row--expanded--list">
																<li class="table--detail__row--expanded--list-item hide--md-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Status</p>
																	<p class="table--detail__row--expanded--list-item-value">Working</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--md-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Transaction Time</p>
																	<p class="table--detail__row--expanded--list-item-value">08:09:38.890</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Tag 50</p>
																	<p class="table--detail__row--expanded--list-item-value">45</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Qty</p>
																	<p class="table--detail__row--expanded--list-item-value">4027</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Open Qty</p>
																	<p class="table--detail__row--expanded--list-item-value">9</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Contract</p>
																	<p class="table--detail__row--expanded--list-item-value">CAUM9 C0775</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Session ID</p>
																	<p class="table--detail__row--expanded--list-item-value">AZT</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																	<p class="table--detail__row--expanded--list-item-title">B/S</p>
																	<p class="table--detail__row--expanded--list-item-value">BUY</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Account</p>
																	<p class="table--detail__row--expanded--list-item-value">BRIO</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																	<p class="table--detail__row--expanded--list-item-title">TIF</p>
																	<p class="table--detail__row--expanded--list-item-value">Day</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Decimal Price</p>
																	<p class="table--detail__row--expanded--list-item-value">5330.123456</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Fractional Price</p>
																	<p class="table--detail__row--expanded--list-item-value">12345</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Stop Price</p>
																	<p class="table--detail__row--expanded--list-item-value">12345</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Exchange</p>
																	<p class="table--detail__row--expanded--list-item-value">CME</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Sender</p>
																	<p class="table--detail__row--expanded--list-item-value">BRIO</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Cancel Reason</p>
																	<p class="table--detail__row--expanded--list-item-value">Expired</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Segment ID</p>
																	<p class="table--detail__row--expanded--list-item-value">56</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Firm ID</p>
																	<p class="table--detail__row--expanded--list-item-value">004</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Expiry Date</p>
																	<p class="table--detail__row--expanded--list-item-value">2018-10-11</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Reject Reason</p>
																	<p class="table--detail__row--expanded--list-item-value">None</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Data Source</p>
																	<p class="table--detail__row--expanded--list-item-value">Globex</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Order key</p>
																	<p class="table--detail__row--expanded--list-item-value">561945654</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Exec Qty</p>
																	<p class="table--detail__row--expanded--list-item-value">3</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">CTI Code</p>
																	<p class="table--detail__row--expanded--list-item-value">1</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">CTI Origin</p>
																	<p class="table--detail__row--expanded--list-item-value">3</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Comments</p>
																	<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
																</li>
															</ul>
														</div>
														<div class="table--detail__row--stacked--actions">
															<button class="btn btn--transparent  js-table-detail-stacked-trigger">
																<i class="fa fa-angle-double-down"></i>
															</button>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td class="table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
												<td class="table--detail--show-md-and-up">Working</td>
												<td class="table--detail--show-md-and-up">08:09:38.890</td>
												<td class="table--detail--show-xs-and-up">45</td>
												<td class="table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">BRIO</td>
												<td class="table--detail--show-lg-and-up">Day</td>
												<td class="table--detail--show-lg-and-up">5330.123456</td>
												<td class="table--detail--disclose"><i class="fa fa-trash-o"></i></td>
											</tr>
											<tr class="table--detail__row--stacked">
												<td colSpan="13">
													<div class="table--detail__row--stacked--container">
														<div class="table--detail__row--stacked--content js-stacked-content">
															<ul class="table--detail__row--expanded--list">
																<li class="table--detail__row--expanded--list-item hide--md-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Status</p>
																	<p class="table--detail__row--expanded--list-item-value">Working</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--md-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Transaction Time</p>
																	<p class="table--detail__row--expanded--list-item-value">08:09:38.890</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Tag 50</p>
																	<p class="table--detail__row--expanded--list-item-value">45</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--xs-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Qty</p>
																	<p class="table--detail__row--expanded--list-item-value">4027</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Open Qty</p>
																	<p class="table--detail__row--expanded--list-item-value">9</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Contract</p>
																	<p class="table--detail__row--expanded--list-item-value">CAUM9 C0775</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--sm-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Session ID</p>
																	<p class="table--detail__row--expanded--list-item-value">AZT</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																	<p class="table--detail__row--expanded--list-item-title">B/S</p>
																	<p class="table--detail__row--expanded--list-item-value">BUY</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Account</p>
																	<p class="table--detail__row--expanded--list-item-value">BRIO</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																	<p class="table--detail__row--expanded--list-item-title">TIF</p>
																	<p class="table--detail__row--expanded--list-item-value">Day</p>
																</li>
																<li class="table--detail__row--expanded--list-item hide--lg-and-up">
																	<p class="table--detail__row--expanded--list-item-title">Decimal Price</p>
																	<p class="table--detail__row--expanded--list-item-value">5330.123456</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Fractional Price</p>
																	<p class="table--detail__row--expanded--list-item-value">12345</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Stop Price</p>
																	<p class="table--detail__row--expanded--list-item-value">12345</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Exchange</p>
																	<p class="table--detail__row--expanded--list-item-value">CME</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Sender</p>
																	<p class="table--detail__row--expanded--list-item-value">BRIO</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Cancel Reason</p>
																	<p class="table--detail__row--expanded--list-item-value">Expired</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Segment ID</p>
																	<p class="table--detail__row--expanded--list-item-value">56</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Firm ID</p>
																	<p class="table--detail__row--expanded--list-item-value">004</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Expiry Date</p>
																	<p class="table--detail__row--expanded--list-item-value">2018-10-11</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Reject Reason</p>
																	<p class="table--detail__row--expanded--list-item-value">None</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Data Source</p>
																	<p class="table--detail__row--expanded--list-item-value">Globex</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Order key</p>
																	<p class="table--detail__row--expanded--list-item-value">561945654</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Exec Qty</p>
																	<p class="table--detail__row--expanded--list-item-value">3</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">CTI Code</p>
																	<p class="table--detail__row--expanded--list-item-value">1</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">CTI Origin</p>
																	<p class="table--detail__row--expanded--list-item-value">3</p>
																</li>
																<li class="table--detail__row--expanded--list-item">
																	<p class="table--detail__row--expanded--list-item-title">Comments</p>
																	<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
																</li>
															</ul>
														</div>
														<div class="table--detail__row--stacked--actions">
															<button class="btn btn--transparent  js-table-detail-stacked-trigger">
																<i class="fa fa-angle-double-down"></i>
															</button>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td class="table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
												<td class="table--detail--show-md-and-up">Normal Row</td>
												<td class="table--detail--show-md-and-up">08:09:38.890</td>
												<td class="table--detail--show-xs-and-up">45</td>
												<td class="table--detail--show-xs-and-up">4027</td>
												<td class="table--detail--show-lg-and-up">9</td>
												<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
												<td class="table--detail--show-sm-and-up">AZT</td>
												<td class="table--detail--show-sm-and-up">BUY</td>
												<td class="table--detail--show-lg-and-up">BRIO</td>
												<td class="table--detail--show-lg-and-up">Day</td>
												<td class="table--detail--show-lg-and-up">5330.123456</td>
												<td class="table--detail--disclose"></td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
						<script type="text/javascript" src="js/commonUI.js"></script>
						<script>
							function init() {
								commonUI.initializeTable({
									selector: '.js-table-detail-stacked',
									detailViewType: 'stackedRow',
									detailViewSelector: '.js-table-detail-stacked-trigger'
								});
							}
							window.onload = init;
						</script>
					</body>
				</html>
			`}></iframe>
		</div><br/>
		<p>To enable this functionality, you can instantiate the table like this:</p>
		<pre><code className="language-javascript">{`commonUI.initializeTable({
	selector: '.js-table-detail-stacked',
	detailViewType: 'stackedRow',
	detailViewSelector: '.js-table-detail-stacked-trigger'
});`}</code></pre>
		<br/>
		<button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
		<pre className="hide-code"><code className="language-html">{`<table class="table table--blue table--comfy table--hover table--expanded--striped table--rows table--detail table--detail__expanded--stacked js-table-detail-stacked">
<thead>
	<tr>
		<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Client Order ID</th>
		<th class="table--detail--show-md-and-up">Status</th>
		<th class="table--detail--show-md-and-up">Transaction Time</th>
		<th class="table--detail--show-xs-and-up">Tag 50</th>
		<th class="table--detail--show-xs-and-up">Qty</th>
		<th class="table--detail--show-lg-and-up">Open Qty</th>
		<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Contract</th>
		<th class="table--detail--show-sm-and-up">Session ID</th>
		<th class="table--detail--show-sm-and-up">B/S</th>
		<th class="table--detail--show-lg-and-up">Account</th>
		<th class="table--detail--show-lg-and-up">TIF</th>
		<th class="table--detail--show-lg-and-up">Decimal Price</th>
		<th class="table--detail--disclose"></th>
	</tr>
</thead>
<tbody>
	<tr>
		<td class="table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>
		<td class="table--detail--show-md-and-up">Working</td>
		<td class="table--detail--show-md-and-up">08:09:38.890</td>
		<td class="table--detail--show-xs-and-up">45</td>
		<td class="table--detail--show-xs-and-up">4027</td>
		<td class="table--detail--show-lg-and-up">9</td>
		<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>
		<td class="table--detail--show-sm-and-up">AZT</td>
		<td class="table--detail--show-sm-and-up">BUY</td>
		<td class="table--detail--show-lg-and-up">BRIO</td>
		<td class="table--detail--show-lg-and-up">Day</td>
		<td class="table--detail--show-lg-and-up">5330.123456</td>
		<td class="table--detail--disclose"><i class="fa fa-ellipsis-v"></i></td>
	</tr>
	<tr class="table--detail__row--stacked">
		<td colSpan="13">
			<div class="table--detail__row--stacked--container">
				<div class="table--detail__row--stacked--content js-stacked-content">
					<ul class="table--detail__row--expanded--list">
						<li class="table--detail__row--expanded--list-item hide--md-and-up">
							<p class="table--detail__row--expanded--list-item-title">Status</p>
							<p class="table--detail__row--expanded--list-item-value">Working</p>
						</li>
						<li class="table--detail__row--expanded--list-item hide--md-and-up">
							<p class="table--detail__row--expanded--list-item-title">Transaction Time</p>
							<p class="table--detail__row--expanded--list-item-value">08:09:38.890</p>
						</li>
						<li class="table--detail__row--expanded--list-item hide--xs-and-up">
							<p class="table--detail__row--expanded--list-item-title">Tag 50</p>
							<p class="table--detail__row--expanded--list-item-value">45</p>
						</li>
						<li class="table--detail__row--expanded--list-item hide--xs-and-up">
							<p class="table--detail__row--expanded--list-item-title">Qty</p>
							<p class="table--detail__row--expanded--list-item-value">4027</p>
						</li>
						<li class="table--detail__row--expanded--list-item hide--lg-and-up">
							<p class="table--detail__row--expanded--list-item-title">Open Qty</p>
							<p class="table--detail__row--expanded--list-item-value">9</p>
						</li>
						<li class="table--detail__row--expanded--list-item hide--sm-and-up">
							<p class="table--detail__row--expanded--list-item-title">Contract</p>
							<p class="table--detail__row--expanded--list-item-value">CAUM9 C0775</p>
						</li>
						<li class="table--detail__row--expanded--list-item hide--sm-and-up">
							<p class="table--detail__row--expanded--list-item-title">Session ID</p>
							<p class="table--detail__row--expanded--list-item-value">AZT</p>
						</li>
						<li class="table--detail__row--expanded--list-item hide--lg-and-up">
							<p class="table--detail__row--expanded--list-item-title">B/S</p>
							<p class="table--detail__row--expanded--list-item-value">BUY</p>
						</li>
						<li class="table--detail__row--expanded--list-item hide--lg-and-up">
							<p class="table--detail__row--expanded--list-item-title">Account</p>
							<p class="table--detail__row--expanded--list-item-value">BRIO</p>
						</li>
						<li class="table--detail__row--expanded--list-item hide--lg-and-up">
							<p class="table--detail__row--expanded--list-item-title">TIF</p>
							<p class="table--detail__row--expanded--list-item-value">Day</p>
						</li>
						<li class="table--detail__row--expanded--list-item hide--lg-and-up">
							<p class="table--detail__row--expanded--list-item-title">Decimal Price</p>
							<p class="table--detail__row--expanded--list-item-value">5330.123456</p>
						</li>
						<li class="table--detail__row--expanded--list-item">
							<p class="table--detail__row--expanded--list-item-title">Fractional Price</p>
							<p class="table--detail__row--expanded--list-item-value">12345</p>
						</li>
						<li class="table--detail__row--expanded--list-item">
							<p class="table--detail__row--expanded--list-item-title">Stop Price</p>
							<p class="table--detail__row--expanded--list-item-value">12345</p>
						</li>
						<li class="table--detail__row--expanded--list-item">
							<p class="table--detail__row--expanded--list-item-title">Exchange</p>
							<p class="table--detail__row--expanded--list-item-value">CME</p>
						</li>
						<li class="table--detail__row--expanded--list-item">
							<p class="table--detail__row--expanded--list-item-title">Sender</p>
							<p class="table--detail__row--expanded--list-item-value">BRIO</p>
						</li>
						<li class="table--detail__row--expanded--list-item">
							<p class="table--detail__row--expanded--list-item-title">Cancel Reason</p>
							<p class="table--detail__row--expanded--list-item-value">Expired</p>
						</li>
						<li class="table--detail__row--expanded--list-item">
							<p class="table--detail__row--expanded--list-item-title">Segment ID</p>
							<p class="table--detail__row--expanded--list-item-value">56</p>
						</li>
						<li class="table--detail__row--expanded--list-item">
							<p class="table--detail__row--expanded--list-item-title">Firm ID</p>
							<p class="table--detail__row--expanded--list-item-value">004</p>
						</li>
						<li class="table--detail__row--expanded--list-item">
							<p class="table--detail__row--expanded--list-item-title">Expiry Date</p>
							<p class="table--detail__row--expanded--list-item-value">2018-10-11</p>
						</li>
						<li class="table--detail__row--expanded--list-item">
							<p class="table--detail__row--expanded--list-item-title">Reject Reason</p>
							<p class="table--detail__row--expanded--list-item-value">None</p>
						</li>
						<li class="table--detail__row--expanded--list-item">
							<p class="table--detail__row--expanded--list-item-title">Data Source</p>
							<p class="table--detail__row--expanded--list-item-value">Globex</p>
						</li>
						<li class="table--detail__row--expanded--list-item">
							<p class="table--detail__row--expanded--list-item-title">Order key</p>
							<p class="table--detail__row--expanded--list-item-value">561945654</p>
						</li>
						<li class="table--detail__row--expanded--list-item">
							<p class="table--detail__row--expanded--list-item-title">Exec Qty</p>
							<p class="table--detail__row--expanded--list-item-value">3</p>
						</li>
						<li class="table--detail__row--expanded--list-item">
							<p class="table--detail__row--expanded--list-item-title">CTI Code</p>
							<p class="table--detail__row--expanded--list-item-value">1</p>
						</li>
						<li class="table--detail__row--expanded--list-item">
							<p class="table--detail__row--expanded--list-item-title">CTI Origin</p>
							<p class="table--detail__row--expanded--list-item-value">3</p>
						</li>
						<li class="table--detail__row--expanded--list-item">
							<p class="table--detail__row--expanded--list-item-title">Comments</p>
							<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>
						</li>
					</ul>
				</div>
				<div class="table--detail__row--stacked--actions">
					<button class="btn btn--transparent  js-table-detail-stacked-trigger">
						<i class="fa fa-angle-double-down"></i>
					</button>
				</div>
			</div>
		</td>
	</tr>
	</tbody>
</table>`}</code></pre>
		<br/>

		<h4>Table with Reorder Functionality</h4>
		<p>
			To enable the table reorder functionality, add a unique class to the table such as <code>js-table-reorder</code> in addition to a unique overlay class
			such as <code>example-overlay</code> and a trigger class such as <code>trigger-one</code>. To Disable a row from being reordered, use the
			helper <code>table__heading--disable</code>. We recommend that you only apply this to the first few columns in the table. This will Automatically disable the
			button within the reorder overlay. <code>table--reorder--show-row</code> will ensure the button is selected in the overlay when it is opened.
		</p>
		<p>
			The default columns for the overlay will be set to 2. It is possible to change this to 1 column by adding <code>reorder__table--single-col</code> to the main
			parent class along side the <code>reorder__table</code> class.
		</p>
		<div className="reorder__table">
			<button className="btn btn--link js-table-overlay-trigger"><i className="fa fa-table"></i> Edit Table Order</button>
			<div className="reorder__table--container">
				<table className="table table--blue table--comfy table--hover table--striped table--responsive js-table-reorder">
					<thead>
						<tr>
							<th className="table__heading--disable table--reorder--show-row">Client Order ID</th>
							<th className="table__heading--disable table--reorder--show-row">Fill ID</th>
							<th className="table--reorder--show-row">Status</th>
							<th className="table--reorder--show-row ">Fill Time</th>
							<th className="table--reorder--show-row">Tag 50</th>
							<th className="table--reorder--show-row">Fill Qty</th>
							<th className="table--reorder--show-row">Contract</th>
							<th className="table--reorder--show-row">Session ID</th>
							<th className="table--reorder--show-row">B/S</th>
							<th className="table--reorder--show-row">Order Price</th>
							<th className="table--reorder--show-row">Stop Price</th>
							<th className="table--reorder--show-row">Time In Force</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<th scope="row">
								<a href="">ACP15299318869</a>
							</th>
							<td>8446:M:126561</td>
							<td className="text--center">Partial Fill</td>
							<td>08:04:46.900</td>
							<td>OPERATORID123</td>
							<td>100</td>
							<td>CAUM9 C0775</td>
							<td>AZT</td>
							<td>BUY</td>
							<td>00331</td>
							<td>6116</td>
							<td>Day</td>
						</tr>
						<tr>
							<th scope="row">
								<a href="">ACP15524945547</a>
							</th>
							<td>80517:M:301326</td>
							<td className="text--center">Filled</td>
							<td>08:05:12.010</td>
							<td>OPERATORIDCME2</td>
							<td>50</td>
							<td>CAUM9 C0860</td>
							<td>R89</td>
							<td>SELL</td>
							<td>00147</td>
							<td>1332</td>
							<td>1332</td>
						</tr>
						<tr>
							<th scope="row">
								<a href="">ACP15299318869</a>
							</th>
							<td>8446:M:126561</td>
							<td className="text--center">Partial Fill</td>
							<td>08:04:46.900</td>
							<td>OPERATORID123</td>
							<td>100</td>
							<td>CAUM9 C0775</td>
							<td>AZT</td>
							<td>BUY</td>
							<td>00331</td>
							<td>6116</td>
						<td>Day</td>
						</tr>
						<tr>
							<th scope="row">
								<a href="">ACP15524945547</a>
							</th>
							<td>80517:M:301326</td>
							<td className="text--center">Filled</td>
							<td>08:05:12.010</td>
							<td>OPERATORIDCME2</td>
							<td>50</td>
							<td>CAUM9 C0860</td>
							<td>R89</td>
							<td>SELL</td>
							<td>00147</td>
							<td>1332</td>
							<td>1332</td>
						</tr>
						<tr>
							<th scope="row">
								<a href="">ACP15299318869</a>
							</th>
							<td>8446:M:126561</td>
							<td className="text--center">Partial Fill</td>
							<td>08:04:46.900</td>
							<td>OPERATORID123</td>
							<td>100</td>
							<td>CAUM9 C0775</td>
							<td>AZT</td>
							<td>BUY</td>
							<td>00331</td>
							<td>6116</td>
							<td>Day</td>
						</tr>
						<tr>
							<th scope="row">
								<a href="">ACP15524945547</a>
							</th>
							<td>80517:M:301326</td>
							<td className="text--center">Filled</td>
							<td>08:05:12.010</td>
							<td>OPERATORIDCME2</td>
							<td>50</td>
							<td>CAUM9 C0860</td>
							<td>R89</td>
							<td>SELL</td>
							<td>00147</td>
							<td>1332</td>
							<td>1332</td>
						</tr>
						<tr>
							<th scope="row">
								<a href="">ACP15299318869</a>
							</th>
							<td>8446:M:126561</td>
							<td className="text--center">Partial Fill</td>
							<td>08:04:46.900</td>
							<td>OPERATORID123</td>
							<td>100</td>
							<td>CAUM9 C0775</td>
							<td>AZT</td>
							<td>BUY</td>
							<td>00331</td>
							<td>6116</td>
							<td>Day</td>
						</tr>
						<tr>
							<th scope="row">
								<a href="">ACP15524945547</a>
							</th>
							<td>80517:M:301326</td>
							<td className="text--center">Filled</td>
							<td>08:05:12.010</td>
							<td>OPERATORIDCME2</td>
							<td>50</td>
							<td>CAUM9 C0860</td>
							<td>R89</td>
							<td>SELL</td>
							<td>00147</td>
							<td>1332</td>
							<td>1332</td>
						</tr>
						<tr>
							<th scope="row">
								<a href="">ACP15299318869</a>
							</th>
							<td>8446:M:126561</td>
							<td className="text--center">Partial Fill</td>
							<td>08:04:46.900</td>
							<td>OPERATORID123</td>
							<td>100</td>
							<td>CAUM9 C0775</td>
							<td>AZT</td>
							<td>BUY</td>
							<td>00331</td>
							<td>6116</td>
							<td>Day</td>
						</tr>
						<tr>
							<th scope="row">
								<a href="">ACP15524945547</a>
							</th>
							<td>80517:M:301326</td>
							<td className="text--center">Filled</td>
							<td>08:05:12.010</td>
							<td>OPERATORIDCME2</td>
							<td>50</td>
							<td>CAUM9 C0860</td>
							<td>R89</td>
							<td>SELL</td>
							<td>00147</td>
							<td>1332</td>
							<td>1332</td>
						</tr>
						<tr>
							<th scope="row">
								<a href="">ACP15299318869</a>
							</th>
							<td>8446:M:126561</td>
							<td className="text--center">Partial Fill</td>
							<td>08:04:46.900</td>
							<td>OPERATORID123</td>
							<td>100</td>
							<td>CAUM9 C0775</td>
							<td>AZT</td>
							<td>BUY</td>
							<td>00331</td>
							<td>6116</td>
							<td>Day</td>
						</tr>
						<tr>
							<th scope="row">
								<a href="">ACP15524945547</a>
							</th>
							<td>80517:M:301326</td>
							<td className="text--center">Filled</td>
							<td>08:05:12.010</td>
							<td>OPERATORIDCME2</td>
							<td>50</td>
							<td>CAUM9 C0860</td>
							<td>R89</td>
							<td>SELL</td>
							<td>00147</td>
							<td>1332</td>
							<td>1332</td>
						</tr>
						<tr>
							<th scope="row">
								<a href="">ACP15299318869</a>
							</th>
							<td>8446:M:126561</td>
							<td className="text--center">Partial Fill</td>
							<td>08:04:46.900</td>
							<td>OPERATORID123</td>
							<td>100</td>
							<td>CAUM9 C0775</td>
							<td>AZT</td>
							<td>BUY</td>
							<td>00331</td>
							<td>6116</td>
							<td>Day</td>
						</tr>
						<tr>
							<th scope="row">
								<a href="">ACP15524945547</a>
							</th>
							<td>80517:M:301326</td>
							<td className="text--center">Filled</td>
							<td>08:05:12.010</td>
							<td>OPERATORIDCME2</td>
							<td>50</td>
							<td>CAUM9 C0860</td>
							<td>R89</td>
							<td>SELL</td>
							<td>00147</td>
							<td>1332</td>
							<td>1332</td>
						</tr>
					</tbody>
				</table>
				<div className="overlay__table example-overlay">
					<div className="overlay__table--left"></div>
					<div className="overlay__table--right table--comfy">
						<div className="overlay__table--title"><i className="fa fa-table" aria-hidden="true"></i>Edit Table Order<i className="icon-cme-close-circle-o overlay__table--close"></i></div>
						<div className="overlay__table--main">
							Customise this table by choosing which columns to display, and in which order
							<ul className="overlay__table--options">
								<li className="options-group-item">
									<i className="fa fa-square-o select-all" aria-hidden="true"></i>
									<label className="overlay__table--select-all select-all">Select All</label>
								</li>
								<li className="options-group-item">
									<button className="btn btn--link reset-to-default"><i className="fa fa-repeat"></i> Reset to Default</button>
								</li>
							</ul>
						</div>
						<div className="overlay__table--actions">
							<button className="btn btn--secondary overlay__table--cancel">Cancel</button>
							<button className="btn btn--positive apply--reorder trigger-one"><i className="fa fa-check"></i> Apply Changes</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<br/><br/>
		<p>In the demo shown here, you can see the ability to still reorder columns at certain <a href="#breakpoints">breakpoints</a>.</p>
		<br/>
		<select className="size-select">
			<option value="">Select a resolution</option>
			<option value="482">480px (xs)</option>
			<option value="770">768px (sm)</option>
			<option value="994">992px (md)</option>
			<option value="1202">1200px (lg)</option>
		</select>
		<br/><br/>
		<div className="iframe-container" style={{ 'height': '500px' }}>
			<iframe seamless srcDoc={`
			<html class="height--100">
					<head>
						<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
						<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
						<link rel="stylesheet" type="text/css" href="css/commonUI.css">
					</head>
					<body class="height--100">
						<div class="table--detail--container">
							<div class="grid height--100">
								<div class="position--relative grid__col-12 height--100">
								<div class="reorder__table">
									<button class="btn btn--link js-table-overlay-trigger"><i class="fa fa-table"></i> Edit Table Order</button>
									<div class="reorder__table--container">
										<table class="table table--blue table--comfy table--hover table--striped table--responsive js-table--responsive js-table-reorder-two table--reorder">
											<thead>
												<tr>
													<th class="table__heading--disable table--reorder--show-row">Client Order ID</th>
													<th class="table__heading--disable table--reorder--show-row">Fill ID</th>
													<th class="table--reorder--show-row">Status</th>
													<th class="table--reorder--show-row ">Fill Time</th>
													<th class="table--reorder--show-row">Tag 50</th>
													<th class="table--reorder--show-row">Fill Qty</th>
													<th class="table--reorder--show-row">Contract</th>
													<th class="table--reorder--show-row">Session ID</th>
													<th class="table--reorder--show-row">B/S</th>
													<th class="table--reorder--show-row">Order Price</th>
													<th class="table--reorder--show-row">Stop Price</th>
													<th class="table--reorder--show-row">Time In Force</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<th scope="row">
														<a href="">ACP15299318869</a>
													</th>
													<td>8446:M:126561</td>
													<td className="text--center">Partial Fill</td>
													<td>08:04:46.900</td>
													<td>OPERATORID123</td>
													<td>100</td>
													<td>CAUM9 C0775</td>
													<td>AZT</td>
													<td>BUY</td>
													<td>00331</td>
													<td>6116</td>
													<td>Day</td>
												</tr>
												<tr>
													<th scope="row">
														<a href="">ACP15524945547</a>
													</th>
													<td>80517:M:301326</td>
													<td className="text--center">Filled</td>
													<td>08:05:12.010</td>
													<td>OPERATORIDCME2</td>
													<td>50</td>
													<td>CAUM9 C0860</td>
													<td>R89</td>
													<td>SELL</td>
													<td>00147</td>
													<td>1332</td>
													<td>1332</td>
												</tr>
												<tr>
													<th scope="row">
														<a href="">ACP15299318869</a>
													</th>
													<td>8446:M:126561</td>
													<td className="text--center">Partial Fill</td>
													<td>08:04:46.900</td>
													<td>OPERATORID123</td>
													<td>100</td>
													<td>CAUM9 C0775</td>
													<td>AZT</td>
													<td>BUY</td>
													<td>00331</td>
													<td>6116</td>
												<td>Day</td>
												</tr>
												<tr>
													<th scope="row">
														<a href="">ACP15524945547</a>
													</th>
													<td>80517:M:301326</td>
													<td className="text--center">Filled</td>
													<td>08:05:12.010</td>
													<td>OPERATORIDCME2</td>
													<td>50</td>
													<td>CAUM9 C0860</td>
													<td>R89</td>
													<td>SELL</td>
													<td>00147</td>
													<td>1332</td>
													<td>1332</td>
												</tr>
												<tr>
													<th scope="row">
														<a href="">ACP15299318869</a>
													</th>
													<td>8446:M:126561</td>
													<td className="text--center">Partial Fill</td>
													<td>08:04:46.900</td>
													<td>OPERATORID123</td>
													<td>100</td>
													<td>CAUM9 C0775</td>
													<td>AZT</td>
													<td>BUY</td>
													<td>00331</td>
													<td>6116</td>
													<td>Day</td>
												</tr>
												<tr>
													<th scope="row">
														<a href="">ACP15524945547</a>
													</th>
													<td>80517:M:301326</td>
													<td className="text--center">Filled</td>
													<td>08:05:12.010</td>
													<td>OPERATORIDCME2</td>
													<td>50</td>
													<td>CAUM9 C0860</td>
													<td>R89</td>
													<td>SELL</td>
													<td>00147</td>
													<td>1332</td>
													<td>1332</td>
												</tr>
												<tr>
													<th scope="row">
														<a href="">ACP15299318869</a>
													</th>
													<td>8446:M:126561</td>
													<td className="text--center">Partial Fill</td>
													<td>08:04:46.900</td>
													<td>OPERATORID123</td>
													<td>100</td>
													<td>CAUM9 C0775</td>
													<td>AZT</td>
													<td>BUY</td>
													<td>00331</td>
													<td>6116</td>
													<td>Day</td>
												</tr>
												<tr>
													<th scope="row">
														<a href="">ACP15524945547</a>
													</th>
													<td>80517:M:301326</td>
													<td className="text--center">Filled</td>
													<td>08:05:12.010</td>
													<td>OPERATORIDCME2</td>
													<td>50</td>
													<td>CAUM9 C0860</td>
													<td>R89</td>
													<td>SELL</td>
													<td>00147</td>
													<td>1332</td>
													<td>1332</td>
												</tr>
												<tr>
													<th scope="row">
														<a href="">ACP15299318869</a>
													</th>
													<td>8446:M:126561</td>
													<td className="text--center">Partial Fill</td>
													<td>08:04:46.900</td>
													<td>OPERATORID123</td>
													<td>100</td>
													<td>CAUM9 C0775</td>
													<td>AZT</td>
													<td>BUY</td>
													<td>00331</td>
													<td>6116</td>
													<td>Day</td>
												</tr>
												<tr>
													<th scope="row">
														<a href="">ACP15524945547</a>
													</th>
													<td>80517:M:301326</td>
													<td className="text--center">Filled</td>
													<td>08:05:12.010</td>
													<td>OPERATORIDCME2</td>
													<td>50</td>
													<td>CAUM9 C0860</td>
													<td>R89</td>
													<td>SELL</td>
													<td>00147</td>
													<td>1332</td>
													<td>1332</td>
												</tr>
												<tr>
													<th scope="row">
														<a href="">ACP15299318869</a>
													</th>
													<td>8446:M:126561</td>
													<td className="text--center">Partial Fill</td>
													<td>08:04:46.900</td>
													<td>OPERATORID123</td>
													<td>100</td>
													<td>CAUM9 C0775</td>
													<td>AZT</td>
													<td>BUY</td>
													<td>00331</td>
													<td>6116</td>
													<td>Day</td>
												</tr>
												<tr>
													<th scope="row">
														<a href="">ACP15524945547</a>
													</th>
													<td>80517:M:301326</td>
													<td className="text--center">Filled</td>
													<td>08:05:12.010</td>
													<td>OPERATORIDCME2</td>
													<td>50</td>
													<td>CAUM9 C0860</td>
													<td>R89</td>
													<td>SELL</td>
													<td>00147</td>
													<td>1332</td>
													<td>1332</td>
												</tr>
												<tr>
													<th scope="row">
														<a href="">ACP15299318869</a>
													</th>
													<td>8446:M:126561</td>
													<td className="text--center">Partial Fill</td>
													<td>08:04:46.900</td>
													<td>OPERATORID123</td>
													<td>100</td>
													<td>CAUM9 C0775</td>
													<td>AZT</td>
													<td>BUY</td>
													<td>00331</td>
													<td>6116</td>
													<td>Day</td>
												</tr>
												<tr>
													<th scope="row">
														<a href="">ACP15524945547</a>
													</th>
													<td>80517:M:301326</td>
													<td className="text--center">Filled</td>
													<td>08:05:12.010</td>
													<td>OPERATORIDCME2</td>
													<td>50</td>
													<td>CAUM9 C0860</td>
													<td>R89</td>
													<td>SELL</td>
													<td>00147</td>
													<td>1332</td>
													<td>1332</td>
												</tr>
											</tbody>
										</table>
										<div class="overlay__table example-overlay-two">
											<div class="overlay__table--left"></div>
											<div class="overlay__table--right table--comfy">
												<div class="overlay__table--title"><i class="fa fa-table" aria-hidden="true"></i>Edit Table Order<i class="icon-cme-close-circle-o overlay__table--close"></i></div>
												<div class="overlay__table--main">
													Customise this table by choosing which columns to display, and in which order
													<ul class="overlay__table--options">
														<li class="options-group-item">
															<i class="fa fa-square-o select-all" aria-hidden="true"></i>
															<label class="overlay__table--select-all select-all">Select All</label>
														</li>
														<li class="options-group-item">
															<button class="btn btn--link reset-to-default"><i class="fa fa-repeat"></i> Reset to Default</button>
														</li>
													</ul>
												</div>
												<div class="overlay__table--actions">
													<button class="btn btn--secondary overlay__table--cancel">Cancel</button>
													<button class="btn btn--positive apply--reorder trigger-two"><i class="fa fa-check"></i> Apply Changes</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<script type="text/javascript" src="js/commonUI.js"></script>
					<script>
						function init() {
							commonUI.initializeTable({
								selector: '.js-table-reorder-two',
								tableReorder: 'js-table-reorder-two',
								overlayElement: '.example-overlay-two',
								trigger: 'trigger-two',
							});
							commonUI.initializeButtonGroup();
							var tableReorderExample = document.getElementsByClassName('js-table-reorder-two')[0];
							tableReorderExample.addEventListener('apply.commonui.reorderTable', function(event) {
								console.log('Saved Table: ', event.detail);
							});
						}
						window.onload = init;
					</script>
				</body>
			</html>`}>
			</iframe>
		</div>
		<br/><br/>
		<button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
		<pre className="hide-code"><code className="language-html">{`
<div class="reorder__table">
	<button class="btn btn--link js-table-overlay-trigger"><i class="fa fa-table"></i> Edit Table Order</button>
	<div class="reorder__table--container">
		<table class="table table--light table--comfy table--hover table--striped table--responsive js-table--responsive js-table-reorder table--reorder">
			<thead>
				<tr>
					<th class="table__heading--disable table--reorder--show-row">Lorem</th>
					<th class="table__heading--disable table--reorder--show-row">Ipsum</th>
					<th class="table--reorder--show-row">Dolor</th>
					<th class="table--reorder--show-row ">Sit</th>
					<th class="table--reorder--show-row">Amet</th>
					<th class="table--reorder--show-row">Consectetur</th>
					<th class="table--reorder--show-row">Afdipisicing</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<th scope="row">
						<a href="">Sit</a>
					</th>
					<td>Dolor</td>
					<td class="text--center">03.788</td>
					<td>Lorem</td>
					<td>Amet</td>
					<td>Consectetur</td>
					<td>Afdipisicing</td>
				</tr>
				<tr>
					<th scope="row">
						<a href="">Sit</a>
					</th>
					<td>Dolor</td>
					<td class="text--center">32.210</td>
					<td>Lorem</td>
					<td>Amet</td>
					<td>Consectetur</td>
					<td>Afdipisicing</td>
				</tr>
				<tr>
					<th scope="row">
						<a href="">Sit</a>
					</th>
					<td>Dolor</td>
					<td class="text--center">47.797</td>
					<td>Lorem</td>
					<td>Amet</td>
					<td>Consectetur</td>
					<td>Afdipisicing</td>
				</tr>
				<tr>
					<th scope="row">
						<a href="">Sit</a>
					</th>
					<td>Dolor</td>
					<td class="text--center">09.640</td>
					<td>Lorem</td>
					<td>Amet</td>
					<td>Consectetur</td>
					<td>Afdipisicing</td>
				</tr>
				<tr>
					<th scope="row">
						<a href="">Sit</a>
					</th>
					<td>Dolor</td>
					<td class="text--center">12.117</td>
					<td>Lorem</td>
					<td>Amet</td>
					<td>Consectetur</td>
					<td>Afdipisicing</td>
				</tr>
				<tr>
					<th scope="row">
						<a href="">Sit</a>
					</th>
					<td>Dolor</td>
					<td class="text--center">12.117</td>
					<td>Lorem</td>
					<td>Amet</td>
					<td>Consectetur</td>
					<td>Afdipisicing</td>
				</tr>
				<tr>
					<th scope="row">
						<a href="">Sit</a>
					</th>
					<td>Dolor</td>
					<td class="text--center">12.117</td>
					<td>Lorem</td>
					<td>Amet</td>
					<td>Consectetur</td>
					<td>Afdipisicing</td>
				</tr>
				<tr>
					<th scope="row">
						<a href="">Sit</a>
					</th>
					<td>Dolor</td>
					<td class="text--center">12.117</td>
					<td>Lorem</td>
					<td>Amet</td>
					<td>Consectetur</td>
					<td>Afdipisicing</td>
				</tr>
				<tr>
					<th scope="row">
						<a href="">Sit</a>
					</th>
					<td>Dolor</td>
					<td class="text--center">12.117</td>
					<td>Lorem</td>
					<td>Amet</td>
					<td>Consectetur</td>
					<td>Afdipisicing</td>
				</tr>
				<tr>
					<th scope="row">
						<a href="">Sit</a>
					</th>
					<td>Dolor</td>
					<td class="text--center">12.117</td>
					<td>Lorem</td>
					<td>Amet</td>
					<td>Consectetur</td>
					<td>Afdipisicing</td>
				</tr>
				<tr>
					<th scope="row">
						<a href="">Sit</a>
					</th>
					<td>Dolor</td>
					<td class="text--center">12.117</td>
					<td>Lorem</td>
					<td>Amet</td>
					<td>Consectetur</td>
					<td>Afdipisicing</td>
				</tr>
				<tr>
					<th scope="row">
						<a href="">Sit</a>
					</th>
					<td>Dolor</td>
					<td class="text--center">12.117</td>
					<td>Lorem</td>
					<td>Amet</td>
					<td>Consectetur</td>
					<td>Afdipisicing</td>
				</tr>
				<tr>
					<th scope="row">
						<a href="">Sit</a>
					</th>
					<td>Dolor</td>
					<td class="text--center">12.117</td>
					<td>Lorem</td>
					<td>Amet</td>
					<td>Consectetur</td>
					<td>Afdipisicing</td>
				</tr>
				<tr>
					<th scope="row">
						<a href="">Sit</a>
					</th>
					<td>Dolor</td>
					<td class="text--center">12.117</td>
					<td>Lorem</td>
					<td>Amet</td>
					<td>Consectetur</td>
					<td>Afdipisicing</td>
				</tr>
			</tbody>
		</table>
		<div class="overlay__table example-overlay">
			<div class="overlay__table--left"></div>
			<div class="overlay__table--right table--comfy">
				<div class="overlay__table--title"><i class="fa fa-table" aria-hidden="true"></i>Edit Table Order<i class="icon-cme-close-circle-o overlay__table--close"></i></div>
				<div class="overlay__table--main">
					Customise this table by choosing which columns to display, and in which order
					<ul class="overlay__table--options">
						<li class="options-group-item">
							<i class="fa fa-square-o select-all" aria-hidden="true"></i>
							<label class="overlay__table--select-all select-all">Select All</label>
						</li>
						<li class="options-group-item">
							<button class="btn btn--link reset-to-default"><i class="fa fa-repeat"></i>Reset to Default</button>
						</li>
					</ul>
				</div>
				<div class="overlay__table--actions">
					<button class="btn btn--secondary overlay__table--cancel">Cancel</button>
					<button class="btn btn--positive apply--reorder trigger-one"><i class="fa fa-check"></i> Apply Changes</button>
				</div>
			</div>
		</div>
	</div>
</div>`}</code></pre>
		<p>To enable this functionality, you can instantiate the table like this:</p>
		<pre><code className="language-javascript">{`commonUI.initializeTable({
	selector: '.js-table-reorder',
	tableReorder: 'js-table-reorder',
	overlayElement: '.example-overlay',
	trigger: 'trigger-one',
});`}</code></pre>
		<p>Subscribe to the apply event where you can get the saved table as below:</p>
		<pre><code className="language-javascript">{`let tableReorderExample = document.getElementsByClassName('js-table-reorder')[0];
tableReorderExample.addEventListener('apply.commonui.reorderTable', function(event) {
	console.log('Saved Table: ', event.detail);
});`}</code></pre>
		<br/>

		<br/>

		<h3>Hit/Lift indicators</h3>
		<p className="callout">
			<strong>Note:</strong> Hit/Lift indicators are a new component. If you are going to use these styles in an app please notify the CommonUI team. This will aid us in monitoring usage, getting feedback, and notifying the correct teams of any changes.
		</p>
		<p>Used to indicate the ability to rapidly respond to a price displayed on our trading interfaces. A buy or a sell will be triggered by clicking on one of these table cells.</p>

		<select className="size-select">
			<option value="">Select a resolution</option>
			<option value="482">480px (xs)</option>
			<option value="770">768px (sm)</option>
			<option value="994">992px (md)</option>
			<option value="1202">1200px (lg)</option>
		</select>
		<br/><br/>

		<div className="iframe-container" style={{ 'height': '100px' }}>
			<iframe seamless srcDoc={`
				<html>
					<head>
						<link rel="stylesheet" type="text/css" href="css/commonUI.css">
					</head>
					<body class="soft">
						<table style="width: auto;" class="table table--cells table--comfy">
							<tbody>
							  <tr>
							    <td tabindex="0" aria-label="Hit" class="hit-lift hit-lift--hit">0.0281923</td>
							    <td tabindex="0" aria-label="Lift" class="hit-lift hit-lift--lift">0.0281923</td>
							  </tr>
							</tbody>
						</table>
					</body>
				</html>
			`}></iframe>
		</div><br/>

		<button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
		<pre className="hide-code"><code className="language-html">{`
<table class="table table--cells table--comfy">
	<tbody>
		<tr>
			<td tabindex="0" aria-label="Hit" class="hit-lift hit-lift--hit">0.0281923</td>
			<td tabindex="0" aria-label="Lift" class="hit-lift hit-lift--lift">0.0281923</td>
		</tr>
	</tbody>
</table>
		`}</code></pre>
		<br/>
		<h3>Inline Alerts</h3>
		<p>The inline alert can be used to overlay a table row to feedback to user any information related to the row.
		For long running pending transactions, you can allow the user to close out the alert and reduce the overlay to a single cell. This cell
		will be the index of the cell on the row you wish to target, you can pass this in as a <code>minimisedCellIndex</code> property.</p>

		<pre><code className="language-javascript">{`commonUI.initializeAlert({
	selector: '.js-inline-alert',
	closeSelector: '.js-inline-alert__close',
	autoCloseTime: null,
	inline: true,
	minimisedCellIndex: 2
});
`}</code></pre><br/>
		<p>Use the following to initialise the pending inline alert: </p>
		<pre><code className="language-javascript">{`commonUI.initializeAlert({
	selector: '.js-inline-alert-pending',
	closeSelector: '.js-inline-alert__close',
	autoCloseTime: null,
	inline: true,
	minimisedCellIndex: 2
});
`}</code></pre><br/>

		<table className="table table--blue table--comfy table--cells table--hover table--striped table--alert">
        	<thead>
				<tr>
					<th>Lorem</th>
					<th>Ipsum</th>
					<th>Dolor</th>
					<th>Sit</th>
				</tr>
			</thead>
        	<tbody>
				<tr>
					<td>Lorem</td>
					<td>Ipsum</td>
					<td>Dolor</td>
					<td>Sit</td>
				</tr>
				<tr>
					<td>Lorem</td>
					<td>Ipsum</td>
					<td>Dolor</td>
					<td>Sit</td>
					<td className="table--alert__overlay alert">EOD cycle is currently running. Your value was not entered. You can submit PCS when the cycle has run.</td>
				</tr>
				<tr>
					<td>Lorem</td>
					<td>Ipsum</td>
					<td>Dolor</td>
					<td>Sit</td>
				</tr>
				<tr>
					<td>Lorem</td>
					<td>Ipsum</td>
					<td>Dolor</td>
					<td>Sit</td>
					<td className="table--alert__overlay table--alert__overlay--warning alert alert--warning">
						<div className="alert__icon alert__icon--block">
    						<i className="fa fa-exclamation-circle icon--medium" aria-hidden="true"></i>
  						</div>
						<div className="alert__heading">
							EOD cycle is currently running. Your value was not entered. You can submit PCS when the cycle has run.
						</div>
					</td>
				</tr>
				<tr>
					<td>Lorem</td>
					<td>Ipsum</td>
					<td>Dolor</td>
					<td>Sit</td>
				</tr>
				<tr>
					<td>Lorem</td>
					<td>Ipsum</td>
					<td>Dolor</td>
					<td>Sit</td>
					<td className="table--alert__overlay table--alert__overlay--success alert alert--success alert--minimal alert--outline hard">
						<div className="alert__icon">
    						<i className="fa fa-check icon--medium" aria-hidden="true"></i>
  						</div>
						<div className="alert__message">
							PCS Entry successfully submitted
						</div>
					</td>
				</tr>
				<tr>
					<td>Lorem</td>
					<td>Ipsum</td>
					<td>Dolor</td>
					<td>Sit</td>
				</tr>
				<tr>
					<td>Lorem</td>
					<td>Ipsum</td>
					<td>Dolor</td>
					<td>Sit</td>
					<td className="table--alert__overlay table--alert__overlay--error alert alert--error alert--minimal alert--outline hard">
						<div className="alert__icon">
    						<i className="fa fa-ban icon--medium" aria-hidden="true"></i>
  						</div>
						<div className="alert__message">
							PCS Entry failed
						</div>
					</td>
				</tr>
				<tr>
					<td>Lorem</td>
					<td>Ipsum</td>
					<td>Dolor</td>
					<td>Sit</td>
				</tr>
				<tr className="js-inline-alert">
					<td>Lorem</td>
					<td>Ipsum</td>
					<td>Dolor</td>
					<td>Sit</td>
					<td className="table--alert__overlay table--alert__overlay--warning table--alert__overlay alert alert--warning js-alert-overlay">
						<div className="alert__icon alert__icon--block">
    						<i className="fa fa-exclamation-circle icon--medium" aria-hidden="true"></i>
  						</div>
						<div className="alert__heading">
							Dismissable Info inline alert
						</div>
						<button className="alert__close btn btn--transparent js-inline-alert__close hard push-half" aria-label="close">
							<i className="alert__close__icon fa fa-remove" aria-hidden="true"></i>
						</button>
					</td>
				</tr>
				<tr>
					<td>Lorem</td>
					<td>Ipsum</td>
					<td>Dolor</td>
					<td>Sit</td>
				</tr>
				<tr className="js-inline-alert-pending">
					<td>Lorem</td>
					<td>Ipsum</td>
					<td>Dolor</td>
					<td>Sit</td>
					<td className="table--alert__overlay table--alert__overlay--pending table--alert__overlay alert alert--pending js-alert-overlay js-pending-alert">
						<div className="alert__icon alert__icon--block">
							<div className="loader-overlay">
								<div className="loader-wrapper">
									<div className="loader"></div>
								</div>
							</div>
  						</div>
						<div className="alert__heading">
							Your PCS entry has been submitted. Pending confirmation.
						</div>
						<button className="alert__close btn btn--transparent js-inline-alert__close hard push-half" aria-label="close">
							<i className="alert__close__icon fa fa-remove" aria-hidden="true"></i>
						</button>
					</td>
				</tr>
				<tr>
					<td>Lorem</td>
					<td>Ipsum</td>
					<td>Dolor</td>
					<td>Sit</td>
				</tr>
			</tbody>

      	</table>

		<br/>

		<p>The responsive treatment for this will take the form of the split table, and the alert(s) will scroll with the right table. </p>

		<select className="size-select">
			<option value="">Select a resolution</option>
			<option value="482">480px (xs)</option>
			<option value="770">768px (sm)</option>
			<option value="994">992px (md)</option>
			<option value="1202">1200px (lg)</option>
		</select>
		<br/><br/>

		<div className="iframe-container" style={{ 'height': '400px' }}>
			<iframe seamless srcDoc={`
				<html>
					<head>
						<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
						<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
						<link rel="stylesheet" type="text/css" href="css/commonUI.css">
					</head>
					<body>
					<table class="table table--blue table--comfy table--cells table--hover table--striped table--alert table--responsive js-table--responsive">
						<thead>
							<tr>
								<th>Lorem</th>
								<th>Ipsum</th>
								<th>Dolor</th>
								<th>Sit</th>
								<th>Lorem</th>
								<th>Ipsum</th>
								<th>Dolor</th>
								<th>Sit</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Lorem</td>
								<td>Ipsum</td>
								<td>Dolor</td>
								<td>Sit</td>
								<td>Lorem</td>
								<td>Ipsum</td>
								<td>Dolor</td>
								<td>Sit</td>
							</tr>
							<tr>
								<td>Lorem</td>
								<td>Ipsum</td>
								<td>Dolor</td>
								<td>Sit</td>
								<td>Lorem</td>
								<td>Ipsum</td>
								<td>Dolor</td>
								<td>Sit</td>
							</tr>
							<tr>
								<td>Lorem</td>
								<td>Ipsum</td>
								<td>Dolor</td>
								<td>Sit</td>
								<td>Lorem</td>
								<td>Ipsum</td>
								<td>Dolor</td>
								<td>Sit</td>
							</tr>
							<tr>
								<td>Lorem</td>
								<td>Ipsum</td>
								<td>Dolor</td>
								<td>Sit</td>
								<td>Lorem</td>
								<td>Ipsum</td>
								<td>Dolor</td>
								<td>Sit</td>
							</tr>
							<tr class="js-inline-alert">
								<td>Lorem</td>
								<td>Ipsum</td>
								<td>Dolor</td>
								<td>Sit</td>
								<td>Lorem</td>
								<td>Ipsum</td>
								<td>Dolor</td>
								<td>Sit</td>
								<td class="table--alert__overlay table--alert__overlay--pending table--alert__overlay alert alert--pending js-alert-overlay js-pending-alert">
									<div class="alert__icon alert__icon--block">
										<div class="loader-overlay">
											<div class="loader-wrapper">
												<div class="loader"></div>
											</div>
										</div>
									</div>
									<div class="alert__heading">
										Your PCS entry has been submitted. Pending confirmation.
									</div>
									<button class="alert__close btn btn--transparent js-inline-alert__close hard push-half" aria-label="close">
										<i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
									</button>
								</td>
							</tr>
							<tr>
								<td>Lorem</td>
								<td>Ipsum</td>
								<td>Dolor</td>
								<td>Sit</td>
								<td>Lorem</td>
								<td>Ipsum</td>
								<td>Dolor</td>
								<td>Sit</td>
							</tr>
							<tr>
								<td>Lorem</td>
								<td>Ipsum</td>
								<td>Dolor</td>
								<td>Sit</td>
								<td>Lorem</td>
								<td>Ipsum</td>
								<td>Dolor</td>
								<td>Sit</td>
							</tr>
							<tr>
								<td>Lorem</td>
								<td>Ipsum</td>
								<td>Dolor</td>
								<td>Sit</td>
								<td>Lorem</td>
								<td>Ipsum</td>
								<td>Dolor</td>
								<td>Sit</td>
							</tr>
							<tr>
								<td>Lorem</td>
								<td>Ipsum</td>
								<td>Dolor</td>
								<td>Sit</td>
								<td>Lorem</td>
								<td>Ipsum</td>
								<td>Dolor</td>
								<td>Sit</td>
							</tr>
						</tbody>
					</table>
					</body>
					<script type="text/javascript" src="js/commonUI.js"></script>
					<script>
						function init() {
							commonUI.initializeTable();
							commonUI.initializeAlert({
								selector: '.js-inline-alert',
								closeSelector: '.js-inline-alert__close',
								autoCloseTime: null,
								inline: true,
								minimisedCellIndex: 4
							});
						}
						window.onload = init;
					</script>
				</html>
			`}></iframe>
		</div><br/>

		<p>The inline alerts also inherit events or classes from normal alerts - you can refer to the documentation for those, <a href="#alerts">here</a>.
		You can also use the Common UI <a href="#helpers">helpers</a> to show and hide the inline alert.</p>

		<button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
		<pre className="hide-code"><code className="language-html">{`<table class="table table--blue table--comfy table--cells table--hover table--striped table--alert">
	<thead>
		<tr>
			<th>Lorem</th>
			<th>Ipsum</th>
			<th>Dolor</th>
			<th>Sit</th>
		</tr>
	</thead>
	<tbody>
		<tr>
			<td>Lorem</td>
			<td>Ipsum</td>
			<td>Dolor</td>
			<td>Sit</td>
		</tr>
		<tr>
			<td>Lorem</td>
			<td>Ipsum</td>
			<td>Dolor</td>
			<td>Sit</td>
			<td class="table--alert__overlay alert">EOD cycle is currently running. Your value was not entered. You can submit PCS when the cycle has run.</td>
		</tr>
		<tr>
			<td>Lorem</td>
			<td>Ipsum</td>
			<td>Dolor</td>
			<td>Sit</td>
		</tr>
		<tr>
			<td>Lorem</td>
			<td>Ipsum</td>
			<td>Dolor</td>
			<td>Sit</td>
			<td class="table--alert__overlay table--alert__overlay--warning alert alert--warning">
				<div class="alert__icon alert__icon--block">
					<i class="fa fa-exclamation-circle icon--medium" aria-hidden="true"></i>
				</div>
				<div class="alert__heading">
					EOD cycle is currently running. Your value was not entered. You can submit PCS when the cycle has run.
				</div>
			</td>
		</tr>
		<tr>
			<td>Lorem</td>
			<td>Ipsum</td>
			<td>Dolor</td>
			<td>Sit</td>
		</tr>
		<tr>
			<td>Lorem</td>
			<td>Ipsum</td>
			<td>Dolor</td>
			<td>Sit</td>
			<td class="table--alert__overlay table--alert__overlay--success alert alert--success alert--minimal alert--outline hard">
				<div class="alert__icon">
					<i class="fa fa-check icon--medium" aria-hidden="true"></i>
				</div>
				<div class="alert__message">
					PCS Entry successfully submitted
				</div>
			</td>
		</tr>
		<tr>
			<td>Lorem</td>
			<td>Ipsum</td>
			<td>Dolor</td>
			<td>Sit</td>
		</tr>
		<tr>
			<td>Lorem</td>
			<td>Ipsum</td>
			<td>Dolor</td>
			<td>Sit</td>
			<td class="table--alert__overlay table--alert__overlay--error alert alert--error alert--minimal alert--outline hard">
				<div class="alert__icon">
					<i class="fa fa-ban icon--medium" aria-hidden="true"></i>
				</div>
				<div class="alert__message">
					PCS Entry failed
				</div>
			</td>
		</tr>
		<tr>
			<td>Lorem</td>
			<td>Ipsum</td>
			<td>Dolor</td>
			<td>Sit</td>
		</tr>
		<tr class="js-inline-alert is-closeable">
			<td>Lorem</td>
			<td>Ipsum</td>
			<td>Dolor</td>
			<td>Sit</td>
			<td class="table--alert__overlay table--alert__overlay--warning table--alert__overlay alert alert--warning js-alert-overlay">
				<div class="alert__icon alert__icon--block">
					<i class="fa fa-exclamation-circle icon--medium" aria-hidden="true"></i>
				</div>
				<div class="alert__heading">
					Dismissable Info inline alert
				</div>
				<button class="alert__close btn btn--transparent js-inline-alert__close hard push-half" aria-label="close">
					<i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
				</button>
			</td>
		</tr>
		<tr>
			<td>Lorem</td>
			<td>Ipsum</td>
			<td>Dolor</td>
			<td>Sit</td>
		</tr>
		<tr class="js-inline-alert-pending is-closeable">
			<td>Lorem</td>
			<td>Ipsum</td>
			<td>Dolor</td>
			<td>Sit</td>
			<td class="table--alert__overlay table--alert__overlay--pending table--alert__overlay alert alert--pending js-alert-overlay js-pending-alert">
				<div class="alert__icon alert__icon--block">
					<div class="loader-overlay">
						<div class="loader-wrapper">
							<div class="loader"></div>
						</div>
					</div>
				</div>
				<div class="alert__heading">
					Your PCS entry has been submitted. Pending confirmation.
				</div>
				<button class="alert__close btn btn--transparent js-inline-alert__close hard push-half" aria-label="close">
					<i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>
				</button>
			</td>
		</tr>
		<tr>
			<td>Lorem</td>
			<td>Ipsum</td>
			<td>Dolor</td>
			<td>Sit</td>
		</tr>
	</tbody>
</table>`}</code></pre>
<br/>
		<h4>Inline Editing</h4>
		<p>The inline editing can be used within a table cell to edit the data that currently resides withing that row.</p>
		<p>To enable the Inline Editing functionality add the <code>inline--edit</code> class to the cells or link that require the edit.</p>
		<p>To enable the required field validation, add the <code>required</code> class to the cells or link that are required.</p>
		<p>If the table has not already been initialised, initialise it with a special class:</p>
		<pre><code className="language-javascript">{`commonUI.initializeTable({
  selector: '.edit-table'
});`}</code></pre>
<br/>
		<div className="scroll-container-x">
		<table className="table table--blue table--comfy table--rows table--hover table--striped text-scale-xs flush--bottom table--responsive js-table--responsive table--inline-edit">
			<thead>
				<tr>
					<th>Product</th>
					<th>Code</th>
					<th>Last</th>
					<th>Change</th>
					<th>Chart</th>
					<th>Open</th>
					<th>High</th>
					<th>Low</th>
					<th>Globex Vol</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td className="inline--edit-border"><a className="weight--bold" href="#">Corn Futures</a></td>
					<td className="text--center inline--edit required">ZCH7</td>
					<td className="text--right inline--edit">369'0</td>
					<td className="text--right inline--edit">+1'0</td>
					<td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
					<td className="text--right inline--edit">367'4</td>
					<td className="text--right inline--edit">367'4</td>
					<td className="text--right inline--edit">367'4</td>
					<td className="text--right inline--edit">68,284</td>
				</tr>
				<tr>
					<td><a className="weight--bold" href="#">Soybean Futures</a></td>
					<td className="text--center inline--edit required">ZCH7</td>
					<td className="text--right inline--edit">1036'4</td>
					<td className="text--right inline--edit">+1'0</td>
					<td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
					<td className="text--right inline--edit">1037'2</td>
					<td className="text--right inline--edit">1037'2</td>
					<td className="text--right inline--edit">1037'2</td>
					<td className="text--right inline--edit">48,346</td>
				</tr>
				<tr>
					<td><a className="weight--bold" href="#">Soybean Oil Futures</a></td>
					<td className="text--center">ZCH7</td>
					<td className="text--right">34.29</td>
					<td className="text--right">+0.02</td>
					<td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
					<td className="text--right">34.31</td>
					<td className="text--right">34.31</td>
					<td className="text--right">34.31</td>
					<td className="text--right">23,054</td>
				</tr>
			</tbody>
		</table>
		</div>
		<hr/>
		<button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
		<pre className="hide-code"><code className="language-html">{`<table class="table table--blue table--comfy table--rows table--hover table--striped text-scale-xs flush--bottom table--responsive js-table--responsive table--inline-edit">
	<thead>
		<tr>
			<th>Product</th>
			<th>Code</th>
			<th>Last</th>
			<th>Change</th>
			<th>Chart</th>
			<th>Open</th>
			<th>High</th>
			<th>Low</th>
			<th>Globex Vol</th>
		</tr>
	</thead>
	<tbody>
		<tr>
			<td class="inline--edit-border"><a class="weight--bold" href="#">Corn Futures</a></td>
			<td class="text--center inline--edit required">ZCH7</td>
			<td class="text--right inline--edit">369'0</td>
			<td class="text--right inline--edit">+1'0</td>
			<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>
			<td class="text--right inline--edit">367'4</td>
			<td class="text--right inline--edit">367'4</td>
			<td class="text--right inline--edit">367'4</td>
			<td class="text--right inline--edit">68,284</td>
		</tr>
		<tr>
			<td><a class="weight--bold" href="#">Soybean Futures</a></td>
			<td class="text--center inline--edit required">ZCH7</td>
			<td class="text--right inline--edit">1036'4</td>
			<td class="text--right inline--edit">+1'0</td>
			<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>
			<td class="text--right inline--edit">1037'2</td>
			<td class="text--right inline--edit">1037'2</td>
			<td class="text--right inline--edit">1037'2</td>
			<td class="text--right inline--edit">48,346</td>
		</tr>
		<tr>
			<td><a class="weight--bold" href="#">Soybean Oil Futures</a></td>
			<td class="text--center">ZCH7</td>
			<td class="text--right">34.29</td>
			<td class="text--right">+0.02</td>
			<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>
			<td class="text--right">34.31</td>
			<td class="text--right">34.31</td>
			<td class="text--right">34.31</td>
			<td class="text--right">23,054</td>
		</tr>
	</tbody>
</table>`}</code></pre>
<br/>
<p>To enable the a border on the link inline edit, add the <code>inline--edit-border</code> class to the cells that require the border.</p>
<p>To set the width of the inline edit cell apply <code>inline--edit-width</code>. Add the following CSS using your own set width.</p>

          <pre><code className="language-css">{`.inline--edit-width {
  width: INSERT-WIDTH-HERE;
}`}</code></pre>

		  <br/>
<table className="table table--blue table--comfy table--rows table--hover table--striped text-scale-xs flush--bottom table--responsive js-table--responsive table--inline-edit">
			<thead>
				<tr>
					<th className="inline--edit-width">Product</th>
					<th>Code</th>
					<th>Last</th>
					<th>Change</th>
					<th>Chart</th>
					<th>Open</th>
					<th>High</th>
					<th>Low</th>
					<th>Globex Vol</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td className="inline--edit-border inline--edit-width"><a className="weight--bold inline--edit required" href="#">Corn Futures</a></td>
					<td className="text--center">ZCH7</td>
					<td className="text--right">369'0</td>
					<td className="text--right">+1'0</td>
					<td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
					<td className="text--right">367'4</td>
					<td className="text--right">367'4</td>
					<td className="text--right">367'4</td>
					<td className="text--right">68,284</td>
				</tr>
				<tr>
					<td className="inline--edit-width"><a className="weight--bold inline--edit" href="#">Soybean Futures</a></td>
					<td className="text--center">ZCH7</td>
					<td className="text--right">1036'4</td>
					<td className="text--right">+1'0</td>
					<td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
					<td className="text--right">1037'2</td>
					<td className="text--right">1037'2</td>
					<td className="text--right">1037'2</td>
					<td className="text--right">48,346</td>
				</tr>
				<tr>
					<td className="inline--edit-width"><a className="weight--bold" href="#">Soybean Oil Futures</a></td>
					<td className="text--center">ZCH7</td>
					<td className="text--right">34.29</td>
					<td className="text--right">+0.02</td>
					<td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
					<td className="text--right">34.31</td>
					<td className="text--right">34.31</td>
					<td className="text--right">34.31</td>
					<td className="text--right">23,054</td>
				</tr>
			</tbody>
		</table>
		<hr/>
		<button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
		<pre className="hide-code"><code className="language-html">{`<table class="table table--blue table--comfy table--rows table--hover table--striped text-scale-xs flush--bottom table--responsive js-table--responsive table--inline-edit">
	<thead>
		<tr>
			<th class="inline--edit-width">Product</th>
			<th>Code</th>
			<th>Last</th>
			<th>Change</th>
			<th>Chart</th>
			<th>Open</th>
			<th>High</th>
			<th>Low</th>
			<th>Globex Vol</th>
		</tr>
	</thead>
	<tbody>
		<tr>
			<td class="inline--edit-border inline--edit-width"><a class="weight--bold inline--edit required" href="#">Corn Futures</a></td>
			<td class="text--center">ZCH7</td>
			<td class="text--right">369'0</td>
			<td class="text--right">+1'0</td>
			<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>
			<td class="text--right">367'4</td>
			<td class="text--right">367'4</td>
			<td class="text--right">367'4</td>
			<td class="text--right">68,284</td>
		</tr>
		<tr>
			<td class="inline--edit-width"><a class="weight--bold inline--edit" href="#">Soybean Futures</a></td>
			<td class="text--center">ZCH7</td>
			<td class="text--right">1036'4</td>
			<td class="text--right">+1'0</td>
			<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>
			<td class="text--right">1037'2</td>
			<td class="text--right">1037'2</td>
			<td class="text--right">1037'2</td>
			<td class="text--right">48,346</td>
		</tr>
		<tr>
			<td class="inline--edit-width"><a class="weight--bold" href="#">Soybean Oil Futures</a></td>
			<td class="text--center">ZCH7</td>
			<td class="text--right">34.29</td>
			<td class="text--right">+0.02</td>
			<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>
			<td class="text--right">34.31</td>
			<td class="text--right">34.31</td>
			<td class="text--right">34.31</td>
			<td class="text--right">23,054</td>
		</tr>
	</tbody>
</table>`}</code></pre>
<br/>
<p>Below is an example of inline edit working in Cards: </p>
<div className="grid">
    <div className="grid__col-xlg-4 grid__col-lg-4 grid__col-md-6 grid__col-sm-12">
        <div className="card">
            <div className="scroll-container-x">
                <table className="table table--comfy table--hover table--striped table--blue table--inline-edit sample-edit">
                    <thead>
                        <tr>
                            <th>
                                <button type="button" className="table-sort">Product</button>
                            </th>
                            <th>
                                <button type="button" className="table-sort">Code</button>
                            </th>
                            <th>Last</th>
                            <th>
                                <button type="button" className="table-sort table-sort--asc">Change</button>
                            </th>
                            <th>Chart</th>
                            <th>Open</th>
                            <th>
                                <button type="button" className="table-sort table-sort--desc">High</button>
                            </th>
                            <th>Low</th>
                            <th>Globex Vol</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="inline--edit-border inline--edit-width"><a className="weight--bold inline--edit"
                                    href="#">Corn Futures</a></td>
                            <td className="text--center inline--edit">ZCH7</td>
                            <td className="text--right inline--edit">369'0</td>
                            <td className="text--right inline--edit">+1'0</td>
                            <td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
                            <td className="text--right inline--edit">367'4</td>
                            <td className="text--right inline--edit">367'4</td>
                            <td className="text--right inline--edit">367'4</td>
                            <td className="text--right inline--edit">68,284</td>
                        </tr>
                        <tr>
                            <td className="inline--edit-width"><a className="weight--bold inline--edit" href="#">Soybean
                                    Futures</a></td>
                            <td className="text--center inline--edit">ZCH7</td>
                            <td className="text--right inline--edit">1036'4</td>
                            <td className="text--right inline--edit">+1'0</td>
                            <td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
                            <td className="text--right inline--edit">1037'2</td>
                            <td className="text--right inline--edit">1037'2</td>
                            <td className="text--right inline--edit">1037'2</td>
                            <td className="text--right inline--edit">48,346</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div className="grid__col-xlg-4 grid__col-lg-4 grid__col-md-6 grid__col-sm-12">
        <div className="card">
            <div className="scroll-container-x">
                <table className="table table--comfy table--hover table--striped table--blue table--inline-edit sample-edit">
                    <thead>
                        <tr>
                            <th>
                                <button type="button" className="table-sort">Product</button>
                            </th>
                            <th>
                                <button type="button" className="table-sort">Code</button>
                            </th>
                            <th>Last</th>
                            <th>
                                <button type="button" className="table-sort table-sort--asc">Change</button>
                            </th>
                            <th>Chart</th>
                            <th>Open</th>
                            <th>
                                <button type="button" className="table-sort table-sort--desc">High</button>
                            </th>
                            <th>Low</th>
                            <th>Globex Vol</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="inline--edit-border inline--edit-width"><a className="weight--bold inline--edit"
                                    href="#">Corn Futures</a></td>
                            <td className="text--center inline--edit">ZCH7</td>
                            <td className="text--right inline--edit">369'0</td>
                            <td className="text--right inline--edit">+1'0</td>
                            <td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
                            <td className="text--right inline--edit">367'4</td>
                            <td className="text--right inline--edit">367'4</td>
                            <td className="text--right inline--edit">367'4</td>
                            <td className="text--right inline--edit">68,284</td>
                        </tr>
                        <tr>
                            <td className="inline--edit-width"><a className="weight--bold inline--edit" href="#">Soybean
                                    Futures</a></td>
                            <td className="text--center inline--edit">ZCH7</td>
                            <td className="text--right inline--edit">1036'4</td>
                            <td className="text--right inline--edit">+1'0</td>
                            <td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
                            <td className="text--right inline--edit">1037'2</td>
                            <td className="text--right inline--edit">1037'2</td>
                            <td className="text--right inline--edit">1037'2</td>
                            <td className="text--right inline--edit">48,346</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div className="grid__col-xlg-4 grid__col-lg-4 grid__col-md-6 grid__col-sm-12">
        <div className="card">
            <div className="scroll-container-x">
                <table className="table table--comfy table--hover table--striped table--blue table--inline-edit sample-edit">
                    <thead>
                        <tr>
                            <th>
                                <button type="button" className="table-sort">Product</button>
                            </th>
                            <th>
                                <button type="button" className="table-sort">Code</button>
                            </th>
                            <th>Last</th>
                            <th>
                                <button type="button" className="table-sort table-sort--asc">Change</button>
                            </th>
                            <th>Chart</th>
                            <th>Open</th>
                            <th>
                                <button type="button" className="table-sort table-sort--desc">High</button>
                            </th>
                            <th>Low</th>
                            <th>Globex Vol</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="inline--edit-border inline--edit-width"><a className="weight--bold inline--edit"
                                    href="#">Corn Futures</a></td>
                            <td className="text--center inline--edit">ZCH7</td>
                            <td className="text--right inline--edit">369'0</td>
                            <td className="text--right inline--edit">+1'0</td>
                            <td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
                            <td className="text--right inline--edit">367'4</td>
                            <td className="text--right inline--edit">367'4</td>
                            <td className="text--right inline--edit">367'4</td>
                            <td className="text--right inline--edit">68,284</td>
                        </tr>
                        <tr>
                            <td className="inline--edit-width"><a className="weight--bold inline--edit" href="#">Soybean
                                    Futures</a></td>
                            <td className="text--center inline--edit">ZCH7</td>
                            <td className="text--right inline--edit">1036'4</td>
                            <td className="text--right inline--edit">+1'0</td>
                            <td className="text--center"><a href="#"><i className="fa fa-bar-chart"></i></a></td>
                            <td className="text--right inline--edit">1037'2</td>
                            <td className="text--right inline--edit">1037'2</td>
                            <td className="text--right inline--edit">1037'2</td>
                            <td className="text--right inline--edit">48,346</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
		<pre className="hide-code"><code className="language-html">{`<div class="grid">
	<div class="grid__col-xlg-3 grid__col-lg-3 grid__col-md-3 grid__col-sm-12">
		<div class="card">
			<div class="scroll-container-x">
				<table class="table table--comfy table--hover table--striped table--blue table--inline-edit">
					<thead>
						<tr>
							<th>
								<button type="button" class="table-sort">Product</button>
							</th>
							<th>
								<button type="button" class="table-sort">Code</button>
							</th>
							<th>Last</th>
							<th>
								<button type="button" class="table-sort table-sort--asc">Change</button>
							</th>
							<th>Chart</th>
							<th>Open</th>
							<th>
								<button type="button" class="table-sort table-sort--desc">High</button>
							</th>
							<th>Low</th>
							<th>Globex Vol</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td class="inline--edit-border inline--edit-width"><a class="weight--bold inline--edit required"
									href="#">Corn Futures</a></td>
							<td class="text--center inline--edit">ZCH7</td>
							<td class="text--right inline--edit">369'0</td>
							<td class="text--right">+1'0</td>
							<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>
							<td class="text--right">367'4</td>
							<td class="text--right">367'4</td>
							<td class="text--right">367'4</td>
							<td class="text--right">68,284</td>
						</tr>
						<tr>
							<td class="inline--edit-width"><a class="weight--bold inline--edit" href="#">Soybean
									Futures</a></td>
							<td class="text--center">ZCH7</td>
							<td class="text--right">1036'4</td>
							<td class="text--right">+1'0</td>
							<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>
							<td class="text--right">1037'2</td>
							<td class="text--right">1037'2</td>
							<td class="text--right">1037'2</td>
							<td class="text--right">48,346</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
	<div class="grid__col-xlg-3 grid__col-lg-3 grid__col-md-3 grid__col-sm-12">
		<div class="card">
			<div class="scroll-container-x">
				<table class="table table--comfy table--hover table--striped table--blue table--inline-edit">
					<thead>
						<tr>
							<th>
								<button type="button" class="table-sort">Product</button>
							</th>
							<th>
								<button type="button" class="table-sort">Code</button>
							</th>
							<th>Last</th>
							<th>
								<button type="button" class="table-sort table-sort--asc">Change</button>
							</th>
							<th>Chart</th>
							<th>Open</th>
							<th>
								<button type="button" class="table-sort table-sort--desc">High</button>
							</th>
							<th>Low</th>
							<th>Globex Vol</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td class="inline--edit-border inline--edit-width"><a class="weight--bold inline--edit required"
									href="#">Corn Futures</a></td>
							<td class="text--center inline--edit">ZCH7</td>
							<td class="text--right inline--edit">369'0</td>
							<td class="text--right">+1'0</td>
							<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>
							<td class="text--right">367'4</td>
							<td class="text--right">367'4</td>
							<td class="text--right">367'4</td>
							<td class="text--right">68,284</td>
						</tr>
						<tr>
							<td class="inline--edit-width"><a class="weight--bold inline--edit" href="#">Soybean
									Futures</a></td>
							<td class="text--center">ZCH7</td>
							<td class="text--right">1036'4</td>
							<td class="text--right">+1'0</td>
							<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>
							<td class="text--right">1037'2</td>
							<td class="text--right">1037'2</td>
							<td class="text--right">1037'2</td>
							<td class="text--right">48,346</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
	<div class="grid__col-xlg-3 grid__col-lg-3 grid__col-md-3 grid__col-sm-12">
		<div class="card">
			<div class="scroll-container-x">
				<table class="table table--comfy table--hover table--striped table--blue table--inline-edit">
					<thead>
						<tr>
							<th>
								<button type="button" class="table-sort">Product</button>
							</th>
							<th>
								<button type="button" class="table-sort">Code</button>
							</th>
							<th>Last</th>
							<th>
								<button type="button" class="table-sort table-sort--asc">Change</button>
							</th>
							<th>Chart</th>
							<th>Open</th>
							<th>
								<button type="button" class="table-sort table-sort--desc">High</button>
							</th>
							<th>Low</th>
							<th>Globex Vol</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td class="inline--edit-border inline--edit-width"><a class="weight--bold inline--edit required"
									href="#">Corn Futures</a></td>
							<td class="text--center inline--edit">ZCH7</td>
							<td class="text--right inline--edit">369'0</td>
							<td class="text--right">+1'0</td>
							<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>
							<td class="text--right">367'4</td>
							<td class="text--right">367'4</td>
							<td class="text--right">367'4</td>
							<td class="text--right">68,284</td>
						</tr>
						<tr>
							<td class="inline--edit-width"><a class="weight--bold inline--edit" href="#">Soybean
									Futures</a></td>
							<td class="text--center">ZCH7</td>
							<td class="text--right">1036'4</td>
							<td class="text--right">+1'0</td>
							<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>
							<td class="text--right">1037'2</td>
							<td class="text--right">1037'2</td>
							<td class="text--right">1037'2</td>
							<td class="text--right">48,346</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</div>`}</code></pre>
<br/>
		</section>
	);
}
}

export default Tables;



// WEBPACK FOOTER //
// ./styleguide/components/sections/Tables.js